export default function() {

vx = Object.assign(vx,
      {oic:{}, page_size:24, av_sync_limits:{},
       st_always_show_me: true, st_always_hear_me: false,
       monitor_delay: 2000, rewind_delta:0,
       st_unmute: vx.about.unmute, vbuf1_cnt:1, vbuf2_cnt:1, adj_cnt:0,
      });

function dohide(nm) {
  if (!vx || !vx.room) { return false; }
  if (!vx.room.hide) { return false; }
  if (!vx.room.hide.includes(nm)) { return false; }
  return true;
}

function wallFastRefresh() {
  vx.sw_is_portrait = vx_is_portrait();
  /* room_configure_layout: portrait/landscape changes */
  room_configure_layout("wallFastRefresh", vx.room.state.pl, vx.room.state.al);
  let layout = vx.layouts[vx.st_layout];
  delete layout.focus_uid;
  vx.wall_info_nxt = get_cached_vp(layout.ly, vx.sw_is_portrait);

  /* e.g. auto profile overrides limit */
  vx.wall_info_nxt.limit = vx.wall_info_nxt.video_cnt;
  if (layout.limit > vx.wall_info_nxt.limit) {
    vx.wall_info_nxt.limit = layout.limit;
  }
  if (layout.acnt > vx.wall_info_nxt.limit) {
    vx.wall_info_nxt.limit = layout.acnt;
  }

  if (layout.cfg_focus_uid) {
    /* Override the actual layout if and only if focus_uid user exists */
    vx.cs_all.forEach(function(ct) {
      if (ct.userid == layout.cfg_focus_uid) {
        let nxt = get_cached_vp("1x1_256", vx.sw_is_portrait);
        nxt.limit = vx.wall_info_nxt.limit;
        vx.wall_info_nxt = nxt;
        layout.focus_uid = layout.cfg_focus_uid;
      }
    });
  }

  if (vx && vx.debug) { console.log("wallFastRefresh "+layout.ly+" "+vx.wall_info_nxt.limit); }
}

window.generate_layouts("room_wall");

function get_cs_stats(tilecnt, is_aud) {
  let max_slots = 0;
  let lg_ok = true; /* All visible hass PT or LG */
  let lg_needed = false; /* 1 or more has SM but not PT */
  let aonly = true;

  if (vx.sw_1on1 && vx.sw_1on1.state == "accepted") {
    return [2, false, false];
  }

  if (vx.cs_all && vx.cs_all.length) {
    // /* Reserve a spot for the presenter */
    // if (!is_aud && vx.room.ephidx == 0 && !vx.room.adhoc &&
    //    !vx.cs_all[0].pres) { max_slots++; }
    vx.cs_all.forEach(function(ct) {
      if (ct.vt && (ct.vt.sm || ct.vt.pt)) {
        aonly = false;
      }
      if (!is_aud) {
        /* Presenter-only mode: count only presenters
         * else: ignore voice-only moderators */
        if ((vx.room.prsonly && ct.pres) || (!vx.room.prsonly && !ct.mod)) {
          max_slots++;
        }
      } else {
        if (/*ct.pres || */ct.mod) {
          /* Audience view: Ignore pres and moderators */
        } else {
          max_slots++;
        }
      }
      if (max_slots <= tilecnt) {
        /* Could show */
        if (ct.vt && ct.vt.sm && !ct.vt.lg) {
          lg_ok = false;
        }
        if (ct.vt && ct.vt.sm && !ct.vt.pt) {
          lg_needed = true;
        }
      }
    });
  }
  if (vx && vx.debug) { console.log("CSSTAT:",max_slots,lg_ok,lg_needed,aonly); }
  return [max_slots, false, aonly];
}

function room_configure_layout(msg, pnm, anm) {
  let device = window.vx_get_mydevice();
  /* All known layouts here */
  vx.layout_cfg = {
    "4x3a"  : {tcnt:0, fn:svg_layout_av, nm:"4x3a",
               c:[{ly:"4x3_256"}]
              },
    "4x4a"  : {tcnt:0, fn:svg_layout_av, nm:"4x4a",
               c:[{ly:"4x4_256"}]
              },
    "7x7a"  : {tcnt:0, fn:svg_layout_av, nm:"7x7a",
               c:[{huge:true,ly:"7x7_256"},{ly:"4x4_256"}]
              },
    "10x10a": {tcnt:0, fn:svg_layout_av, nm:"10x10a",
               c:[{huge:true,ly:"10x10_256"},{ly:"4x4_256"}]
              },

    "1x1p5"  : {tcnt:1, acnt:1, fn:svg_layout_hv, nm:"1x1p5",
                c:[{ly:"1x1_256"}],
               },
    "2x1p5"  : {tcnt:2, acnt:2, fn:svg_layout_hv, nm:"2x1p5",
                c:[{ly:"2x1_256"}],
               },
    "2x2p5"  : {tcnt:4, acnt:4, fn:svg_layout_hv, nm:"2x2p5",
                c:[{ly:"2x2_256"}],
               },
    "3x2p5"  : {tcnt:0, acnt:6, fn:svg_layout_hv, nm:"3x2p5",
                c:[{ly:"3x2_256"}]
               },
    "3x3p5"  : {tcnt:0, acnt:9, fn:svg_layout_hv, nm:"3x3p5",
                c:[{ly:"3x3_256"}]
               },
    "4x3p5"  : {tcnt:0, acnt:12, fn:svg_layout_hv, nm:"4x3p5",
                c:[{ly:"4x3_256"}]
               },
    "4x4p5"  : {tcnt:0, acnt:16, fn:svg_layout_hv, nm:"4x4p5",
                c:[{ly:"4x4_256"}]
               },

    "6_aonly"  : {tcnt:0, acnt:6, fn:svg_layout_hv, nm:"6_aonly",
                  c:[{ly:"6_aonly"}],
               },
    "2on4"   : {tcnt:0, acnt:6, fn:svg_layout_hv, nm:"2on4",
                c:[{ly:"2on4_pt"}],
               },
    "1on4"   : {tcnt:0, acnt:5, fn:svg_layout_hv, nm:"1on4",
                c:[{ly:"1on4_pt"}],
               },
    "1x5_pt" : {tcnt:0, acnt:6, fn:svg_layout_hv, nm:"1x5_pt",
                c:[{ly:"1x5_pt"}],
               },
    "1x6_pt" : {tcnt:0, acnt:7, fn:svg_layout_hv, nm:"1x6_pt",
                c:[{ly:"1x6_pt"}],
               },
    "2x5lg_pt" : {tcnt:0, acnt:11, fn:svg_layout_hv, nm:"2x5lg_pt",
                c:[{ly:"2x5lg_pt"}],
               },
    "autopt" : {auto:true, tcnt:0, nm:"autopt",
                as:[{n:0,nm:"1on4"},{n:5,nm:"1x5_pt"},{n:6,nm:"1x6_pt"},
                    {n:7,nm:"2x5lg_pt"}, {n:11}]
               },
    "autop5" : {auto:true, tcnt:4, nm:"autop5",
                as:[{n:0,nm:"1x1p5"}, {n:2,nm:"2x1p5"}, {n:3,nm:"2x2p5"},
                    {n:5,nm:"3x2p5"}, {n:7,nm:"3x3p5"}, {n:10,nm:"4x3p5"},
                    {n:13,nm:"4x4p5"}, {n:16}]
               },
  };
  if (device && device.pt_can_play < 2) {
    vx.layout_cfg["2on4"] =
      {tcnt:0, acnt:6, fn:svg_layout_hv, nm:"2on4",
       c:[{ly:"1on4_pt"}],
      };
  }
  if (vx.sw_is_portrait) {
    vx.layout_cfg["2x1p5"] =
      {tcnt:2, acnt:2, fn:svg_layout_hv, nm:"2x1p5",
       c:[{ly:"1x2_256"}],
      };
    vx.layout_cfg["2x2p5"] =
      {tcnt:3, acnt:4, fn:svg_layout_hv, nm:"2x2p5",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["3x2p5"] =
      {tcnt:3, acnt:6, fn:svg_layout_hv, nm:"3x2p5",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["3x3p5"] =
      {tcnt:3, acnt:9, fn:svg_layout_hv, nm:"3x3p5",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["4x3p5"] =
      {tcnt:3, acnt:12, fn:svg_layout_hv, nm:"4x3p5",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["4x4p5"] =
      {tcnt:3, acnt:16, fn:svg_layout_hv, nm:"4x4p5",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["2on4"] =
      {tcnt:3, acnt:6, fn:svg_layout_hv, nm:"2on4",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["1on4"] =
      {tcnt:3, acnt:5, fn:svg_layout_hv, nm:"1on4",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["1x5_pt"] =
      {tcnt:3, acnt:6, fn:svg_layout_hv, nm:"1x5_pt",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["1x6_pt"] =
      {tcnt:3, acnt:7, fn:svg_layout_hv, nm:"1x6_pt",
       c:[{ly:"1x3_256"}],
      };
    vx.layout_cfg["2x5lg_pt"] =
      {tcnt:3, acnt:11, fn:svg_layout_hv, nm:"2x5lg_pt",
       c:[{ly:"1x3_256"}],
      };
  }

  let changed = false;
  let cfg;
  let sel = 0;

  if (pnm) {
    let parts = pnm.split(".")
    let limit = 0;
    pnm = parts[0];
    if (!vx.layout_cfg[pnm] || vx.layout_cfg[pnm].disabled) {
      console.log("Nonexistent:"+pnm);
      pnm = "autop5";
    }

    /* max_slots used to for 'auto' layout selection.
     * lg_ok if particpants can supply pt/lg tile */
    let [max_slots, lg_ok, is_aonly] = get_cs_stats(vx.layout_cfg[pnm].tcnt);
    if (is_aonly && (!vx.room.slate || vx.room.slate.mode != "on")) {
      pnm = "6_aonly";
    } else if (vx.layout_cfg[pnm].auto) {
      let nm = vx.layout_cfg[pnm].as[0].nm;
      vx.layout_cfg[pnm].as.forEach(function(a) {
        if (a.nm && max_slots >= a.n) {
          nm = a.nm;
        }
        limit = a.n;
      });
      pnm = nm;
    }

    for (sel=0; sel < vx.layout_cfg[pnm].c.length; sel++) {
      let c = vx.layout_cfg[pnm].c[sel];
      /* Can use large tiles if visible particpants have it */
      if (c.lg && !lg_ok) { continue; }
      /* Can show huge supported and is moderator */
      if (c.huge && (!device.has_huge || !vx.room.is_mod)) {
        continue;
      }
      break; 
    }
    if (sel >= vx.layout_cfg[pnm].c.length) {
      console.warn("No valid selection for:"+vx.layout_cfg[pnm].nm);
      sel = vx.layout_cfg[pnm].c.length - 1;
    }
    cfg = vx.layout_cfg[pnm].c[sel];
    
    //console.log("HCFG:",cfg.ly,limit);
    if (!vx.layouts[0] ||
        cfg.ly != vx.layouts[0].ly) {
      changed = true;
    }

    vx.layouts[0] = {};
    Object.assign(vx.layouts[0],cfg);
    if (device.only_show_self) {
      vx.layouts[0].ly = "1x1_256";
    } else {
      vx.layouts[0].cfg_focus_uid = (parts[2]) || "--";
    }
    vx.layouts[0].limit = limit;
    vx.layouts[0].fn = vx.layout_cfg[pnm].fn;
    vx.layouts[0].acnt = vx.layout_cfg[pnm].acnt;
  }

  if (anm) {
    if (!vx.layout_cfg[anm] || vx.layout_cfg[anm].disabled) {
      console.log("Nonexistent aud:"+anm);
      anm = "autop5";
    }

    let [max_slots, lg_ok] =
        get_cs_stats(vx.layout_cfg[pnm].tcnt,true);

    if (vx.layout_cfg[anm].auto) {
      let nm = vx.layout_cfg[anm].as[0].nm;
      if (vx.st_page_idx > 1) {
        max_slots = 20; // Force consistent layout
      }
      vx.layout_cfg[anm].as.forEach(function(a) {
        if (a.nm && max_slots >= a.n) {
          nm = a.nm;
        }
        //limit = a.n;
      });
      anm = nm;
    }

    for (sel=0; sel < vx.layout_cfg[anm].c.length; sel++) {
      let c = vx.layout_cfg[anm].c[sel];
      /* Can use large tiles if visible particpants have it */
      if (c.lg && !lg_ok) { continue; }
      /* Can show huge supported and is moderator */
      if (c.huge && (!device.has_huge || !vx.room.is_mod)) {
        continue;
      }
      break; 
    }
    if (sel >= vx.layout_cfg[anm].c.length) {
      console.warn("No valid selection for:"+vx.layout_cfg[anm].nm);
      sel = vx.layout_cfg[anm].c.length - 1;
    }
    cfg = vx.layout_cfg[anm].c[sel];

    //console.log("ACFG:",cfg.ly);
    if (!vx.layouts[1] || 
        cfg.ly != vx.layouts[1].ly) {
      changed = true;
    }
    vx.layouts[1] = cfg;
    vx.layouts[1].focus_pos = 0;
    vx.layouts[1].fn = vx.layout_cfg[anm].fn;
  }

  if (vx.sw_is_portrait) {
    if (vx && vx.debug) { console.log("Layouts (portrait) "+msg+" "+changed); }
  } else {
    if (vx && vx.debug) { console.log("Layouts (landscape) "+msg+" "+changed); }
  }
  return changed;
}

vx.st_layout = 0;
vx.layouts = [];
vx.st_browsing = false;

function svg_misc(tt) {
  return '<svg class="vxic vxic-misc" viewBox="0 0 48 48" ><title>'+tt+'</title><circle cx="8" cy="26" r="4" stroke="white" stroke-width="1" fill="white" /><circle cx="24" cy="26" r="4" stroke="white" stroke-width="1" fill="white" /><circle cx="40" cy="26" r="4" stroke="white" stroke-width="1" fill="white" /></svg>';
}

function svg_hand_down(tt) {
  return '<svg class="vxic vxic-hd" viewBox="0 0 48 48"><title>'+tt+'</title><path d="M8.85,15.65a4.15,4.15,0,1,1,5.88-5.87l3,3-1.55-1.54a4.16,4.16,0,1,1,5.88-5.88l3,3-.32-.33a4.17,4.17,0,0,1,.5-6.35,4.33,4.33,0,0,1,5.52.62L43.32,14.86c5.59,5.59,3.92,16.53-4,24.2a23,23,0,0,1-8.24,5.23l-.14.05a18.59,18.59,0,0,1-18.61-4c-2.49-2.25-4.95-4.67-5.29-5.72a4.13,4.13,0,0,1,2.68-5.23l1,0,5,4.91L2.35,20.9a4.33,4.33,0,0,1-.62-5.52,4.17,4.17,0,0,1,6.35-.5L11.21,18" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}
  
function svg_allhand_down(tt) {
  return '<svg class="vxic vxic-ahd" viewBox="0 0 64 64"><title>'+tt+'</title><g transform="scale(0.75) translate(10 14) rotate(45 20 20)"><path stroke="black" stroke-width="1" fill="#e03535" d=" M 8.12, 15.1 A 4.17, 4.17, 0, 0, 0, 2.22, 21 L 22.88, 41.65 l -10.32 .42 -1, 0 A 4.18, 4.18, 0, 0, 0, 8.9, 47.35 c .7, 2.2, 2.56, 2.56, 3.94, 2.7 L 25, 52.46 a 24.37, 24.37, 0, 0, 0, 13.25 -.83, 23.26,23.26,0,0,0,8.26-5.26 c 7.92-7.7,9.63-18.65,4.07-24.21 L 30.66,2.22 a 4.17, 4.17, 0, 0, 0 -5.9, 5.9 l 7.63, 7.64 L 19.93, 3.29 A 4.18, 4.18, 0, 0, 0, 14, 9.2 L 26.49, 21.66, 10.26, 5.43 a 4.18, 4.18, 0, 0, 0 -5.9, 5.91 L 19.93, 26.9 "></path></g><path stroke-linecap="round" stroke-width="4" d="m 44,24 l 16,16 m 0,-16 l -16,16"></path></svg>';
}

function svg_hand_raised(tt) {
  return '<svg class="vxic vxic-hr" viewBox="0 0 55 55"><title>'+tt+'</title><path d="M8.12,15.1A4.17,4.17,0,0,0,2.22,21L22.88,41.65l-10.32.42-1,0A4.18,4.18,0,0,0,8.9,47.35c.7,2.2,2.56,2.56,3.94,2.7L25,52.46a24.37,24.37,0,0,0,13.25-.83,23.26,23.26,0,0,0,8.26-5.26c7.92-7.7,9.63-18.65,4.07-24.21L30.66,2.22a4.17,4.17,0,0,0-5.9,5.9l7.63,7.64L19.93,3.29A4.18,4.18,0,0,0,14,9.2L26.49,21.66,10.26,5.43a4.18,4.18,0,0,0-5.9,5.91L19.93,26.9" stroke="black" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

function svg_layout_hv() {
  return '<svg class="vxic" viewBox="0 0 68 68"><style> .vmtext { font: 18px sans-serif; }</style><text x="2"  y="28" class="vmtext">H</text><text x="18" y="28" class="vmtext">O</text><text x="35" y="28" class="vmtext">S</text><text x="51" y="28" class="vmtext">T</text><text x="2"  y="58" class="vmtext">V</text><text x="18" y="58" class="vmtext">I</text><text x="28" y="58" class="vmtext">E</text><text x="44" y="58" class="vmtext">W</text></svg>';
}

function svg_layout_av() {
  return '<svg class="vxic" viewBox="0 0 68 68"><style> .vmtext { font: 18px sans-serif; } </style> <text x="6"  y="18" class="vmtext">A</text> <text x="20" y="18" class="vmtext">U</text> <text x="34" y="18" class="vmtext">D</text> <text x="48" y="18" class="vmtext">I</text> <text x="54" y="18" class="vmtext">-</text> <text x="5"  y="39" class="vmtext">E</text> <text x="19" y="39" class="vmtext">N</text> <text x="33" y="39" class="vmtext">C</text> <text x="47" y="39" class="vmtext">E</text> <text x="8"  y="60" class="vmtext">V</text> <text x="22" y="60" class="vmtext">I</text> <text x="28" y="60" class="vmtext">E</text> <text x="40" y="60" class="vmtext">W</text></svg>';
}

function svg_layout_1p7() {
  return '<svg class="vxic vxic-1p7" viewBox="0 0 68 84"><title>Host View</title><rect x="4" y="2" width="12" height="12" rx="2.5"></rect><rect x="20" y="2" width="44" height="44" rx="2.5"></rect><rect x="4" y="18" width="12" height="12" rx="2.5"></rect><rect x="4" y="34" width="12" height="12" rx="2.5"></rect><rect x="4" y="50" width="12" height="12" rx="2.5"></rect><rect x="20" y="50" width="12" height="12" rx="2.5"></rect><rect x="36" y="50" width="12" height="12" rx="2.5"></rect><rect x="52" y="50" width="12" height="12" rx="2.5"></rect><circle class="vxic-1p7c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-1p7c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-1p7c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_2x2() {
  return '<svg class="vxic vxic-2x2" viewBox="0 0 68 84"><title>Host View</title><rect x="6" y="2" width="26" height="26" rx="2.5"></rect><rect x="36" y="2" width="26" height="26" rx="2.5"></rect><rect x="6" y="32" width="26" height="26" rx="2.5"></rect><rect x="36" y="32" width="26" height="26" rx="2.5"></rect><circle class="vxic-2x2c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-2x2c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-2x2c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_1on3() {
  return '<svg class="vxic vxic-1on6" viewBox="0 0 68 84"><title>Host View</title><rect x="12" y="2" width="44" height="28" rx="2.5"></rect><rect x="12" y="34" width="12" height="12" rx="2.5"></rect><rect x="28" y="34" width="12" height="12" rx="2.5"></rect><rect x="44" y="34" width="12" height="12" rx="2.5"></rect><circle class="vxic-1on6c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-1on6c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-1on6c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_1on6() {
  return '<svg class="vxic vxic-1on6" viewBox="0 0 68 84"><title>Host View</title><rect x="12" y="2" width="44" height="28" rx="2.5"></rect><rect x="12" y="34" width="12" height="12" rx="2.5"></rect><rect x="28" y="34" width="12" height="12" rx="2.5"></rect><rect x="44" y="34" width="12" height="12" rx="2.5"></rect><rect x="12" y="50" width="12" height="12" rx="2.5"></rect><rect x="28" y="50" width="12" height="12" rx="2.5"></rect><rect x="44" y="50" width="12" height="12" rx="2.5"></rect><circle class="vxic-1on6c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-1on6c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-1on6c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_1x1() {
  return '<svg class="vxic vxic-1x2" viewBox="0 0 68 84"><title>Host View</title><rect x="6" y="2" width="56" height="56" rx="2.5"></rect><circle class="vxic-1x1c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-1x1c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-1x1c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_1x2() {
  return '<svg class="vxic vxic-1x2" viewBox="0 0 68 84"><title>Host View</title><rect x="6" y="2" width="56" height="26" rx="2.5"></rect><rect x="6" y="32" width="56" height="26" rx="2.5"></rect><circle class="vxic-1x2c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-1x2c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-1x2c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_1x3() {
  return '<svg class="vxic vxic-1x3" viewBox="0 0 68 84"><title>Host View</title><rect x="16" y="2"  width="36" height="16" rx="2.5" fill="black"></rect><rect x="16" y="22" width="36" height="16" rx="2.5" fill="black"></rect><rect x="16" y="42" width="36" height="16" rx="2.5" fill="black"></rect><circle class="vxic-1x3c1" cx="20" cy="72" r="4"></circle><circle class="vxic-1x3c2" cx="34" cy="72" r="4"></circle><circle class="vxic-1x3c3" cx="48" cy="72" r="4"></circle></svg>';
}

function svg_layout_3x3() {
  return '<svg class="vxic vxic-3x3" viewBox="0 0 68 84"><title>Host View</title><rect x="6"  y="2"  width="16" height="16" rx="2.5"></rect><rect x="26" y="2"  width="16" height="16" rx="2.5"></rect><rect x="46" y="2"  width="16" height="16" rx="2.5"></rect><rect x="6"  y="22" width="16" height="16" rx="2.5"></rect><rect x="26" y="22" width="16" height="16" rx="2.5"></rect><rect x="46" y="22" width="16" height="16" rx="2.5"></rect><rect x="6"  y="42" width="16" height="16" rx="2.5"></rect><rect x="26" y="42" width="16" height="16" rx="2.5"></rect><rect x="46" y="42" width="16" height="16" rx="2.5"></rect><circle class="vxic-3x3c1" cx="20" cy="72" r="4"></circle><circle class="vxic-3x3c2" cx="34" cy="72" r="4"></circle><circle class="vxic-3x3c3" cx="48" cy="72" r="4"></circle></svg>';
}

function svg_layout_4x3() {
  return '<svg class="vxic vxic-4x3" viewBox="0 0 68 84"><title>Audience View</title><style> .vmtext { font: 18px sans-serif; } </style><text x="20" y="38" class="vmtext">1</text><text x="36" y="38" class="vmtext">2</text><rect x="4" y="2" width="12" height="12" rx="2.5"></rect><rect x="20" y="2" width="12" height="12" rx="2.5"></rect><rect x="36" y="2" width="12" height="12" rx="2.5"></rect><rect x="52" y="2" width="12" height="12" rx="2.5"></rect><rect x="4" y="18" width="12" height="12" rx="2.5"></rect><rect x="52" y="18" width="12" height="12" rx="2.5"></rect><rect x="4" y="34" width="12" height="12" rx="2.5"></rect><rect x="52" y="34" width="12" height="12" rx="2.5"></rect><rect x="4" y="50" width="12" height="12" rx="2.5"></rect><rect x="20" y="50" width="12" height="12" rx="2.5"></rect><rect x="36" y="50" width="12" height="12" rx="2.5"></rect><rect x="52" y="50" width="12" height="12" rx="2.5"></rect><circle class="vxic-4x3c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-4x3c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-4x3c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_4x4() {
  return '<svg class="vxic vxic-4x4" viewBox="0 0 68 84"><title>Audience View</title><style> .vmtext { font: 18px sans-serif; } </style><text x="20" y="38" class="vmtext">1</text><text x="36" y="38" class="vmtext">6</text><rect x="4" y="2" width="12" height="12" rx="2.5"></rect><rect x="20" y="2" width="12" height="12" rx="2.5"></rect><rect x="36" y="2" width="12" height="12" rx="2.5"></rect><rect x="52" y="2" width="12" height="12" rx="2.5"></rect><rect x="4" y="18" width="12" height="12" rx="2.5"></rect><rect x="52" y="18" width="12" height="12" rx="2.5"></rect><rect x="4" y="34" width="12" height="12" rx="2.5"></rect><rect x="52" y="34" width="12" height="12" rx="2.5"></rect><rect x="4" y="50" width="12" height="12" rx="2.5"></rect><rect x="20" y="50" width="12" height="12" rx="2.5"></rect><rect x="36" y="50" width="12" height="12" rx="2.5"></rect><rect x="52" y="50" width="12" height="12" rx="2.5"></rect><circle class="vxic-4x4c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-4x4c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-4x4c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_7x7() {
  return '<svg class="vxic vxic-7x7" viewBox="0 0 68 84"><title>Audience View</title><style> .vmtext { font: 18px sans-serif; } </style><text x="20" y="38" class="vmtext">4</text><text x="36" y="38" class="vmtext">9</text><rect x="4" y="2" width="12" height="12" rx="2.5"></rect><rect x="20" y="2" width="12" height="12" rx="2.5"></rect><rect x="36" y="2" width="12" height="12" rx="2.5"></rect><rect x="52" y="2" width="12" height="12" rx="2.5"></rect><rect x="4" y="18" width="12" height="12" rx="2.5"></rect><rect x="52" y="18" width="12" height="12" rx="2.5"></rect><rect x="4" y="34" width="12" height="12" rx="2.5"></rect><rect x="52" y="34" width="12" height="12" rx="2.5"></rect><rect x="4" y="50" width="12" height="12" rx="2.5"></rect><rect x="20" y="50" width="12" height="12" rx="2.5"></rect><rect x="36" y="50" width="12" height="12" rx="2.5"></rect><rect x="52" y="50" width="12" height="12" rx="2.5"></rect><circle class="vxic-7x7c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-7x7c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-7x7c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_layout_10x10() {
  return '<svg class="vxic vxic-10x10" viewBox="0 0 68 84"><title>Audience View</title><style> .vmtext { font: 18px sans-serif; } </style><text x="18" y="38" class="vmtext">1</text><text x="28" y="38" class="vmtext">0</text><text x="39" y="38" class="vmtext">0</text><rect x="4" y="2" width="12" height="12" rx="2.5"></rect><rect x="20" y="2" width="12" height="12" rx="2.5"></rect><rect x="36" y="2" width="12" height="12" rx="2.5"></rect><rect x="52" y="2" width="12" height="12" rx="2.5"></rect><rect x="4" y="18" width="12" height="12" rx="2.5"></rect><rect x="52" y="18" width="12" height="12" rx="2.5"></rect><rect x="4" y="34" width="12" height="12" rx="2.5"></rect><rect x="52" y="34" width="12" height="12" rx="2.5"></rect><rect x="4" y="50" width="12" height="12" rx="2.5"></rect><rect x="20" y="50" width="12" height="12" rx="2.5"></rect><rect x="36" y="50" width="12" height="12" rx="2.5"></rect><rect x="52" y="50" width="12" height="12" rx="2.5"></rect><circle class="vxic-10x10c1" cx="20" cy="72" r="4"/></circle><circle class="vxic-10x10c2" cx="34" cy="72" r="4"/></circle><circle class="vxic-10x10c3" cx="48" cy="72" r="4"/></circle></svg>';
}

function svg_enter_room(tt) {
  return '<svg class="vxic vxic-re" viewBox="0 0 64 64"><title>'+tt+'</title> <style> .vmtext { font: 18px sans-serif; fill: white; } </style> <line class="vxic-rep" stroke-linecap="round" stroke-width="4" fill="none" x1="32" y1="10" x2="32" y2="34" /> <line class="vxic-rep" stroke-linecap="round" stroke-width="3" fill="none" x1="20" y1="22" x2="44" y2="22" /> <rect class="vxic-rer" x="8" y="4" rx="4" ry="4" width="48" height="36" style="fill:none;stroke-width:2" /> <text x="0" y="60" class="vmtext">E</text> <text x="12" y="60" class="vmtext">N</text> <text x="26" y="60" class="vmtext">T</text> <text x="38" y="60" class="vmtext">E</text><text x="51" y="60" class="vmtext">R</text> </svg>';
}
  
function svg_exit_room(tt) {
  return '<svg class="vxic vxic-rx" viewBox="-1 -1 63 63"><title>'+tt+'</title> <style> .vmtext { font: 18px sans-serif; fill: white; } </style> <line id="plus2h" stroke-linecap="round" stroke-dasharray="null" stroke-width="5" stroke="#e03535" fill="none" x1="20" y1="22" x2="44" y2="22" /> <rect id="room" x="8" y="4" rx="4" ry="4" width="48" height="36" style="fill:transparent;stroke-width:2;opacity:1" /> <text x="8" y="60" class="vmtext">E</text> <text x="22" y="60" class="vmtext">X</text> <text x="37" y="60" class="vmtext">I</text> <text x="44" y="60" class="vmtext">T</text> </svg>';
}
  
function svg_show_volume_off() {
  return '<svg class="vxic vxic-mu" viewBox="-1 -1 63 63"><title>Muted</title><path class="vxic-mubl" d="M16.79,45H14.73a10,10,0,1,1,0-20h2.06L38.34,5.71a2.41,2.41,0,0,1,4.12,1.53V62.78a2.42,2.42,0,0,1-4.12,1.54Z" transform="translate(-3.96 -4.51)" stroke-linecap="round" stroke-linejoin="round"/><line class="vxic-muc" x1="48.5" y1="37.17" x2="60.5" y2="25.17" stroke-linecap="round" stroke-linejoin="round"/><line class="vxic-muc" x1="60.5" y1="37.17" x2="48.5" y2="25.17" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}
  
function svg_show_volume_on() {
  return '<svg class="vxic vxic-um" viewBox="-1 -1 63 63"><title>Sound On</title><path class="vxic-ums" d="M51,28.35a6,6,0,0,1,0,12" transform="translate(-4.54 -4.51)" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path class="vxic-ums" d="M51,20.35a14,14,0,1,1,0,28" transform="translate(-4.54 -4.51)" fill="none" stroke-linecap="round" stroke-linejoin="round"/><path class="vxic-umbl" d="M17,45H15a10,10,0,0,1,0-20h2L38,5.71a2.34,2.34,0,0,1,4,1.53V62.78a2.34,2.34,0,0,1-4,1.54Z" transform="translate(-4.54 -4.51)" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}
  
function svg_show_mic_off() {
  return '<svg class="vxic vxic-mx" viewBox="-1 -1 63 63"><title>Mic Off</title><g><line id="base1" stroke-linecap="round" stroke-dasharray="null" stroke-width="3" stroke="white" fill="none" x1="38" y1="62" x2="6" y2="62"/><line id="stem1" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" stroke="white" fill="none" x1="22" y1="62" x2="22" y2="48"/><path id="swivelbot" stroke-linecap="round" stroke-dasharray="null" stroke-width="2" stroke="white" fill="transparent" d="m 6,24 l 0,6 c 0,24 32,24 32,0 l 0,-6"/><path id="micbody" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" stroke="white" fill="#963232" d="m 10,30 c 0,18 24,18 24,0 l 0,-12 c 0,-18 -24,-18 -24,0 l 0,12 z"/><path id="xout2" stroke-linecap="round" stroke-dasharray="null" stroke-width="2" stroke="white" fill="transparent" d="m 46,18 l 12,12 m 0,-12 l -12,12"/></g></svg>';
}
  
function svg_show_mic_on() {
  return '<svg class="vxic vxic-mo" viewBox="-1 -1 63 63"><title>Mic On</title><g><line id="base1" stroke-linecap="round" stroke-dasharray="null" stroke-width="3" stroke="white" fill="none" x1="38" y1="62" x2="6" y2="62"/><line id="stem1" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" stroke="white" fill="none" x1="22" y1="62" x2="22" y2="48"/><path id="swivelbot" stroke-linecap="round" stroke-dasharray="null" stroke-width="2" stroke="white" fill="transparent" d="m 6,24 l 0,6 c 0,24 32,24 32,0 l 0,-6"/><path id="micbody" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" stroke="white" fill="transparent" d="m 10,30 c 0,18 24,18 24,0 l 0,-12 c 0,-18 -24,-18 -24,0 l 0,12 z"/></g></svg>';
}

function svg_show_conf_off() {
  return '<svg class="vxic vxic-cx" viewBox="0 0 64 64"> <title>'+'</title> <style> .vmtext { font: 18px sans-serif; fill: white; } </style> <g> <circle id="hosthead" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" cx="32" cy="14" r="8" /> <path id="hostsound1" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 22,10 c 0,0 -4,4 0,8" /> <path id="hostsound2" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 19,8 c 0,0 -6,6 0,12" /> <path id="hostsound3" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 16,6 c 0,0 -8,8 0,16" /> <path id="hostbody"   stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d=" m 17,37 l 30,0 l 0,-6 c 0,0 0,-8 -8,-8 l -14, 0 c 0,0 -8,0 -8,8 z" /> <text x="3"  y="58" class="vmtext">H</text> <text x="18" y="58" class="vmtext">O</text> <text x="34" y="58" class="vmtext">S</text> <text x="48" y="58" class="vmtext">T</text> </g> </svg>';
}

function svg_show_conf_on() {
  return '<svg class="vxic vxic-co" viewBox="0 0 64 64"><title>'+'</title> <style> .vmtext { font: 18px sans-serif; fill: white; } </style> <g> <circle id="hosthead" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" cx="32" cy="14" r="8" /> <path id="hostsound1" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 22,10 c 0,0 -4,4 0,8" /> <path id="hostsound2" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 19,8 c 0,0 -6,6 0,12" /> <path id="hostsound3" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 16,6 c 0,0 -8,8 0,16" /> <path id="hostbody"   stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d=" m 17,37 l 30,0 l 0,-6 c 0,0 0,-8 -8,-8 l -14, 0 c 0,0 -8,0 -8,8 z" /> <text x="13"  y="58" class="vmtext">A</text> <text x="28" y="58" class="vmtext">L</text> <text x="41" y="58" class="vmtext">L</text> </g> </svg>';
  }

function svg_make_pres(m) {
  return '<svg class="vxic vxic-pra" viewBox="0 0 64 64"><title>'+m+'</title><g><rect x="14" y="60" rx="2" ry="2" width="36" height="3"></rect><polygon points="18,60 14,16 50,16 46,60" /><rect class="" x="6" y="10" rx="2" ry="2" width="52" height="6"></rect><path stroke-linecap="round" d="m 16,10 l 6,-6 l 3,-1"></path><rect x="26" y="2" rx="2" ry="2" width="3" height="2"></rect><line stroke="#ff000" x1="32" y1="24" x2="32" y2="44"></line><line stroke="#ff000" x1="22" y1="34" x2="42" y2="34"></line></g></svg>';
}

function svg_rem_pres(m) {
  return '<svg class="vxic vxic-prr" viewBox="0 0 64 64"><title>'+m+'</title><g><rect x="14" y="60" rx="2" ry="2" width="36" height="3"></rect><polygon style="fill:rgba(150,50,50,.7)" points="18,60 14,16 50,16 46,60" /><rect x="6" y="10" rx="2" ry="2" width="52" height="6"></rect><path stroke-linecap="round" d="m 16,10 l 6,-6 l 3,-1"></path><rect x="26" y="2" rx="2" ry="2" width="3" height="2"></rect><line x1="22" y1="34" x2="42" y2="34"></line></g></svg>';
}

function svg_mirror(m) {
  return '<svg class="vxic vxic-mo" viewBox="0 0 64 64"><title>'+m+'</title><g transform="translate(8,8)"><polygon points="12,44 36,44 24,32" style="fill:#807070;stroke-width:1"></polygon><g fill="#807070" stroke="none"><path d="M42,6 H6 C3.8,6,2,7.8,2,10 v24 c0,2.2,1.8,4,4,4 h8v-4 H6 V10 h36 v24 h-8 v4 h8 c2.2,0,4-1.8,4-4V10C46,7.8,44.2,6,42,6z"></path></g></g></svg>';
}

function svg_kvm_rq(m) {
  return '<svg class="vxic vxic-kvr" viewBox="0 0 64 64"><title>'+m+'</title><g><rect x="6" y="10" rx="4" ry="4" width="52" height="34"/><line id="plusv" stroke-linecap="round" x1="32" y1="18" x2="32" y2="38"/><line id="plush" stroke-linecap="round" x1="22" y1="28" x2="42" y2="28"/><line stroke-linecap="round" stroke-width="5" x1="32" y1="46" x2="32" y2="53"/><line stroke-linecap="round" stroke-width="5" x1="22" y1="55" x2="42" y2="55"/></g></svg>';
}

function svg_kvm_on(m) {
  return '<svg class="vxic vxic-kvs" viewBox="0 0 64 64"><title>'+m+'</title><g><rect x="6" y="10" rx="4" ry="4" width="52" height="34" fill="#903232"/><line id="plush" stroke-linecap="round" x1="22" y1="28" x2="42" y2="28"/><line stroke-linecap="round" stroke-width="5" x1="32" y1="46" x2="32" y2="53"/><line stroke-linecap="round" stroke-width="5" x1="22" y1="55" x2="42" y2="55"/></g></svg>';
}

function svg_to_brk(m,n) {
  let num = "";
  m = m + " #" + n;
  if (n < 10) {
    num = '<text x="20" y="60" style="font-size:2rem;">'+n+'</text>';
  } else if (n < 100) {
    num = '<text x="12" y="60" style="font-size:2rem;>'+n+'</text>';
  } else {
    num = '<text x="4" y="60" style="font-size:1.8rem;>'+n+'</text>';
  }
  return '<svg class="vxic vxic-rx" style="font-size:1.6rem;stroke-width:2;" viewBox="0 0 64 64"><title>'+m+'</title><text x="7" y="22">T</text><text x="30" y="22">O</text>'+num+'</svg>';
}

function svg_to_main(m) {
  return '<svg class="vxic vxic-tobrk" style="font-size:1.4rem;stroke-width:2;" viewBox="0 0 64 64"><title>'+m+'</title><text x="18" y="22">T</text><text x="33" y="22">O</text><text x="0" y="58">M</text><text x="22" y="58">A</text> <text x="39" y="58">I</text> <text x="48" y="58">N</text></svg>';
}

function svg_show_conf_hp3() {
  return '<svg class="vxic vxic-cq" viewBox="0 0 64 64"><title>'+'</title> <style> .vmtext { font: 18px sans-serif; fill: white; } </style> <circle id="hosthead" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" cx="46" cy="14" r="8" /> <path id="hostsound1" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 34,12 c 0,0 -4,4 0,8" /> <path id="hostsound2" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 31,10 c 0,0 -6,6 0,12" /> <path id="hostsound3" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 28,8 c 0,0 -8,8 0,16" /> <path id="hostbody" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d=" m 31,39 l 30,0 l 0,-6 c 0,0 0,-8 -8,-8 l -14, 0 c 0,0 -8,0 -8,8 z" /> <g id="aud1hand" transform="scale(0.40) translate(11 20) rotate(45 20 20)"> <path stroke-linecap="round" stroke-linejoin="round" stroke="black" stroke-width="1" fill="#e03535" d=" M 8.12, 15.1 A 4.17, 4.17, 0, 0, 0, 2.22, 21 L 22.88, 41.65 l -10.32 .42 -1, 0 A 4.18, 4.18, 0, 0, 0, 8.9, 47.35 c .7, 2.2, 2.56, 2.56, 3.94, 2.7 L 25, 52.46 a 24.37, 24.37, 0, 0, 0, 13.25 -.83, 23.26,23.26,0,0,0,8.26-5.26 c 7.92-7.7,9.63-18.65,4.07-24.21 L 30.66,2.22 a 4.17, 4.17, 0, 0, 0 -5.9, 5.9 l 7.63, 7.64 L 19.93, 3.29 A 4.18, 4.18, 0, 0, 0, 14, 9.2 L 26.49, 21.66, 10.26, 5.43 a 4.18, 4.18, 0, 0, 0 -5.9, 5.91 L 19.93, 26.9 "/> </g> <text x="0" y="58" class="vmtext">Q</text> <text x="14" y="58" class="vmtext">U</text> <text x="27" y="58" class="vmtext">E</text> <text x="39" y="58" class="vmtext">U</text> <text x="52" y="58" class="vmtext">E</text> </g> </svg>';
}

function svg_show_conf_prv() {
  return '<svg class="vxic vxic-co" viewBox="0 0 64 64"><title>'+"Private 1-on-1"+'</title> <style> .vmtext { font: 18px sans-serif; fill: white; } </style> <g> <circle id="hosthead" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" cx="32" cy="14" r="8" /> <path id="hostsound1" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 22,10 c 0,0 -4,4 0,8" /> <path id="hostsound2" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 19,8 c 0,0 -6,6 0,12" /> <path id="hostsound3" stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d="m 16,6 c 0,0 -8,8 0,16" /> <path id="hostbody"   stroke-linecap="butt" stroke-dasharray="null" stroke-width="2" fill="transparent" d=" m 17,37 l 30,0 l 0,-6 c 0,0 0,-8 -8,-8 l -14, 0 c 0,0 -8,0 -8,8 z" /> <text x="13"  y="58" class="vmtext">Priv</text> </g> </svg>';
}

function svg_chat() {
  return '<svg class="vxic vxic-ch" viewBox="0 0 64 64"><title></title><style> .vmtext { font: 18px sans-serif; } </style><text x="2"  y="38" class="vmtext" >C</text><text x="18" y="38" class="vmtext" >H</text><text x="36" y="38" class="vmtext" >A</text><text x="50" y="38" class="vmtext" >T</text></svg>';
}

function svg_is_sharing() {
  return '<svg stroke="#43c4c0" fill="rgb(180, 75, 75)" stroke-width=6 viewBox="0 0 64 64"><title>Show Shared</title><line x1="23" y1="28" x2="45" y2="16"/><line x1="23" y1="36" x2="45" y2="48" /><circle cx="52" cy="12" r="8"  /><circle cx="16" cy="32" r="8" /><circle cx="52" cy="52" r="8" /></svg>';
}

function svg_play() {
  return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 73.856 73.856"><g fill="#FFFFFF"><path d="M55.928,36.9l-28,17.528v-35L55.928,36.9z"/><path d="M36.83,71.928c-19.299,0-35-15.701-35-35s15.701-35,35-35s35,15.701,35,35S56.129,71.928,36.83,71.928z M36.83,7.928 c-15.991,0-29,13.009-29,29c0,15.99,13.009,29,29,29c15.99,0,29-13.01,29-29C65.83,20.938,52.82,7.928,36.83,7.928z"/></g></svg>';
}

//ac: 0 = host, -N = first N anyone, N = first N handraised
var conf_modes = [ {ac:-99, prv:false, fn:svg_show_conf_on}, {ac:1, prv:false, fn:svg_show_conf_hp3}, {ac:0, prv:false, fn:svg_show_conf_off}];

function dnssub(vsurl) {
  vx.vmode_dsg = getCookie("vx_dsg");
  /* 6/sec @ 300 == 50 sec */
  if (vx.useWPlay) {
    vsurl = vsurl.replace("sgrp=", "bepi=1600&sub=3&sgrp=");
  } else {
    if (!vx.vmode_dsg && !vx.rewind_delta) {
      vsurl = vsurl.replace("sgrp=", "icl=168&mmc=168&sub=3&sgrp=");
    } else {
      vsurl = vsurl.replace("sgrp=", "icl=60&mmc=60&sgrp=");
      vx.vmode_dsg = true;
    }
  }
  //vsurl += VuemixSDK.chooseOption({
  //  ua:[/Macintosh.*AppleWebKit.*Version.*Safari/],
  //  pos:"&dma"/*enable dummy audio*/}, "");

  //vsurl += "&dma";
  //console.log("VS " + vsurl);
  return vsurl;
}

function monitor_self() {
  api_self(vx, {}, function(status, data) {
    if (vx && vx.debug) { console.log("update self"); }
    if (status == 401) {
      window.vx_signout_callback();
      return;
    }
    if (data) {
      if (!vx_import_user(vx, data)) {
        window.vx_signout_callback();
        return;
      }
    }

    /* Force occassional list_room update to update any
     *  streaming ids */
    delete vx.last_query_limit;

    /* User's streaming id may have changed. Call even if no vdbid as this
     *   will acquire any remote streaming state */
    update_user_assets();
    /* auth_room success triggers monitor_self call. auth_room is
       periodic because wss are periodically refreshed. The key step
       in wss refresh is auth_me/room. */
  });
}

function room_noaccess(opt={}) {
  stop_playback();
  room_destroy_slate();
  if (vx.cb_room) {
    vx.cb_room("noaccess",opt);
  }
}

/****************************************************************************/

function handle_auth_room(msg) {
  delete vx.room.auth_error;
  delete vx.room.auth_restart;
  if (msg.data != "ok") {
    vx_nav_callback("eventid","-");
    if (vx.room.is_eph) {
      window.vx_nav_callback("goto_room",{
        acc: vx.acc,
        room: vx.room.main_room
      });
      return;
    }
    if (msg.data.error == "denied-limit") {
      let v = msg.data.vcnt;
      let w = msg.data.acnt - v;
      vx.room.auth_error = `Room is currently full. ${v} already viewing and ${w} more waiting. You will be let in when space becomes available.`;
      vx.room.auth_restart = 20;
    } else if (msg.data.error == "denied-home") {
      window.vx_nav_callback("notify",
        {c:8, m:"Please enter room again to re-authenticate."});
      window.vx_nav_callback("goto_home");
      return;
    } else {
      vx.room.auth_error = msg.data.error;
      vx.room.auth_restart = 0;
    }
  }

  /* For now assume auth_room was for self. Get
   *   lastest user and room roles. get_room_ctrl
   *   returns both. */
  wss_send(vx, "get_room_ctrl", {});

  /* Get lastest vdbid/vid; trigger bind_video */
  monitor_self();

  if (vx.postAuthAction) {
    if (vx.postAuthAction.action == "msg_to") {
      handle_msg_to(vx.postAuthAction);
    }
    delete vx.postAuthAction;
  }
}

function handle_list_user(msg) {
  if (msg.data.uid == vx.user.id) {
    /* FOR SELF */
    if (msg.data.roles) {
      let r = msg.data.roles;
      /* These roles are specific to this room */
      vx.room.is_mod = r.is_mod;      
      vx.room.is_owner = r.is_owner;
      vx.room.can_join = r.can_join || false;
      vx.room.can_view = r.can_view || false;
      vx.room.detach = msg.data.det;
      if (r.can_view) {
        /* auth_room:ok sent due to owner manually letting
           in user. */
        vx.cb_room && vx.cb_room("noaccess",{reset:true});
      }
      window.vx_nav_callback("setMod",{is_mod: vx.room.is_mod,
                                       is_owner: vx.room.is_owner});
      get_room_stats();
    }
    vx.room.isSelf = true;
    vx.room.self_state = msg.data.sa || {};
    vx.room.mod_state = msg.data.ma || {};
    if (!getAudioBlk(vx.room)) {
      window.vx_nav_callback("mic",true);
    } else {
      window.vx_nav_callback("mic",false);
    }

    if (!vx.room.can_view) {
      /* Kill the wall and display some kind of message? */
      // FIXME
    }
    updateUIStates();
    if (msg.data.ephidx) {
      vx_to_brk_room(vx,msg.data.ephidx);
      vx.room.my_ephidx = msg.data.ephidx;
    }
  } else {
    /* FOR SOMEONE ELSE */
    if (vx && vx.debug) { console.log("another user"); }
  }
  
  /* Need to do this for self and others to keep 
     cell iconography current */
  if (vx.cs_all) {
    let changed = false;
    vx.cs_all.forEach(function(ct) {
      if (ct.userid == msg.data.uid) {
        msg.data.sa = msg.data.sa || {};
        msg.data.ma = msg.data.ma || {};
        if (!objsame(ct.self_state, msg.data.sa)) {
          ct.self_state = msg.data.sa;
          changed = true;
        }
        if (!objsame(ct.mod_state, msg.data.ma)) {
          ct.mod_state = msg.data.ma;
          changed = true;
        }
        if (update_vdbid(ct, msg.data.vdbid, msg.data.vid)) {
          changed = true;
        }
        if (update_detach(ct, msg.data.det)) {
          changed = true;
        }
      }
    });
    if (changed) {
      updateWall();
    }
  }
}

function handle_bind_video(msg) {
  if (msg.data == "video_active") {
    vx.user.is_streaming = true;
    updateUIStates();
  } else if (msg.data == "video_done") {
    vx.user.is_streaming = false;
    ///* Clear out streaming id in user record and start monitoring self */
    //api_clear_streamingid(vx, {vdbid: vx.user.vdbid}, function() {
    //  console.log("cleared streamingid");
    //});
    updateUIStates();
  } else if (msg.data == "video_new_active") {
    /* bind called prior to streaming start to register new vdbid 
     *   with user/room. However, unlikely it was active. Once video
     *   is actually active, call bind again finalize state */
    update_user_assets();
  }
}

function handle_join_room(msg) {
  if (msg.data == "ok") {
    vx.room.is_joined = true;
    updateUIStates();
  } else if (msg.data == "denied-limit") {
    window.vx_nav_callback("notify", {c:8, m:"You cannot join. Room has reached its participant limit."});
    window.vx_nav_callback("exit_room");
  }
}

function handle_exit_room(msg) {
  if (msg.data == "ok") {
    if (vx.room.is_joined) {
      window.vx_nav_callback("exit_room");
    }
    vx.room.is_joined = false;
    vx.room.is_raised = false;
    delete vx.room.is_raised_pos;
    updateUIStates();
  }
}

function handle_raise_hand(msg) {
  if (msg.data == "ok") {
    vx.room.is_raised = true;
    delete vx.room.is_raised_pos;
    $(".panel_btn_exit_q").attr("order", "+");
    updateUIStates();
  }
}

function handle_lower_hand(msg) {
  if (msg.data == "ok") {
    vx.room.is_raised = false;
    delete vx.room.is_raised_pos;
    updateUIStates();
  }
}

function objsame(a,b) {
  if ((typeof a) != (typeof b)) {
    return false;
  }
  if ((typeof a) != "object") {
    if (a != b) {
      return false;
    }
  } else {
    if (Object.keys(a).length !=
        Object.keys(b).length) {
      return false;
    }
    for (let k of Object.keys(a)) {
      //console.log(k,a[k],b[k]);
      if (a[k] != b[k]) {
        return false;
      }
    }
  }
  return true;
}

function update_vdbid(ct,vdbid,vid) {
  if (!ct || !vdbid || !vid) { return false; }
  let changed = false;
  let stmid,epoch,enc;
  if (m = vid.match(/(0x[0-9a-f]+:0):0/)) {
    stmid = "r."+m[1];
    enc = 0;
    epoch = 0;
  } else {
    let parts = vid.split(":");
    stmid = "t."+vid+":0";
    enc = parts[0];
    epoch = parts[1];
  }
  ct.id = vdbid;
  if (ct.streamingID != stmid) {
    ct.streamingID = stmid;
    if (ct.raw) {
      ct.raw.enc_video_id = enc;
      ct.raw.epoch = epoch
    }
    changed = true;
  }
  if (vx && vx.debug) {
    console.log("video update",ct.userid,
                vdbid, stmid, changed);
  }
  return changed;
}

function update_detach(ct,det) {
  if (!ct) { return false; }
  let changed = false;
  det = det || false;
  if (det !== ct.detach) {
    ct.detach = det;
    changed = true;
  }
  if (ct.userid == vx.user.id) {
    vx.room.detach = det;
  }
  if (vx && vx.debug) {
    console.log("detach update",ct.userid,
                det, vx.room.detach, changed);
  }
  return changed;
}

function cs_all_same(o,n)
{
  if (n.length != o.length) { return false; }
  let fs = ["raw","roles","self_state","mod_state","vt",
            "pres","qna","mod","ss","ss_an","ao","aoall","isSelf"];
  for (let i=0; i<n.length; i++) {
    //console.log(n[i]);
    for (let f of fs) {
      //console.log(f,n[i][f],typeof n[i][f]);
      if (!objsame(n[i][f],o[i][f])) {
        return false;
      }
    }
  }
  return true;
}

function handle_list_room(msg) {
  if (msg.data == "denied") {
    room_noaccess({
      src: "list_room",
      txt: "Your access has been retracted.",
    });
    return;
  }
  if (msg.data && msg.data[0] && msg.data[0].stats) {
    /* Merely a stats update */
    vx.rstats = vx.rstats || {};
    vx.rstats.part = msg.data[0].stats.part || 0;
    vx.rstats.view = msg.data[0].stats.view || 0;
    vx.rstats.wait = msg.data[0].stats.wait || 0;
    updateRStats();
    return;
  }

  let cs_all = [];
  let device = window.vx_get_mydevice();
  let is_alone = true;
  if (msg.data) {
    /* {"uid":"5c5c75fc39583c758e917538",
        "kd":"aud",
        "vdbid":"live-2019073034392079505298177",
        "vid":"1y59DoaSDJtmsqAjGWYGI/J3yd7aCPVPBsxLcRWT9A4=:1564705209"} */
    let found_self = false;
    msg.data = msg.data || [];
    if (vx.room) {
      delete vx.room.mod_ct;
    }
    if (device.only_show_self && vx.user) {
      msg.data = msg.data.filter(function(c) {
        if (c.uid != vx.user.id) {
          // Make everyone audio-only
          c.vt = {};
          return true;
        }
        return false;
      });
      if (vx.user.vdbid && device.is_capturing) {
        /* Pre-process result to guarantee 'self' exists and 
           is first */
        let self = {};
        self.vid = vx.user.vid;
        self.vdbid = vx.user.vdbid;
        self.uid = vx.user.id;
        self.vt = {sm:true,pt:true};
        self.kind = "prs";
        if (vx.room.is_joined) {
          self.dname = "[CAMERA MODE]";
        } else {
          self.dname = "[CAMERA MODE] You need to Enter";
        }
        msg.data.unshift(self);
      }
    }

    vx.room.is_first_raised = false;
    for (let ci=0; ci < msg.data.length; ++ci) {
      let c = msg.data[ci];
      if (c.kind == "inl") {
        if (c.uid == vx.user.id) {
          vx.room.is_first_raised = true;
        }
        break;
      }
    }
    msg.data.forEach(function(c) {
      if (c.last_key || !c.vdbid) { return; }
      try {
        let tmp = {};
        let parts = c.vid.split(":");
        tmp.title = c.dname;
        tmp.thumbnail_url2 = c.tn;
        tmp.type = "video";
        tmp.epoch = parts[1];
        tmp.enc_video_id = parts[0];
        tmp.id = c.vdbid;
        //console.log(JSON.stringify(tmp));
        
        let m, ct = new VuemixSDK.DataObject.VideoData(tmp);
        if (m = ct.streamingID.match(/(0x[0-9a-f]+:0):0/)) {
          ct.streamingID = "r."+m[1];
        }
        //console.log(JSON.stringify(c));
        if (c.kind == "prs") {
          ct.pres = true;
        } else if (c.kind == "inl") {
          ct.qna = true;
        } else if (c.kind == "mod") {
          /* Means voice-only moderator */
          ct.mod = true;
          if (vx.room && !vx.room.mod_ct) {
            vx.room.mod_ct = ct;
          }
        }
        if (c.roles) {
          ct.roles = {};
          ct.roles.is_owner = c.roles.is_owner;
          ct.roles.is_mod = c.roles.is_mod;
        }

        ct.userid = c.uid;
        ct.self_state = c.sa || {};
        ct.mod_state = c.ma || {};
        update_detach(ct,c.det)
        ct.ss = c.ss;
        ct.ss_an = c.ss_an;
        ct.orig_vt = c.orig_vt;
        ct.vt = c.vt;
        if (ct.vt && ct.vt.pt) {
          if (device.pt_can_play) {
            ct.vt.lg = true;
          } else {
            ct.vt.pt = false;
          }
        }
        if (ct.userid == vx.user.id) {
          ct.isSelf = true;
          found_self = true;
          if (ct.id) {
            window.vx_check_stopcapture(ct.id);
          }
          if (vx.room) {
            /* Some other login of "self" or moderator may have changed us */
            vx.room.self_state = ct.self_state;
            vx.room.mod_state = ct.mod_state;
          }
          if (ct.qna) {
            vx.room.is_raised = true;
          }
        }
        if (!ct.isSelf && ((ct.roles && ct.roles.is_mod) ||
                           ct.pres || ct.mod)) {
          is_alone = false;
        }
        if (!ct.isSelf && !vx.room.is_mod && vx.room.privmode) {
          if (!ct.roles || !ct.roles.is_mod) {
            ct.raw.orig_title = ct.raw.title;
            ct.raw.title = "";
          }
          if ((vx.room.is_first_raised && (!ct.roles || !ct.roles.is_mod)) ||
              (!vx.room.is_first_raised)) {
            ct.orig_vt = ct.vt;
            ct.vt = {};
            ct.mod_state = {blk:1};
          }
        }
        if (document.hidden || vx.user_vmode == 4) {
          ct.aoall = true;
        }
        cs_all.push(ct);
      }
      catch(e) {
        console.error("list_room",e);
      }
    });
    /* Room updated; Can show breakout controls */
  }

  if (vx.cb_room) {
    vx.cb_room("config_presence", {
      is_alone: is_alone && !vx.aud_filt && !vx.room.ephidx,
      is_detached: vx.room.detach,
    });
  }

  vx.room.eph_show = true;
  vx.cs_all_ephidx = vx.cs_all_ephidx || 0;
  if (cs_all_same(vx.cs_all,cs_all) &&
      vx.cs_all_ephidx == vx.room.ephidx) {
    return;
  }

  vx.cs_all = cs_all;
  vx.cs_all_ephidx = vx.room.ephidx;
  if (vx.room.state) {
    /* Call in case 'auto' and user count crossed threshold */
    wallFastRefresh();
  }
  vx.list_room_lastq = Date.now();
  updateWall();
  vx_nav_callback("roomlist",msg.data);
}


/* Global room events */
function handle_room(msg,opt) {
  opt = opt || {};
  if (msg && msg.data) {
    if (msg.data.k == "user_changed" ||
        msg.data.k == "user_restarted") {
      /* Some user's thumbnail or scrambled vid may have changed. There is no
         rush in updating for that. */
      if (msg.data.vt && vx.cs_all) {
        let changed = false;
        let mod_ct;
        if (msg.data.uid == vx.user.id && msg.data.vdbid) {
          window.vx_check_stopcapture(msg.data.vdbid);
        }
        vx.cs_all.forEach(function(ct) {
          if (ct.userid != msg.data.uid) { return; }
          if (vx.room.privmode && ct.orig_vt) {
            /* Privacy mode and orig_vt holds real thing */
            if (!objsame(ct.orig_vt,msg.data.vt)) {
              ct.orig_vt = msg.data.vt;
            }
          } else {
            /* Not privacy mode or someone who was exposed */
            if (ct.vt && !objsame(ct.vt,msg.data.vt)) {
              ct.vt = msg.data.vt;
              changed = true;
            }
          }
          if (ct.ss != msg.data.ss) {
            if ((!ct.ss || ct.ss == "-") && msg.data.ss) {
              ct.ss_is_new = true;
            }
            ct.ss = msg.data.ss;
            ct.ss_an = msg.data.ss_an;
            changed = true;
          }
          if (update_vdbid(ct, msg.data.vdbid, msg.data.vid)) {
            changed = true;
          }
          if (update_detach(ct, msg.data.det)) {
            changed = true;
          }
        });
        if (changed) {
          wallFastRefresh();
          updateWall();
        }
      }
      return;
    }
    if (msg.data.k && msg.data.k == "emptied") {
      window.vx_nav_callback("notify",
        {c:8, m:"The Host emptied the room and asks everyone to re-enter."});
      window.vx_nav_callback("goto_home");
      return;
    }
    if (msg.data.k && msg.data.k == "user_exited" && msg.data.uid) {
      let kvm = getLocal("vxkvm",true);
      if (vx && vx.debug) { console.log("exited: "+JSON.stringify(kvm)+"  "+msg.data.uid); }
      if (kvm && kvm.uid && kvm.uid == msg.data.uid) {
        if (kvm.state == "server") {
          window.vx_nav_callback("kvm_stop_server",{kid:kvm.id});
        } else {
          kvm_request_stop();
        }
      }
    }
    if (msg.data.k && msg.data.k == "user_joined" && msg.data.uid) {
      if (msg.data.ephidx !== undefined && msg.data.uid == vx.user.id) {
        vx.room.my_ephidx = msg.data.ephidx;
      }
    }
    if (msg.data.k && msg.data.k == "breakout") {
      vx_to_brk_room(vx,msg.data.n);
      vx.room.my_ephidx = msg.data.n;
      if (!vx.room.is_mod) {
        /* Show button bar to indicate breakout room change */
        cssmotion(null,1000);
      }
    }
  }

  if (!wss_isopen(vx)) {
    /* Likely mobile browser restore recovering */
    return;
  }
  let wssopt = {};
  /* limit might be 0 for very first query if we don't have layout
   *  from ctrl yet */
  wssopt.limit = vx.wall_info_nxt.limit || 16;
  vx.last_query_limit = wssopt.limit;
  if (!vx.st_browsing) {
    /* A little extra for pure moderator, offscreen presenters */
    wssopt.limit += 6; // OR SKIP???
    wssopt.aud_mode = true;
    wssopt.eph_strict = vx.room.eph_strict || false;
    wssopt.filt = vx.aud_filt;
    wssopt.start_idx = 0;
  } else {
    /* A little extra to allow auto to work (since prs/mod not shown) */
    wssopt.limit += 4;
    /* Audience mode accounts for pres/mod */
    wssopt.aud_mode = true;
    wssopt.eph_strict = vx.room.eph_strict || false;
    wssopt.filt = vx.aud_filt;
    wssopt.start_idx = (vx.st_page_idx-1) * (vx.wall_info_nxt.limit);
  }

  if (opt.immediate) {
    window.clearTimeout(vx.list_room_tid);
    delete vx.list_room_tid;
    vx.list_room_lastq = Date.now();
    wss_send(vx, "list_room", wssopt);
    /* 20min refresh */
    if (vx.refresh_room_tid) {
      window.clearTimeout(vx.refresh_room_tid);
    }
    vx.refresh_room_tid = setTimeout(handle_room, 1800*1000);
  } else if (!vx.list_room_tid) {
    /* Wait to aggregate */
    vx.list_room_tid = setTimeout(function() {
      delete vx.list_room_tid;
      wss_send(vx, "list_room", wssopt);
      /* 20min refresh */
      if (vx.refresh_room_tid) {
        window.clearTimeout(vx.refresh_room_tid);
      }
      vx.refresh_room_tid = setTimeout(handle_room, 1800*1000);
    }, 500);
  }
}

function get_room_stats() {
  if (!vx.room.is_mod || vx.room.adhoc) { return; }
  if (vx.room_stats_tid) { return; }
  delete vx.rstats;
  wss_send(vx, "list_room", { all: true, stats: true });
  vx.room_stats_tid = setInterval(function() {
    wss_send(vx, "list_room", { all: true, stats: true });
  }, 15*1000);
}

function update_room_state() {
  let c = {set_ctrl:{}};
  if (vx.room && vx.room.state) {
    c.set_ctrl.state = vx.room.state;
    wss_send(vx, "set_room_ctrl", c);
  }
}

function room_add_logo(el) {
  if (!vx || !vx.room) { return; }
  let x = document.createElement("img");
  x.src = vx.room.logo.url;
  x.classList.add("room-logo");
  el.appendChild(x);
}

function room_add_slate(el) {
  if (!vx || !vx.room) { return; }
  vx._slate = vx._slate || {};
  
  if (!vx._slate.el ||
      vx._slate.type != vx.room.slate.type ||
      vx._slate.url != vx.room.slate.url) {
    let url = vx.room.slate.url+"?random="+Math.trunc(Date.now()/10000);
    let x;
    if (vx.room.slate.type == "image") {
      x = document.createElement("img");
      x.src = url;
      x.classList.add("room-slate");
    } else if (vx.room.slate.type == "video") {
      x = document.createElement("video");
      x.src = url;
      x.setAttribute('playsinline', 'playsinline');
      x.loop = true;
      x.autoplay = true;
      x.classList.add("room-slate");
      //window.NSV_update({stop:true});
    } else if (vx.room.slate.type == "audio") {
      x = document.createElement("audio");
      x.src = url;
      x.setAttribute('playsinline', 'playsinline');
      x.loop = true;
      x.autoplay = true;
      x.classList.add("room-slate");
    }
    el.appendChild(x);
    vx._slate.el = x;
    vx._slate.type = vx.room.slate.type;
    vx._slate.url = vx.room.slate.url;
  } else {
    el.appendChild(vx._slate.el);
    vx._slate.el.style.display = "block";
    vx._slate.el.play && vx._slate.el.play();
  }
  if (vx.sw && !vx.st_unmute) {
    /* Wall is muted */
    room_mute_slate();
  }
}

function room_mute_slate() {
  let el = $(".room-slate")[0];
  if (!el) { return; }
  el.muted = true;
}

function room_unmute_slate() {
  let el = $(".room-slate")[0];
  if (!el) { return; }
  el.play && el.play();
  el.muted = false;
}

function room_play_slate() {
  let el = $(".room-slate")[0];
  if (!el) { return; }
  el.play && el.play();
}

function room_rem_slate() {
  if (vx.room && vx.room.slate && vx.room.slate.mode == "on") {
    let el = $(".room-slate")[0];
    if (!el) { return; }
    el.pause && el.pause();

    let body = document.getElementsByTagName("body")[0];
    el.style.display = "none";
    body.appendChild(el);
  } else {
    room_destroy_slate();
  }
  //window.NSV_update();
}

function room_destroy_slate() {
  let el = $(".room-slate")[0];
  if (el) {
    el.pause && el.pause();
    el.removeAttribute('src');
    el.load && el.load();
    el.remove();
  }
  delete vx._slate;
}

function getNumericStyleProperty(style, prop){
  return parseInt(style.getPropertyValue(prop),10) ;
}

function room_km_destroy() {
  if (!vx._km) { return; }
  Object.keys(vx._km).forEach(function(id) {
    let km = vx._km[id];
    km.wss.close();
    Object.keys(km.ptrs).forEach(function(name) {
      let ptr = km.ptrs[name];
      ptr.remove();
    });
    delete km.el;
    delete vx._km[id];
  });
  delete vx._km;
  delete vx._kmuids;
}

function room_km_create_ptr(km,is_self,rgb,uname) {
  let name = rgb;
  if (is_self) {
    name = "self";
  }
  let ptr = km.ptrs[name];
  if (!ptr) {
    /* Create a fake, small mouse pointer */
    ptr = document.createElement("div");
    ptr.style.position = "absolute";
    ptr.style["z-index"] = "10";
    if (is_self) {
      ptr.is_self = true;
      ptr.style.width = 0;
      ptr.style.height = 0;
      ptr.style["border-top"] = "10px solid transparent";
      ptr.style["border-bottom"] = "5px solid transparent";
      ptr.style["border-left"] = "10px solid white";
    } else {
      ptr.style.width = "6px";
      ptr.style.height = "6px";
      ptr.style.border = "1px solid black";
      ptr.style["border-radius"] = "50%";
    } 
    km.ptrs[name] = ptr;
    if (km.el) {
      km.el.insertBefore(ptr, km.el.firstChild);
    }
  }

  if (uname) {
    ptr.setAttribute("name",uname);
    ptr.classList.add("pointer-name");
  } else if (uname === false) {
    ptr.classList.remove("pointer-name");
  }

  if (rgb) {
    if (!ptr.is_self) {
      ptr.style["background-color"] = "rgb("+rgb+")";
      ptr.style["color"] = "rgb("+rgb+")";
    } else {
      ptr.style["border-left"] = "10px solid rgb("+rgb+")";
      //ptr.style["border-left"] = "10px solid green";
    }
  } else {
    //ptr.style["background-color"] = "white";
    ptr.style["color"] = "white";
  }
  return ptr;
}

function room_km_attach_ptrs(km) {
  if (!km.ptrs) { return; }
  if (!km.el) { return; }
  Object.keys(km.ptrs).forEach(function(name) {
    km.el.insertBefore(km.ptrs[name], km.el.firstChild);
    //km.el.appendChild(km.ptrs[name]);
  });
}

function room_km_remove_ptrs(km) {
  if (!km.ptrs) { return; }
  Object.keys(km.ptrs).forEach(function(name) {
    let ptr = km.ptrs[name];
    ptr.remove();
    delete km.ptrs[name];
  });
}

function room_km_move_ptr(ptr,x,y) {
  if (!ptr) { return; }
  if (!ptr.is_self) {
    ptr.style.transform = `translate3d(${x-1}px, ${y-1}px, 0)`;
  } else {
    ptr.style.transform = `translate3d(${x+3}px, ${y+3}px, 0)`;
  }
}

function room_km_attachdev(km) {
  //if (!km.el) { return; }
  //if (km.el.querySelector(".kminput")) {
  //  /* Already exists on this cell */
  //  console.log("kminput already exists");
  //  return;
  //}
  if (km.input) {
    km.input.remove();
    delete km.input;
  }
  if (km.info) {
    km.info.remove();
    delete km.info;
  }

  /* Create mouse/keyboard capture overlay */
  let keydown = {};
  let hidev = false;
  let allowpaste = true;
  let k = document.createElement("textarea");
  k.tabIndex = 0;//-1;
  k.style.position = "absolute";
  k.style.top = 0;
  k.style.left = 0;
  k.style.bottom = 0;
  k.style.right = 0;
  k.style.padding = 0;
  k.style.margin = 0;
  k.style.outline = 0;
  k.style.border = 0;
  k.style.color = "transparent";
  k.style.background = "transparent";
  k.style.resize = "none";
  k.style["z-index"] = 1000;
  k.style.cursor = "none";
  k.classList.add("kminput");
 
  /* Local menu disable */
  k.addEventListener('contextmenu', (ev) => {
    ev.preventDefault();
  });

  /* Mouse Move */
  k.addEventListener('mousemove', (ev) => {
    ev.stopPropagation();
    let msg = {};
    let rect = km.el.getBoundingClientRect();
    let x = (ev.clientX - Math.trunc(rect.left));
    let y = (ev.clientY - Math.trunc(rect.top));
    msg.type = "mmove";
    msg.xf = x / Math.trunc(rect.width-1);
    msg.yf = y / Math.trunc(rect.height-1);
    //console.log("mousemoveX", x, ev.clientX, rect.left, rect.width);
    //console.log("mousemoveY", y, ev.clientY, rect.top, rect.height);
    km.wss.mysend(msg);
    room_km_move_ptr(km.ptrs["self"],x,y);
  });

  /* Mouse buttons */
  k.addEventListener('mousedown', (ev) => {
    let msg = {};
    msg.type = "mbtn";
    msg.down = true;
    msg.btn = ev.button;
    //console.log(`mousedown ${msg.btn}`);
    km.wss.mysend(msg);
  });
  k.addEventListener('wheel', (ev) => {
    //console.log(`wheel m ${ev.deltaMode} dy ${ev.deltaY}`);
    if (ev.deltaY > 0) {
      km.wss.mysend({type:"mbtn",down:true,btn:4});
      km.wss.mysend({type:"mbtn",down:false,btn:4});
    } else {
      km.wss.mysend({type:"mbtn",down:true,btn:3});
      km.wss.mysend({type:"mbtn",down:false,btn:3});
    }
  });
  k.addEventListener('mouseup', (ev) => {
    let msg = {};
    msg.type = "mbtn";
    msg.down = false;
    msg.btn = ev.button;
    //console.log(`mouseup ${btn}`);
    km.wss.mysend(msg);
  });
  k.addEventListener('mouseenter', (ev) => {
    //console.log(`mouseenter`);
    keydown = {};
    allowpaste = true;
    km.wss.mysend({type:"resetkb"});
  });
  k.addEventListener('mouseleave', (ev) => {
    //console.log(`mouseleave`);
    km.wss.mysend({type:"resetkb"});
  });

  /* Keyboard */
  k.addEventListener('keydown', (ev) => {
    if (keydown[ev.code]) { return; }
    let msg = {};
    msg.type = "key";
    msg.down = true;
    msg.key = ev.code;
    if (ev.code == "MetaLeft") {
      msg.key = "ControlLeft";
    }

    if (allowpaste && ev.code == "KeyV" && ev.ctrlKey) {
      hidev = true;
      setTimeout(function() {
        if (vx && vx.debug) { console.log(`delay-ctrlv down`); }
        km.wss.mysend(msg);
        msg.down = false;
        km.wss.mysend(msg);
        hidev = false;
      },25);
    } else if (ev.code.indexOf("Key") == 0 && ev.metaKey) {
      if (allowpaste && ev.code == "KeyV") {
        /* Change meta+V => ctrl+V so paste works smoothly on Mac */
        hidev = true;
        setTimeout(function() {
          if (vx && vx.debug) { console.log(`delay-metav convert`); }
          km.wss.mysend({type:"key",down:true,key:"ControlLeft"});
          km.wss.mysend({type:"key",down:true,key:"KeyV"});
          km.wss.mysend({type:"key",down:false,key:"KeyV"});
          km.wss.mysend({type:"key",down:false,key:"ControlLeft"});
          hidev = false;
        },25);
      } else {
        /* On Mac, meta+key does not send 'keyup' for 'key' */
        if (vx && vx.debug) { console.log(`meta keydown ${msg.key}`); }
        ev.preventDefault();
        km.wss.mysend(msg);
        msg.down = false;
        km.wss.mysend(msg);
      }
    } else {
      ev.preventDefault();
      //console.log(`keydown ${msg.key}`);
      km.wss.mysend(msg);
      keydown[ev.code] = true;
    }
    k.value = "";
  });
  k.addEventListener('keyup', (ev) => {
    delete keydown[ev.code];
    let code = ev.code;
    let msg = {};
    if (ev.code == "KeyV" && hidev) {
      //console.log("hidev");
      return;
    }
    msg.type = "key";
    msg.down = false;
    msg.key = ev.code;
    if (ev.code == "MetaLeft") {
      msg.key = "ControlLeft";
    }
    //console.log(`keyup ${msg.key} ${k.value}`);
    km.wss.mysend(msg);
    k.value = "";
  });

  /* Paste */
  k.addEventListener('paste', (ev) => {
    //console.log("paste ev",ev);
    let cb = (ev.clipboardData || window.clipboardData);
    let txt = cb.getData('text');
    if (vx && vx.debug) { console.log("paste txt",txt); }
    if (txt.indexOf("https://") == 0) {
      let msg = {};
      msg.type = "command";
      msg.kind = "turl"
      msg.url = txt;
      km.wss.mysend(msg);
    } else {
      let msg = {};
      msg.type = "clipboard";
      msg.txt = txt;
      km.wss.mysend(msg);
    }
    k.value = "";
    allowpaste = false;
  });

  km.input = k;
  km.el.appendChild(k);

  km.info = document.createElement("div");
  km.info.classList.add("kminfo");
  km.info.innerHTML = 
    '<div class="ct_sdimage_saving"> Saving Config </div>' +
    '<div class="ct_sdimage_restoring"> Restoring </div>';
  km.el.appendChild(km.info);
  $(".ct_sdimage_saving").hide();
  $(".ct_sdimage_restoring").hide();
}

function room_km_build(km,el,port,secret) {
  km.el = el;

  setTimeout(function() {
    /* Override the usual tile border. Video needs to
       completely fill the slot or else mouse position tracking
       gets very complicated */
    km.el.style.border = "none";
  }, 1);

  km.ptrs = km.ptrs || {};

  if (km.attached) {
    /* Tile was rebuilt. Recreate mouse/keyboard capture if granted
     *   device control. */
    room_km_attachdev(km);
  }
  /* Reappend pointers on each redraw */
  room_km_attach_ptrs(km);

  /* Only recreate wss when needed */
  if (!km.wss || km.wss.readyState > 1) {
    room_km_remove_ptrs(km);
    km.port = port;
    km.secret = secret;
    km.downloads = [];
    km.wss = new WebSocket("wss://"+port+"/km?secret="+secret);
    km.wss.onopen = function () {
      //console.log("wss opened");
      let name = vx.user.dname.replace(/\s+/,"").slice(0,6);
      let cred = is_my_room(vx) ? vx.user.creds["myroom"] : vx.user.creds["me"];
      km.wss.mysend({type:"open",
                     name:name,
                     uid:vx.user.id,
                     cred:cred});
    }

    km.wss.onmessage = function (msg) {
      let j = to_json(msg.data);
      if (j.type == "mouse") {
        let rect = km.el.getBoundingClientRect();
        let x = j.xf * rect.width;
        let y = j.yf * rect.height;
        let rgb = j.rgb.join(",");
        //console.log("mouse",j.name,rgb,x,y);
        room_km_move_ptr(room_km_create_ptr(km, false, rgb, j.name), x, y);
      } else if (j.type == "mouse-self") {
        /* Signals client has been given device control */
        let rgb = j.rgb.join(",");
        room_km_attachdev(km);
        room_km_create_ptr(km, true, rgb, false);
        km.attached = true;
      } else if (j.type == "mouse-exit") {
        let rgb = j.rgb.join(",");
        if (km.ptrs[rgb]) {
          km.ptrs[rgb].remove();
          delete km.ptrs[rgb];
        }
      } else if (j.type == "mouse-exit-self") {
        if (km.ptrs["self"]) {
          km.ptrs["self"].remove();
          delete km.ptrs["self"];
        }
        if (km.input) {
          km.input.remove();
          delete km.input;
        }
        delete km.attached;
      } else if (j.type == "cfg") {
        if (vx && vx.debug) { console.log("cfg",msg.data); }
        if (j.amode) { km.amode = j.amode; }
        /* For now, uids should match across ALL kms */
        vx._kmuids = j.uids || [];
        let menu_km = room_get_kminfo(vx.selected_ct);
        if (menu_km && km.id == menu_km.id) {
          $(".ct_misc_btn_sdamode_mod").hide();
          $(".ct_misc_btn_sdamode_any").hide();
          $(".ct_misc_btn_sdamode_"+km.amode).show();
        }
      } else if (j.type == "image") {
        if (j.action == "saving") {
          $(".ct_sdimage_saving").show();
        } else if (j.action == "restoring") {
          $(".ct_sdimage_restoring").show();
        } else if (j.action == "none") {
          $(".ct_sdimage_saving").hide();
          $(".ct_sdimage_restoring").hide();
        }
      } else if (j.type == "downloads") {
        if (j.action == "list") {
          km.downloads = j.names || [];
          let menu_km = room_get_kminfo(vx.selected_ct);
          if (menu_km && km.id == menu_km.id) {
            updateMiscDownloads(vx.selected_ct, km);
          }
        }
      } else {
        console.warn("unhandled",msg.data);
      }
    }

    km.wss.onclose = function () {
      //console.log("wss closed");
      room_km_remove_ptrs(km);
      if (km.input) {
        km.input.remove();
        delete km.input;
      }
      km.attached = false;
    }

    km.wss.onerror = function (ev) {
      console.log("wss error:"+ev.type);
    }

    km.wss.mysend = function(msg) {
      if (km.wss.readyState != 1) { return; }
      if (msg.type == "command" && msg.url) {
        /* To avoid abuse, do not allow raw quotes */
        msg.url = msg.url.replace(/\"/g,"%22");
      }
      km.wss.send(JSON.stringify(msg));
    }
  } else {
    /* wss already opened. Update any state. */
    km.wss.mysend({type:"open",
                   is_joined:vx.room.is_joined || false,
                  });
  }
}

function room_get_kminfo(ct) {
  if (!ct) { return; }
  if (!ct.vt) { return; }
  if (!ct.vt.km) { return; }
  let [port,secret] = ct.vt.km.split(",");
  let id = secret; 
  if (!port || !secret || port == "undefined") { return; }
  return {id:id, port:port, secret:secret};
}

function room_get_km(ct) {
  let info = room_get_kminfo(ct);
  if (vx._km && info) {
    return vx._km[info.id];
  }
  return;
}

function room_send_all_kms(msg) {
  if (!vx._km) { return; }
  Object.keys(vx._km).forEach(function(id) {
    let km = vx._km[id];
    if (!km || !km.wss) { return; }
    km.wss.mysend(msg);
  });
}

function room_add_kmctrl(el,ct) {
  try {
    if (!vx || !vx.room) { return; }
    let info = room_get_kminfo(ct);
    if (!info) { return; }

    vx._km = vx._km || {};
    vx._km[info.id] = vx._km[info.id] || {id:info.id};
    room_km_build(vx._km[info.id], el, info.port, info.secret);
    vx._kmvisible ++;
  } catch(e) {
    console.log(e);
  }
}

function handle_room_ctrl(msg) {
  if (msg && msg.data && msg.data.event) {
    vx_nav_callback("eventid",msg.data.event.id);
  } else {
    vx_nav_callback("eventid","-");
  }
  if (msg && msg.data && msg.data.hide) {
    vx_nav_callback("hide", msg.data.hide);
  }

  if (msg.data.error == "error") {
    msg.data.src = "room_ctrl";
    msg.data.txt = "Something went wrong.";
    room_noaccess(msg.data);
    return;
  }
  if (msg.data.error == "denied") {
    msg.data.src = "room_ctrl";
    msg.data.check_meet = true;
    if (vx.room.auth_error) {
      msg.data.txt = vx.room.auth_error;
    }
    if (vx.room.auth_restart) {
      msg.data.restart = vx.room.auth_restart;
    }
    room_noaccess(msg.data);
    return;
  }
  if (!vx.room.can_view) {
    /* Need to start from the beginning and re-auth. User granted access
     * after showing up and can_view is stale. For added safety, wait 250ms
     * before starting fresh. */
    window.setTimeout(startFresh,250);
    return;
  }

  let device = window.vx_get_mydevice();
  if (vx_nav_callback) {
    vx_nav_callback("title", vx_full_room_name(vx,msg.data.dname));
  }
  if (vx.room) {
    let do_update = false;
    let do_refresh = false;
    vx.room.dname = msg.data.dname;
    vx.room.descr = msg.data.descr;
    vx.room.url = msg.data.url;
    vx.room.cat = msg.data.cat;
    vx.room.can_contact = msg.data.can_contact;
    vx.room.can_vmail = msg.data.can_vmail;
    vx.room.idle = msg.data.idle;
    vx.room.adhoc = msg.data.adhoc || false;
    vx.room.prsonly = msg.data.prsonly || false;
    if (vx.room.eph_strict !== undefined &&
        msg.data.eph_strict !== undefined &&
        vx.room.eph_strict != msg.data.eph_strict) {
      /* Show/Exclude main from breakouts changed */
      do_refresh = true;
    }
    vx.room.eph_strict = msg.data.eph_strict;

    let oldhide = vx.room.hide;
    if (!vx.room.is_mod) {
      vx.room.hide = msg.data.hide || [];
    } else {
      vx.room.hide = [];
    }
    vx.room.cast = msg.data.cast || {};
    vx.room.slate = {};
    vx.room.slate.url = msg.data.slate;
    vx.room.slate.type = "image";
    if (msg.data.slate_mime) {
      if (msg.data.slate_mime.match(/^video/)) {
        vx.room.slate.type = "video";
      } else if (msg.data.slate_mime.match(/^audio/)) {
        vx.room.slate.type = "audio";
      }
    }
    vx.room.logo = {};
    if (msg.data.rlogo && msg.data.rlogo != "-") {
      vx.room.logo.url = msg.data.rlogo;
    }
    if (msg.data.rback && msg.data.rback != "-") {
      vx.cb_room("bgimg", {url: msg.data.rback});
    }
    if (msg.data.rbannland && msg.data.rbannland != "-") {
      vx.cb_room("bannland", {url: msg.data.rbannland});
    }
    if (!vx.room.rec && msg.data.rec) {
      window.show_notification("This meeting is being recorded.","warning",8);
    }
    vx.room.rec = msg.data.rec;
    vx.room.auto_raise = vx.room.auto_raise || msg.data.auto_raise;
    if (!vx.room.is_mod && vx.room.privmode && !msg.data.privmode) {
      /* Turning off privmode */
      vx.cs_all.forEach(function(ct) {
        if (ct.orig_vt) {
          ct.vt = ct.orig_vt;
          delete ct.orig_vt;
          ct.mod_state = {};
        }
        if (ct.raw.orig_title) {
          ct.raw.title = ct.raw.orig_title;
        }
      });
      do_update = true;
    } else if (!vx.room.is_mod && !vx.room.privmode && msg.data.privmode) {
      /* Turning on privmode */
      vx.cs_all.forEach(function(ct) {
        if (ct.isSelf) { return; }
        if (!ct.roles || !ct.roles.is_mod) {
          ct.raw.orig_title = ct.raw.title;
          ct.raw.title = "";
        }
        if ((vx.room.is_first_raised && (!ct.roles || !ct.roles.is_mod)) ||
            (!vx.room.is_first_raised)) {
          ct.orig_vt = ct.vt;
          ct.vt = {};
          ct.mod_state = {blk:1};
        }
      });
      do_update = true;
    }
    vx.room.privmode = msg.data.privmode || false;

    if (vx.auto_open_panel && device.capture_state == "off") {
      vx_nav_callback("panel",true);
      vx.auto_open_panel = false;
    }

    if (vx.room.slate.url) {
      vx.room.slate.mode = msg.data.slate_mode || "off";
    }
    if (device.only_show_self) {
      vx.room.hide.push("search");
      vx.room.hide.push("audience!");
      vx.room.hide.push("auto");
      vx.room.hide.push("live");
    }
    vx_nav_callback("hide", vx.room.hide);
    if (!objsame(oldhide,msg.data.hide)) {
      createPanel();
    }

    vx.room.state = {};
    if ((typeof msg.data.state) == "string") {
      /* Temporary to convert old strings into maps */
      msg.data.state = {};
    }
    if (msg.data.state) {
      let prv_ac = vx.room.state.ac;
      let prv_prv = vx.room.state.prv;
      if (vx_nav_callback) {
        vx_nav_callback("setCtrl", msg.data);
      }
      vx.room.state = msg.data.state;
      if (vx.room.state.ac != prv_ac ||
          vx.room.state.prv != prv_prv) {
        do_update = true;
      }
      /* Defaults in case not set */
      if (!vx.room.state.pl) {
        vx.room.state.pl = vx.user.presLayouts[0].value;
      }
      if (!vx.room.state.al) {
        vx.room.state.al = vx.user.audLayouts[0].value;
      }
      /* room_configure_layout: if first time OR host changed room setup */
      if (room_configure_layout("ctrl", vx.room.state.pl, vx.room.state.al)) {
        do_update = true;
      }
      if (vx && vx.debug) { console.log("create: "+do_update+" "+JSON.stringify(vx.layouts)); }
    }
    if (vx.room.state.ac === undefined) {
      vx.room.state.ac = conf_modes[0].ac;
      vx.room.state.prv = conf_modes[0].prv;
    }
    vx.room.url = msg.data.url;
    vx.room.dname = msg.data.dname;
    vx.room.chat = msg.data.chat;    
    vx.room.eph_cnt = 0;
    if (msg.data.eph && msg.data.eph > 0) {
      vx.room.eph_cnt = msg.data.eph;
    }
    vx.room.eph_mode = msg.data.eph_mode || "open";
    if (vx.room.ephidx > vx.room.eph_cnt) {
      room_noaccess({
        src: "room_ctrl",
        txt:"Breakout room does not exist."
      });
      return;
    }

    if (vx.guestQuestion) {
      wss_send(vx, "msg_to", {
        msg: vx.guestQuestion,
        to:{ room: false },
      });
      vx.guestQuestion = null;
    }

    updateUIStates();
    if (!vx.sw) {
      createWall();
    } else if (do_refresh) {
      handle_room(null,{immediate:true});
    } else if (do_update) {
      wallFastRefresh();
      updateWall();
    }

    if (msg.data.anote_enabled) {
      window.wss_send_cb(vx, "get_ctrl_part", {
        field: {
          name: "arrival-notify",
        },
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.ok ||
            !msg.data.results) { return; }
        let r = msg.data.results[0];
        /* This is updated by this same msg.data for ctrl */
        r.val.can_msg = vx.room.can_contact || vx.room.can_vmail || false;
        vx.cb_room("config_notify", r.val);
      });
    }
  }
}

function play_dbell() {
  let x = document.getElementById("__dbell");
  if (!x) { return; }
  /* Don't interrupt already playing doorbell */
  if (!x.paused && !x.ended) {
    return;
  }
  x.src = vx_nav_callback("getasset","dbell");
  if (!x.src) { return; }
  x.play();
}

function handle_msg_to(msg) {
  if (msg && (msg.data == "denied" || msg.data == "error")) {
    return;
  }
  if (msg && msg.data) {
    /* "$<command>" Reserved for presenter commands */
    if (msg.data.y) {
      if (msg.data.y.sub == "arrival") {
        if (!vx_nav_callback("dbell_ok")) { return; }
        let at = msg.data.y.at;
        let rmtxt = "@"+at.split("/")[1];
        let nm = msg.data.xn;
        let txt = `${msg.data.xn} arrived ${rmtxt}.`;
        let btxt = "Pull Them In";
        let uni = msg.data.y.em;
        if (!msg.data.xn) {
          uni = msg.data.y.at;
          btxt = "Pull Next In";
          if (msg.data.y.waiting) {
            txt = `${msg.data.y.waiting} waiting ${rmtxt}.`;
          } else {
            txt = `Waiting in ${rmtxt}.`;
          }
        } else if (at == vx_only_full_room_name(vx)) {
          uni = msg.data.xn;
          btxt = "Let Them In";
          txt = `"${msg.data.xn}" is waiting outside.`;
        }
        window.vx_nav_callback("notify", {
          c:120, m:txt,
          v: "primary-outline", 
          extra:{uni:uni, btn:true, btnText:btxt,
                 btnArgs: {
                   tgt_uid: msg.data.x,
                   from_room: msg.data.y.at,
                   nm: nm,
                   exp: msg.data.y.expire,
                   sig: msg.data.y.sig,
                 },
                 btnAction:function(ev) {
                   wss_send_cb(vx, "transfer_pull", {
                     tgt_uid: ev.target.btnArgs.tgt_uid,
                     from_room: ev.target.btnArgs.from_room,
                     exp: ev.target.btnArgs.exp,
                     sig: ev.target.btnArgs.sig,
                   }, function(msg) {
                     let close_dialog = true;
                     if (msg.data.ok) {
                       // if (!ev.target.btnArgs.tgt_uid) {
                       //   /* Keep open if pull-next-from-room */
                       //   close_dialog = false;
                       // }
                     } else if (msg.data.errcode == "not-present") {
                       if (ev.target.btnArgs.nm) {
                         window.vx_nav_callback("notify", {
                           c:3, m:`${ev.target.btnArgs.nm} is no longer present.`});
                       } else {
                         window.vx_nav_callback("notify", {
                           c:3, m:`${ev.target.btnArgs.from_room} has no one left.`});
                       }
                     } else if (msg.data.errcode == "no-auth") {
                       window.vx_nav_callback("notify", {
                         c:3, m:`You are not authorized to pull from ${ev.target.btnArgs.from_room}.`});
                     } else if (msg.data.errcode == "expired") {
                       window.vx_nav_callback("notify", {
                         c:3, m:`Your authorization has expired for ${ev.target.btnArgs.from_room}.`});
                     } else if (msg.data.errcode == "retry") {
                       /* Don't warn. Let user click again */
                       close_dialog = false;
                     } else {
                       window.vx_nav_callback("notify", {
                         c:3, m:`${ev.target.btnArgs.from_room} pull failed.`});
                     }
                     if (close_dialog) {
                       window.vx_nav_callback("notify-close", {
                         id: ev.target.btnArgs.id});
                     }
                   });
                 } // btnAction
                }
        }); // notify
        play_dbell();
      }
    } else if (msg.data.t == "$open") {
    } else if (msg.data.t.indexOf("$kvm") == 0 ||
               msg.data.t.indexOf("+kvm") == 0) {
      kvm_request_rx(msg.data.f, msg.data.n, msg.data.t);
      return;
    } else if (msg.data.t.indexOf("+1on1") == 0) {
      request_1on1_rx(msg.data.f, msg.data.n, msg.data.t);
      return;
    } else if (msg.data.t.indexOf("$alert") == 0) {
      window.show_notification(msg.data.t.substring(6),"warning",4);
      return;
    } else if (msg.data.t.indexOf("$dial") == 0) {
      if (msg.data.f == vx.user.id) { return; }
      vx.cb_room && vx.cb_room("dial", {info:msg.data.t.substring(5)});
      do_mute();
      return;
    } else if (msg.data.t.indexOf("$doorbell") == 0) {
      /* Locally disabled via quick menu */
      if (!vx_nav_callback("dbell_ok")) { return; }
      play_dbell();
      return;
    }
  }

  let tgt_room = vx.room.main_room;
  if (msg) {
    if (msg.data.ephidx == 0 && msg.data.md) {
      tgt_room = vx.room.name;
    } else if (msg.data.ephidx) {
      tgt_room += "."+msg.data.ephidx;
    }
  }
  
  if (msg && msg.data && tgt_room == vx.room.name &&
      !msg.data.y) {
    if (!window.vx_nav_callback("is_open_chat", {acc:vx.room.acc, room:vx.room.name})) {
      $(".vxic-ch").attr("waiting","1");
      window.show_notification("You have new chat messages. Open chat below.","warning",2);
    } else {
      $(".vxic-ch").attr("waiting","0");
    }
  }
}

function visChanged() {
  if (vx && vx.debug) { console.log("hidden:"+document.hidden); }
  if (window.vx_get_mydevice().is_mobile) {
    do_mute();
    if (document.hidden) {
      vx.prv_hidden = true;
    } else if (vx.prv_hidden) {
      vx.cs_all = [];
      vx.st_page_idx = 1;
      delete vx.last_query_limit;
      delete vx.vid_ids;
      createWall();
      delete vx.prv_hidden;
    }
  }
}

function devChanged() {
  if (window.vx_get_mydevice().do_jackunplug) {
    do_mute_unmute();
  }
}

function roomKeyUp(e) {
  if (e.altKey) {
    if (!e.shiftKey && e.keyCode == 65/*a*/) {
      if (getAudioBlk(vx.room)) {
        updateUserState(vx.room, "blk", 0, true);
      } else {
        updateUserState(vx.room, "blk", 1, true);
      }
    } else if (!e.shiftKey && e.keyCode == 72 /*h*/) {
      window.vx_nav_callback("open_chat", {acc:vx.room.acc, room:vx.room.name});
    } else if (!e.shiftKey && e.keyCode == 89/*y*/) {
      if (!vx.room.is_mod) {
        if (vx.room.is_raised) {
          exit_line();
        } else {
          enter_line();
        }
      }
    } else if (e.shiftKey && e.keyCode == 77/*M*/) {
      if (vx.st_unmute) {
        do_mute();
      } else {
        do_unmute();
      }
    }
  }
}

function stop_playback() {
  if (vx.sw) {
    vx.sw.close();
    delete vx.sw;
    $(".vxelrm").remove();
  }
  vx.cs_all = [];
  vx.st_page_idx = 1;
  vx.wall_info_nxt = {};
  vx.wall_info_cur = {stitched_cnt:0,video_cnt:0,limit:0};
  delete vx.vid_ids;
  if (vx.refresh_room_tid) {
    window.clearTimeout(vx.refresh_room_tid);
    delete vx.refresh_room_tid;
  }
  vx.auto_open_panel = true;
}

function cleanup() {
  console.log("room cleanup");
  document.removeEventListener("visibilitychange", visChanged, false);
  navigator.mediaDevices.removeEventListener('devicechange', devChanged);
  document.removeEventListener("keyup", roomKeyUp, false);
  $("#room_wall").unbind("click");
  room_destroy_slate();
  room_km_destroy();

  vx_nav_callback("hide", []);
  vx_nav_callback("setAudMode", {enable:false});
  window.NSV_update({stop:true,cleanup:true});
  window.vx_nav_callback("unmute_cbs",{});
  window.vx_nav_callback("canTranscribe",false);
  window.stop_localloopback();
  if (vx.sw) {
    vx.sw.close();
    delete vx.sw;
    $(".vxelrm").remove();
  }
  if (vx.user) {
    vx.user.is_streaming = false;
  }
  vx.cs_all = [];
  vx.st_page_idx = 1;
  vx.wall_info_nxt = {};
  vx.wall_info_cur = {stitched_cnt:0,video_cnt:0,limit:0};
  delete vx.last_query_limit;
  delete vx.vid_ids;
  if (vx.refresh_room_tid) {
    window.clearTimeout(vx.refresh_room_tid);
    delete vx.refresh_room_tid;
  }
  if (vx.room_stats_tid) {
    window.clearTimeout(vx.room_stats_tid);
    delete vx.room_stats_tid;
  }
  if (vx.debug_tid) {
    window.clearTimeout(vx.debug_tid);
    delete vx.debug_tid;
  }
  if (vx.astate_tid) {
    window.clearTimeout(vx.astate_tid);
    delete vx.astate_tid;
  }

  vx_pvw_cancel();
  delete vx.vs_selected_cb;
  delete vx.help_queue;
  wss_clr_routes(window.vx,"room");
}

function cssmotion(ev,ms) {
  if (!vx.mmove_tid) {
    $(".panel").attr("isopen","prep");
    setTimeout(function() {
      $(".panel").attr("isopen","true");
    }, 1);
  }
  window.clearTimeout(vx.mmove_tid);
  vx.mmove_tid = setTimeout(function() {
    $(".panel").attr("isopen","false");
    delete vx.mmove_tid;
  }, (ms || 1000));
}

function cssanytouch(ev) {
  let jq = $(".panel");
  if (!jq) { return; }
  let v = jq.attr("isopen");
  if (!v || v == "false") {
    jq.attr("isopen","true");
  } else {
    jq.attr("isopen","false");
  }
}

function startFresh(cb_room) {
  let device = window.vx_get_mydevice();
  console.log("room startFresh");
  /* Not critical. Expedites cleanup */
  window.VuemixDashJS.timeout = 8000;
  vx.useWPlay = device.can_useWPlay;
  cleanup();

  if (vx.disable_live) { vx.rewind_delta = -5; }
  vx.vid_ids_refreshed = true;
  vx.aud_ids = [];
  delete vx.aud_filt;
  window.vx_nav_callback("unmute_cbs",{
    do_mute: do_mute,
    do_unmute: do_unmute,
  });
  window.vx_nav_callback("unmute",vx.st_unmute);
  /* Call aec workaround to restore pipeline in case 
   *  user muted (thus turning it off) when they 
   *  left some other room. This has no effect if
   *  the pipeline has never been initialized. */
  aec_workaround_on();

  delete vx.sw_1on1;
  vx.help_queue = [];
  window.vx_nav_callback("michide",false);
  vx.auto_open_panel = true;

  /* This will render whatever initial or left-over state we have */
  updateUIStates();

  document.addEventListener("visibilitychange", visChanged, false);
  navigator.mediaDevices.addEventListener('devicechange', devChanged);
  document.addEventListener("keyup", roomKeyUp, false);
  $("#room_wall").on("click", () => {
    room_play_slate();
  });
  visChanged();
  vx.cb_room = cb_room || vx.cb_room;
  if (vx.cb_room) {
    vx.cb_room("noaccess",{reset:true});
  }
  delete vx.room.detach;
  delete vx.room.is_joined;

  let opt = {};
  opt.acc = vx.room.acc;
  opt.room = vx.room.name;
  opt.uid = vx.user.id;
  opt.routes_id = "room";
  opt.routes = {};
  opt.routes["auth_me"] = function (msg) {
    if (!msg.data.error) {
      if (is_my_room(vx)) {
        wss_send(vx, "auth_room", {"cred":vx.user.creds["myroom"]});
      } else {
        wss_send(vx, "auth_room", {});
      }
    } else if (msg.data.error == "denied") {
      window.vx_signout_callback();
    } else {
      room_noaccess({
        src: "auth_me",
        txt: "Room does not exist."
      });
    }
  }
  opt.routes["auth_room"] = handle_auth_room;
  opt.routes["list_user"] = handle_list_user;
  opt.routes["bind_video"] = handle_bind_video;
  opt.routes["list_room"] = handle_list_room;
  opt.routes["join_room"] = handle_join_room;
  opt.routes["exit_room"] = handle_exit_room;
  opt.routes["raise_hand"] = handle_raise_hand;
  opt.routes["lower_hand"] = handle_lower_hand;
  opt.routes["room_ctrl"] = handle_room_ctrl;
  opt.routes["msg_to"] = handle_msg_to;
  opt.routes["room"] = handle_room;

  wss_open(vx, opt);
}

/****************************************************************************/


  /* ============================= ACTIONS ============================= */
  
function enter_line(userid) {
  if (!userid) {
    wss_send(vx, "raise_hand", {});
  } else {
    wss_send(vx, "raise_hand", {tgt_uid: userid});
  }
}
  
function exit_line(userid) {
  if (!userid) {
    wss_send(vx, "lower_hand", {});
  } else {
    wss_send(vx, "lower_hand", {tgt_uid: userid});
  }
}

function exit_all_line() {
  wss_send(vx, "lower_hand", {tgt_uid: "all"});
}

function join_group(userid) {
  if (!userid) {
    let opt = {};
    if (vx.room.auto_raise) {
      opt.raised = true;
      vx.room.auto_raise = false;
    }
    wss_send(vx, "join_room", opt);
  } else {
    wss_send(vx, "join_room", {tgt_uid: userid});
  }
}

function leave_group(userid,blklist) {
  if (!userid) {
    wss_send(vx, "exit_room", {});
  } else {
    wss_send(vx, "exit_room", {tgt_uid: userid, blklist:blklist});
  }
}

function room_transfer(val,force,cb) {
  let m, room;
  if (val.charAt(0) == '#') {
    val = val.replace(/[\(\)\s\-\.]/g, "");
    if (!(m = val.match(/#([0-9]+)/))) {
      console.log("Invalid phone number");
      cb({error:true});
      return;
    }
    /* Phone Number */
    let number = m[1];
    window.vx_nav_callback("past_phones",{cmd:"add",number:"#"+number});
    issue_http({
      type:"GET",
      contentType: "application/json",
      url: "//"+vx.subd+".vuemix.com/api/v2/remotestorage/sigwire",
      done: function(s,r) {
        let j = to_json(r);
        if (!j || !j.sigwire || !j.sigwire.token) {
          cb({error:true});
          return;
        }
        let msg = "";
        msg = "$dial "+JSON.stringify({
          id: j.sigwire.id,
          token: j.sigwire.token,
          number: number,
        });
        wss_send(vx, "msg_to", {msg:msg, to:{
          uid: vx.selected_ct.userid
        }, eph:true});
        cb({ok:true});
      }
    });
    return;
  }

  if (val.charAt(0) != '@') {
    val = '@' + val;
  }
  if ((m = val.match(/@([^\/]+\/[^\/]+)/))) {
    room = m[1];
  } else if ((m = val.match(/@([^\/]+)/))) {
    room = vx.room.acc+"/"+m[1];
  }
  let follow_transfer = false;
  if (room.indexOf("!") >= 0) {
    follow_transfer = true;
  }
  room = room.replace("!","");
  //val = val.replace("!","");
  wss_send_cb(vx, "transfer_room", {
    tgt_uid: vx.selected_ct.userid,
    to_room: room,
    force: force
  }, function(msg) {
    if (!msg || !msg.data || msg.data.error) {
      let e = "Unable to transfer user.";
      if (msg && msg.data && msg.data.error) {
        e += " ["+msg.data.error+"]";
      }
      window.vx_nav_callback("notify", {c:3, m:e});
      cb({error:true});
    } else {
      window.vx_nav_callback("past_rooms",{cmd:"add",name:val});
      if (msg.data.rv == "closed") {
        window.vx_nav_callback("notify", {c:3, m:`@${room} is not open.`});
        cb({canforce:true});
      } else {
        if (follow_transfer) {
          window.vx_nav_callback("goto_room", {room:room, auto_join:true});
        } else {
          cb({ok:true});
        }
      }
    }
  });
}

function btn_room_transfer(target, force) {
  let val = target.value;
  $(".ct_misc_btn_trntop").css("border","none");
  room_transfer(val,force,function(rv) {
    if (rv.ok) {
      target.value = "";
      $(".panel3").hide();
      $(".ct_misc_btn_trnf").hide();
      delete vx.selected_ct;
    } else if (!force && rv.canforce) {
      $(".ct_misc_btn_trntop").css("border","solid 2px red");
      $(".ct_misc_btn_trnf").show();
    } else {
      target.value = "";
      $(".ct_misc_btn_trnf").hide();
    }
  });
}

function btn_room_past(target, cb) {
  let val = target.value;
  let room;

  if (val.charAt(0) == '#') {
    cb(window.vx_nav_callback("past_phones",{cmd:"get"}) || []);
    return;
  }

  if ((m = val.match(/@([a-zA-Z0-9_-]+)/))) {
    room = m[1];
  }
  clearTimeout(vx.ros_tid);
  if (!room) {
    cb(window.vx_nav_callback("past_rooms",{cmd:"get"}) || []);
  } else if (room.length > 1) {
    vx.ros_tid = setTimeout(function() {
      window.wss_send_cb(window.vx, "ac_room_ctrl", {
        txt: room,
      }, function(msg) {
        if (!msg || !msg.data || !msg.data.rooms) { return; }
        let acRooms = [];
        msg.data.rooms.forEach(function(r) {
          acRooms.push("@"+r.room);
          });
        cb(acRooms);
      });
    }, 300);
  } else {
    cb([]);
  }
}

function set_focus(ct) {
  let c = { set_ctrl: {state:{}} };
  if (!vx.room || !vx.room.state) { return; }
  c.set_ctrl.state = vx.room.state;
  let base = vx.room.state.pl.split(".")[0];
  c.set_ctrl.state.pl = base+".0."+ct.userid;
  wss_send(vx, "set_room_ctrl", c);
}

function clr_focus() {
  let c = { set_ctrl: {state:{}} };
  c.set_ctrl.state = vx.room.state;
  let base = vx.room.state.pl.split(".")[0];
  c.set_ctrl.state.pl = base;
  wss_send(vx, "set_room_ctrl", c);
}

function toggle_pres(ct) {
  if (!vx.room.is_mod) { return; }
  if (ct.pres) {
    if (false && ct.roles && ct.roles.is_owner) {
      window.wss_send(window.vx, "raise_hand",
                      {tgt_uid: ct.userid, tgt_to:"mod"});
    } else {
      window.wss_send(window.vx, "lower_hand", {tgt_uid: ct.userid});
    }
  } else {
    window.wss_send(window.vx, "raise_hand", {tgt_uid: ct.userid, tgt_to:"prs"});
  }
}

function start_1on1_internal() {
  if (!vx.sw_1on1) { return; }
  console.log("accepted",JSON.stringify(vx.sw_1on1));
  vx.sw_1on1.state = "accepted";
  vx.st_layout = 1;
  vx.st_browsing = true;
  vx.st_page_idx = 1;
  vx.aud_filt = {name: vx.sw_1on1.dname};
  if (window.vx_get_mydevice().vt) {
    window.vx_get_mydevice().vt.priv = 1;
    update_user_assets();
  }
  handle_room(null,{immediate:true});
  updateUserState(vx.room, "blk", 1, true);
  window.vx_nav_callback("mic",false);
  window.vx_nav_callback("michide",true);
  /* Update layout and refresh user-to-tile mapping */
  wallFastRefresh();
  updateWall();  
}

function end_1on1_internal() {
  if (!vx.sw_1on1) { return; }
  window.vx_nav_callback("michide",false);
  if (vx.sw_1on1 && vx.sw_1on1.state == "accepted" && vx.aud_filt) {
    delete vx.aud_filt;
    vx.st_layout = 0;
    vx.st_browsing = false;
    vx.st_page_idx = 1;    
    if (window.vx_get_mydevice().vt) {
      window.vx_get_mydevice().vt.priv = 0;
      update_user_assets();
    }
    handle_room(null,{immediate:false});
    window.vx_nav_callback("notify",{c:2, m:"1-on-1 session ended"});
  } else if (vx.sw_1on1 && vx.sw_1on1.state == "requester") {
    window.vx_nav_callback("notify",{c:2, m:"Requested user is unavailable"});
  }
  delete vx.sw_1on1;
}

function request_1on1(ct) {
  if (vx.sw_1on1) {
    /* Already in 1on1 */
    return;
  }
  console.log("request_1on1");
  let msg = "+1on1 ";
  vx.sw_1on1 = {};
  vx.sw_1on1.state = "requester";
  vx.sw_1on1.uid = ct.userid;
  vx.sw_1on1.dname = ct.title;
  msg += JSON.stringify({c:"request"});
  wss_send(vx, "msg_to", {msg:msg, to:{uid:vx.sw_1on1.uid}, eph:true});
}

function accept_1on1() {
  if (!vx.sw_1on1) { return; }
  console.log("request_1on1");
  let msg = "+1on1 ";
  msg += JSON.stringify({c:"accept"});
  wss_send(vx, "msg_to", {msg:msg, to:{uid:vx.sw_1on1.uid}, eph:true});
  start_1on1_internal();
}

function reject_1on1() {
  if (!vx.sw_1on1) { return; }
  console.log("request_1on1");
  let msg = "+1on1 ";
  msg += JSON.stringify({c:"reject"});
  wss_send(vx, "msg_to", {msg:msg, to:{uid:vx.sw_1on1.uid}, eph:true});
  end_1on1_internal();
}

function request_1on1_rx(from, dname, msg) {
  if (!from || !msg) { return; }
  if (from == vx.user.id) { return; }
  console.log("request_1on1_rx",from,dname,msg);

  let k = to_json(msg.substring(5));
  if (k.c == "request") {
    if (vx.sw_1on1) {
      /* Auto reject. Already in 1on1 */
      let msg = "+1on1 ";
      msg += JSON.stringify({c:"reject"});
      wss_send(vx, "msg_to", {msg:msg, to:{uid:from}, eph:true});
      return;
    }
    vx.sw_1on1 = {};
    vx.sw_1on1.state = "requestee";
    vx.sw_1on1.uid = from;
    vx.sw_1on1.dname = dname;
    $(".ct_1on1_name").html(dname);
    $(".panel4").show();
  } else if (k.c == "accept") {
    if (!vx.sw_1on1) { return; } // no outstanding request
    if (vx.sw_1on1.uid != from) { return; } // not user requested
    start_1on1_internal();
  } else if (k.c == "reject") {
    if (!vx.sw_1on1) { return; } // no outstanding request
    if (vx.sw_1on1.uid != from) { return; } // not user requested
    end_1on1_internal();
  }
}

function kvm_btn_state() {
  if (!window.vx_get_mydevice().kvm_supported) { return; }
  let kvm = getLocal("vxkvm",true);
  $(".ct_panel_btn_kvmon").hide();
  if (!kvm) {
  } else {
    $(".ct_panel_"+kvm.uid).find(".ct_panel_btn_kvmon").show();
  }
}

function kvm_request_access(ct) {
  console.log("kvm_request_access");
  if (!vx.room.is_mod) { return; }
  let uid = ct.userid;
  let msg = "$kvm ";
  let kvm;
  kvm = getLocal("vxkvm",true);
  if (kvm && kvm.state) {
    console.log("kvm still active:"+kvm.state);
    return;
  }

  kvm = {};
  let ran = new Uint32Array(1);
  window.crypto.getRandomValues(ran);
  kvm.id = (((ran[0] % 1024) * 1048576) +
            Math.trunc((Date.now()/100) % (24*3600*10)));
  kvm.uid = uid;
  kvm.state = "access";
  console.log(JSON.stringify(kvm));
  setLocal("vxkvm",JSON.stringify(kvm));
  window.vx_nav_callback("kvm_start_client_rq");
  kvm_btn_state();
  msg += JSON.stringify({id:kvm.id, c:"access"});
  wss_send(vx, "msg_to", {msg:msg, to:{uid:kvm.uid}, eph:true});
}

function kvm_request_stop() {
  window.vx_nav_callback("kvm_stop_client",{cb: function() {
    kvm_btn_state();
  }});
}

function kvm_request_rx(from, dname, msg) {
  if (!from || !msg) { return; }
  if (from == vx.user.id) { return; }

  console.log("KVM:"+from+":"+dname+":"+msg);
  let k = to_json(msg.substring(4));
  if (!k.id) { return; }
  if (!k.c) { return; }
  let kvm = getLocal("vxkvm",true);

  if (k.c == "access") {
    if (kvm) {
      if (kvm.state != "server" || kvm.uid != from) {
        console.log("REJECTING "+kvm.state+" != server OR "+kvm.uid+" is not "+from);
        let c = {};
        c.msg = "+kvm "+JSON.stringify({id:k.id,c:"server_reject"});
        c.to = {uid:from};
        c.eph = true;
        wss_send(vx, "msg_to", c);
        return;
      } else {
        window.vx_nav_callback("kvm_stop_server",{kid:kvm.id});
        eraseLocal("vxkvm");
      }
    }
    window.vx_nav_callback("kvm_start_server", { kid:k.id, dn:dname, cb:function(id,rsp) {
      console.log("start_server_cb:"+rsp);
      if (rsp == "server_accept") {
        let kvm = {};
        kvm.id = id;
        kvm.uid = from;
        kvm.state = "server";
        setLocal("vxkvm",JSON.stringify(kvm));
      }
      let c = {};
      c.msg = "+kvm "+JSON.stringify({id:id,c:rsp});
      c.to = {uid:from};
      c.eph = true;
      wss_send(vx, "msg_to", c);
    }});
  } else {
    if (!kvm) {
      console.log("no outstanding request");
      return;
    }
    if (from != kvm.uid) {
      console.log("wrong user responding to exist kvm");
      return;
    }
    if (k.id != kvm.id) {
      console.log("kvm:not active or not ours "+k.id);
      return;
    }
    if (k.c == "server_reject") {
      window.vx_nav_callback("notify",
                             {c:10, m:"Your request was rejected"});
      kvm_request_stop();
    } else if (k.c == "server_unsupported") {
      window.vx_nav_callback("notify",
                             {c:10, m:"User's platform is unsupported"});
      kvm_request_stop();
    } else if (k.c == "server_accept") {
      window.vx_nav_callback("notify",{c:4, m:"Remote session accepted"});
      window.vx_nav_callback("kvm_start_client",{kid:kvm.id});
    } else if (k.c == "server_stop") {
      window.vx_nav_callback("notify",
                             {c:10, m:"Remote session ended."});
      kvm_request_stop();
    }
  }
}

  /* ============================= WALL ============================= */

function set_wall_attr(cls, attr, val) {
  $("."+cls).attr(attr,val);
}

function doRedraw() {
  if (vx && vx.debug) { console.log("REDRAW"); }
  window.stop_localloopback();
  room_rem_slate();
  if (vx.wall_info_cur) {
    if (vx && vx.debug) { console.log(vx.wall_info_cur.proto+" "+vx.wall_info_nxt.proto); }
    if ((576 * vx.wall_info_cur.ratio) <= 1024) {
      vx.sw.wall.width = 576 * (vx.wall_info_cur.ratio);
      vx.sw.wall.height = 576;
    } else {
      vx.sw.wall.width = 1024;
      vx.sw.wall.height = 1024 / (vx.wall_info_cur.ratio);
    }
    set_wall_attr("vxwport", "vxwrw", vx.sw.wall.width);
    set_wall_attr("vxwbase", "vxwrw", vx.sw.wall.width);
    set_wall_attr("vxwbase", "vxwrh", vx.sw.wall.height);
  } else {
    console.log("wall_info_cur not set");
  }
  updateUIStates();
  /* vx.sw.redraw now triggered in resize */
  delete vx.sw._width;
  delete vx.sw._height;
  vx.sw.resize();
  setTimeout(function() {
    $(".vxwport").css("font-weight","200");
  }, 250);
  setTimeout(function() {
    $(".vxwport").css("font-weight","inherit");
  }, 500);
}

function updateUIStates() {
  $(".header_segment_user").hide();
  $(".panel_btn").hide();
  $(".pg_panel").hide();
  if (!vx.st_login) {
    /* Should not really occur */
    return;
  }

  if (vx.sw && !vx.sw.st_unmute) {
    $("#bigmum").show();
  } else {
    $("#bigmum").hide();
  }

  $(".vxic-mubl").attr("alert","1");
  $("#ctrl_live").show();
  $("#ctrl_rewind").show();
  $("#abr_auto").show();
  $("#abr_audio").show();

  if (vx.room.is_mod && vx.room.state) {
    let ac = vx.room.state.ac;
    let prv = vx.room.state.prv || false;
    let found = false;
    conf_modes.forEach(function(m,i) {
      if (m.ac == ac && m.prv == prv) {
        $(".panel_btn_conf_"+i).show();
        found = true;
      }
    });
    if (!found) {
      $(".panel_btn_conf_0").show();
    }
    $(".panel_btn_exitall_q").show();
  }
  
  if (vx.room.is_joined) {
    $(".panel_btn_leave").show();
    btn_remove_help("panel_btn_join");
    /* Neither mod nor owner need to raise hands */
    if (!vx.room.is_mod) {
      if (vx.room.is_raised) {
        $(".panel_btn_exit_q").show();
      } else {
        $(".panel_btn_enter_q").show();
      }
    }
  } else if (vx.user && vx.user.is_streaming && vx.room.can_join) {
    $(".panel_btn_join").attr("disable",null).show();
    if (vx.room.auto_join) {
      btn_remove_help("panel_btn_join");
      vx.room.auto_join = false;
      join_group();
    } else {
      btn_queue_help("panel_btn_join");
    }
  } else {
    if (vx.user && vx.user.is_streaming) {
      /* Cannot join */
      $(".panel_btn_join").attr("disable","true").show();
    }
    btn_remove_help("panel_btn_join");
  }

  if (vx.st_layout == 1) {
    $(".panel_btn_mode_1").show();
  } else {
    $(".panel_btn_mode_0").show();
  }  
  if (vx.st_browsing && (!vx.sw_1on1 || vx.sw_1on1.state != "accepted")) {
    $(".pg_panel_first").attr("enabled", (vx.st_page_idx > 1)?"1":"0");
    $(".pg_panel_prev").attr("enabled", (vx.st_page_idx > 1)?"1":"0");
    $(".pg_panel_next").attr("enabled", "1");
    $(".pg_panel").show();
  }

  /* Primary call moved to list_user */
  /*
  if (!getAudioBlk(vx.room)) {
    window.vx_nav_callback("mic",true);
  } else {
    window.vx_nav_callback("mic",false);
  }
  */

  if (vx.room.is_mod && vx.user.can_mirror && window.vx_get_mydevice().start_mirror && window.vx_get_mydevice().multi_window) {
    $(".panel_btn_mirror").show();
  }
  if (vx.room.chat && vx.room.chat.mode == "disabled") {
    $(".panel_btn_chat").hide();
    btn_remove_help("panel_btn_chat");
    vx.chat_panel = false;
  } else {
    $(".panel_btn_chat").show();
    //btn_queue_help("panel_btn_chat");
  }

  update_panel_ephroom();

  if (vx.cb_room) {
    vx.cb_room("config_presence", {
      is_joined: vx.room.is_joined,
      is_detached: vx.room.detach,
      message_cb: function() {
        room_noaccess({
          dname: vx.room.dname,
          can_contact: vx.room.can_contact,
          can_vmail: vx.room.can_vmail,
          url: vx.room.url,
          rlogo: vx.room.rlogo,
          noa_msg: "Leave a message",
          init_state: "leavemsg",
        });
      }
    });
  }
}

/* "ct" might be content for SDK or vx.room */
function getAudioBlk(ct) {
  if (ct.self_state && ct.self_state.blk) {
    if (vx && vx.debug) { console.log("self audio blk=1 "+ct.self_state.blk); }
    return 1;
  }
  if (ct.mod_state && ct.mod_state.blk)  {
    if (vx && vx.debug) { console.log("mod audio blk=1 "+ct.mod_state.blk); }
    return 2;
  }
  return false;
}

/* "ct" might be content for SDK or vx.room */
function updateUserState(ct, key, val, onself) {
  if (ct.isSelf || (vx.room && vx.room.is_mod)) {
    let up = {};
    if (key == "blk" && !val && ct.detach) {
      return;
    }
    if (ct.isSelf) {
      up.tgt_uid = vx.user.id;
      if (ct.self_state[key] == val) {
        /* Special check for unmuting */
        if (val == 0 && ct.mod_state && ct.mod_state.blk) {
          window.vx_nav_callback("notify",
             {c:3, m:"Moderator muted you. You cannot unmute."});
        }
        return;
      }
      ct.self_state[key] = val;
      if (onself) {
        vx.cs_all.forEach(function(x) {
          if (x.isSelf) {
            x.self_state[key] = val;
          }
        });
      }
      up.state = ct.self_state;
    } else {
      up.tgt_uid = ct.userid;
      if (ct.mod_state[key] == val) {
        return;
      }
      ct.mod_state[key] = val;
      if (onself) {
        vx.cs_all.forEach(function(x) {
          if (x.isSelf) {
            x.mod_state[key] = val;
          }
        });
      }
      up.state = ct.mod_state;
    }
    updateWall();
    wss_send(vx, "update_user_state", up);
  }
}

function update_audios(auds) {
  auds = auds || [];
  vx.aud_ids = vx.aud_ids || [];
  /* Limit to 16 */
  auds = auds.slice(0,16);

  if (!vx.aud_ids) {
    vx.aud_ids = auds;
  } else {
    vx.aud_ids.forEach(function(id,idx) {
      if (auds.includes(id)) {
        /* Keep it */
        //console.log("audio keep "+idx+" "+id);
        auds = auds.filter(i => i != id);
      } else if (vx.aud_ids[idx]) {
        /* No longer wanted */
        //console.log("audio clr  "+idx+" "+id);
        vx.aud_ids[idx] = "";
      }
    });
    /* Fill anything new into gaps */
    let i = 0;
    auds.forEach(function(add_id) {
      while (i < vx.aud_ids.length && vx.aud_ids[i]) { i++; }
      //console.log("audio new  "+i+" "+add_id);
      vx.aud_ids[i] = add_id;
      i++;
    });
  }

  /* Create abuf for max. Expand to full 16 so
   *  setFocus is ready for more tracks */
  while (vx.aud_ids.length < 16) {
    vx.aud_ids.push("");
  }

  /* Find last real id for the request */
  let last = 0;
  vx.aud_ids.forEach(function(id,idx) {
    if (id) { last = idx+1; }
  });
  /* Keep as an array, even if an array of 1 */
  if (last < 1) { last = 1; }

  //vx.aud_stm_id_seq = encodeURIComponent(vx.aud_ids.slice(0,last).join(","));
  vx.aud_ids = vx.aud_ids.slice(0,last);
  vx.aud_stm_id_seq = encodeURIComponent(vx.aud_ids.join(","));
  //console.log("AUDIO RQ: "+last+" "+vx.aud_stm_id_seq);
  //console.log("AUDIO ID: "+vx.aud_ids.length+" "+JSON.stringify(vx.aud_ids));

  if (vx.st_unmute && !vx.sw.st_unmute) {
    vx.sw.setFocus(vx.aud_ids);
    vx.sw.st_unmute = vx.st_unmute;
    window.vx_nav_callback("unmute",vx.st_unmute);
  }
}

function updateWall() {
  if (!vx.sw) {
    console.log("updateWall: no wall");
    return;
  }
  if (!vx.wall_info_nxt || !vx.wall_info_nxt.video_cnt) {
    console.log("updateWall: wall_info not set");
    return;
  }
  vx.sw.wall.lo.pages = vx.wall_info_nxt.pages;
  $(".vxwplayerview").css(vx.wall_info_nxt.css);

  if (vx && vx.debug) {
    console.log("updateWall: update "+vx.wall_info_nxt.video_cnt+" "+
                vx.wall_info_nxt.stitched_cnt+" "+
                vx.layouts[vx.st_layout].focus_uid);
  }
  let qna_order;
  let audience_cnt;
  let vid_ids = [], aud_ids = [], audioCtrlMode = 0;
  let pt_ids = [];
  if (vx.room && vx.room.state) {
    audioCtrlMode = vx.room.state.ac;
  }
  
  /* Set 'role' for CSS use */
  qna_order = audience_cnt = 0;
  for (let i = 0; i < vx.cs_all.length; i ++) {
    let ct = vx.cs_all[i];
    //console.log("ct "+i+" "+JSON.stringify(ct));
    if (ct.pres) {
      if (!ct.vt || !ct.vt.km) {
        ct.role="pres";
      }
    } else if (ct.mod) {
      /* Nothing */
    } else {
      audience_cnt ++;
      if (ct.qna) {
        qna_order ++;
        ct.role="qna";
        ct.order=""+qna_order;
        if (ct.isSelf) {
          $(".panel_btn_exit_q").attr("order", ""+qna_order);
          if (vx.room.is_raised_pos != qna_order) {
            let suf = ["","st","nd","rd","th"][Math.min(qna_order,4)];
            let txt = `You are ${qna_order}${suf} in line`;
            if (qna_order > 1 && vx.room.privmode) {
              txt += ". You will see and hear the host once you are first in line.";
            }
            window.vx_nav_callback("notify",{v:"info", c:5, m:txt});
          }
          vx.room.is_raised_pos = qna_order;
        }
      } else {
        ct.role="etc";
      }
    }
  }

  let cs = [];
  let self_shown = false;
  let max = vx.wall_info_nxt.video_cnt;
  let focus_uid = vx.layouts[vx.st_layout].focus_uid;
  let acnt = vx.layouts[vx.st_layout].acnt;
  //let focus_pos = vx.layouts[vx.st_layout].focus_pos;
  if (vx.st_browsing) {
    /* Audience browsing mode
     */
    $(".pg_panel_curr").empty().html(""+(vx.st_page_idx));

    for (let i = 0; i < vx.cs_all.length; i++) {
      let ct = vx.cs_all[i];
      delete ct.consider_for_audio;
      if (!ct.vt || (!ct.vt.sm && !ct.vt.lg) || ct.vt.off) {
        ct.ao = true;
      } else {
        ct.ao = false;
      }
      if (vx.sw_1on1 && vx.sw_1on1.state == "accepted") {
        if (!ct.isSelf && ct.userid != vx.sw_1on1.uid) {
          /* 1-on-1 is self and one other person */
          continue;
        }
        //if (!ct.isSelf) {
        //  /* Never for self; Always hear other audio. Audio state is always
        //   *  muted when in 1on1 so we force it on here. */
        //  aud_ids.push(ct.streamingID);
        //}
      } else {
        /* Not in a 1on1. Thumbnail only for those marked priv */
        if (ct.vt && ct.vt.priv) {
          ct.ao = true;
        }
      }
      ct.consider_for_audio = true;
      if (/*ct.pres || */ct.mod) {
        continue;
      }
      cs.push(ct);
      vx.sw.addToContentMap(ct);
      if (ct.isSelf) { self_shown = true; }
      if (cs.length >= max) {
        break;
      }
    }
    if (vx.sw_1on1 && vx.sw_1on1.state == "accepted") {
      if (!self_shown && vx.user &&
          vx.localloopback && vx.localloopback.active) {
        let parts = vx.user.vid.split(":");
        let new_ct = new VuemixSDK.DataObject.VideoData({
          title: "",
          type: "video",
          epoch: parts[1],
          enc_video_id: parts[0],
          id: vx.user.vdbid,
        });
        new_ct.vt = window.vx_get_mydevice().vt;
        new_ct.isSelf = true;
        cs.push(new_ct);
        vx.sw.addToContentMap(new_ct);
        self_shown = true;
      }
      if (!cs.length || cs.length < 2) {
        /* Cannot be alone. If other user is gone, end 1on1 */
        reject_1on1();
      }
    }

  } else {
    /* Presentation mode
     */
    let slots = [];

    // Setup video slots
    for (let vi=0; vi<max; vi++) {
      let s = {};
      let cell = vx.sw.currPageCell(vi);
      s.cs = vx.dummy_ct[vi];
      s.is_empty = true;
      s.str = "";
      if (cell && cell.prototype == "vidPT") {
        if (vx.layouts[0].ly != "6_aonly") {
          s.for_pres = true;
        }
        s.is_ptonly = true;
        s.is_lg = true;
        s.str += "P";
      }
      if (cell && cell.prototype == "vidLG") {
        s.is_lg = true;
        s.str += "L";
      }
      if (cell && cell.prototype == "vidSM") {
        s.is_sm = true;
        s.str += "S";
      }
      if (vx.room.prsonly) {
        s.for_pres = true;
      }
      slots[vi] = s;
    }
    if (vx.room.slate && vx.room.slate.mode == "on" && vx.room.ephidx == 0) {
      slots[0].for_pres = true;
    }

    // Fill Video Slots
    for (let i=0; i < vx.cs_all.length; i++) {
      let ct = vx.cs_all[i];
      delete ct.consider_for_audio;
      /* Moderators are not visible (audio only) */
      if (ct.mod) {
        ct.consider_for_audio = true;
        continue;
      }
      if (focus_uid && ct.userid != focus_uid) {
        /* Skip over any due to "focus" */
        if (ct.pres) {
          ct.consider_for_audio = true;
        }
        continue;
      }

      /* Assign to slot or slots */
      let vi;
      let repeat_small = false;
      for (vi=0; vi<max; vi++) {
        let s = slots[vi];
        if (!s.is_empty) { continue; }
        /* Ignore any panelist restrictions if using focus */
        if (!focus_uid && s.for_pres && !ct.pres) { continue; }
        ct.consider_for_audio = true;
        s.cs = ct;
        s.is_empty = false;
        vx.sw.addToContentMap(ct);
        //console.log("filling "+vi+" "+ct.id+" lg "+s.str+" ss "+ct.ss);
        //console.log("filling vt",s.is_ptonly,JSON.stringify(ct.vt));
        ct.title = ct.raw.title;
        ct.ao = false;
        if (ct.vt.priv || ct.vt.off) {
          /* 1on1 people should be in audience view so
           * self/1on1 check is not required. No 'priv' should be seen
           * in host view. */
          ct.ao = true;
        } else if (s.is_ptonly) {
          if (!ct.vt || !ct.vt.pt) {
            ct.ao = true;
          }
        } else if (s.is_lg) {
          if (!ct.vt || (!ct.vt.sm && !ct.vt.pt)) {
            ct.ao = true;
          }
        } else if (!ct.vt || !ct.vt.sm) {
          ct.ao = true;
        }
        delete ct.__second;
        if (ct.isSelf) { self_shown = true; }
        /* Show screenshare in lg, camera in sm for viewers */
        if (!ct.isSelf && s.is_lg && ct.ss && ct.ss != "-" &&
            ct.ss != "s+ao" && ct.vt && ct.vt.pt) {
          repeat_small = true;
        }
        break;
      }
      if (vi >= max) {
        /* No room; not placed */
        /* Allow off screen presenters. 
           Allow anyone offscreen if videos were restricted
           to less than acnt (and not focusing) */
        if (ct.pres || (!focus_uid && vi < acnt)) {
          ct.consider_for_audio = true;
        }
      }
      if (repeat_small) {
        /* First subsequent empty small */
        for (vi++; vi<max; vi++) {
          let s = slots[vi];
          if (!s.is_empty) { continue; }
          if (s.is_lg) { continue; }
          let new_ct = new VuemixSDK.DataObject.VideoData({
            title: ct.raw.title,
            type: "video",
            epoch: ct.raw.epoch,
            enc_video_id: ct.raw.enc_video_id,
            id: ct.id+".2",
          });
          s.cs = new_ct;
          s.is_empty = false;
          vx.sw.addToContentMap(new_ct);
          ct.title = ct.raw.title+" (Share)";
          ct.__second = new_ct;
          new_ct.is_second = true;
          //console.log("filling sm "+new_ct.id);
          //console.log(new_ct);
          break;
        }
      }
    }

    slots.forEach(function(s) {
      cs.push(s.cs);
    });
  } /* pres mode */

  while (cs.length < max) {
    cs.push(vx.dummy_ct[cs.length]);
  }

  /* Process visible videos to determine loopback / mosaic / PT */
  let device = window.vx_get_mydevice();
  /* Maximum number of PTs per view */
  let pt_limit = device.pt_can_play;
  let when_required = (pt_limit == 1);
  for (let i = 0; i < cs.length; i++) {
    let stm_id = cs[i].streamingID;
    let cell = vx.sw.currPageCell(i);
    if (cell) {
      cell.content = cs[i].loid;
    }
    cs[i].ispt = false;
    delete cs[i].aud;
    if (!stm_id || stm_id == "r.0:0") {
      if (!cell || cell.prototype != "vidPT") {
        vid_ids.push("");
      }
      continue;
    }

    if (cs[i].isSelf && vx.localloopback && vx.localloopback.active) {
      /* Shows local loopback. No need to request server video */
      if (!cell || cell.prototype != "vidPT") {
        vid_ids.push("r.0:0");
      }
    } else if (cs[i].ao) {
      /* Audio only does not need to show video */
      if (!cell || cell.prototype != "vidPT") {
        vid_ids.push("r.0:0");
      }
    } else if (when_required && pt_limit > 0 &&
               cs[i].vt && cs[i].vt.pt && cell &&
               (cell.prototype == "vidPT" ||
                cs.length == 1)) {
      /* Use single PT playback only if 
         (1) The slot only accepts a PT (i.e. big presenter)
         (2) There is only one slot (i.e. 1x1 focus)
      */
      pt_limit --;
      cs[i].ispt = true;
      if (!cell || cell.prototype != "vidPT") {
        vid_ids.push("r.0:0");
      }
      pt_ids.push(stm_id);
    } else if (!when_required && pt_limit > 0 &&
               cs[i].vt && cs[i].vt.pt && cell &&
               (cell.prototype == "vidLG" ||
                cell.prototype == "vidPT")) {
      /* Use PT video instead of mosaic */
      pt_limit --;
      cs[i].ispt = true;
      if (!cell || cell.prototype != "vidPT") {
        vid_ids.push("r.0:0");
      }
      pt_ids.push(stm_id);
    } else {
      /* Use tile; Assuming consistent cell/tile ordering */
      if (!cell || cell.prototype != "vidPT") {
        vid_ids.push(stm_id);
      }
    }
  }
  //console.log("VIDS:"+JSON.stringify(vid_ids));
  //console.log("PTDS:"+JSON.stringify(pt_ids));

  /* Loop over participants and decide which can be heard */
  let canTranscribeSelf = false;
  qna_order = audience_cnt = 0;
  for (let j=0; j<vx.cs_all.length; j++) {
    let ct = vx.cs_all[j];
    let audAllowed = true;

    if (vx.sw_1on1 && vx.sw_1on1.state == "accepted") {
      /* Only self and partner; Ignore mute status */
      if (!ct.isSelf && ct.userid != vx.sw_1on1.uid) {
        audAllowed = false;
      }
    } else if (!ct.consider_for_audio) {
      audAllowed = false;
    } else {
      /* Regular / non-1on1 */
      if (getAudioBlk(ct) || ct.detach) {
        // audio was individually muted
        audAllowed = false;
      }
      if (!ct.pres && !ct.mod) {
        if (audioCtrlMode > 0) {
          /* pres + qna(N) audio */
          if (ct.qna) {
            if (audioCtrlMode <= qna_order) { audAllowed = false; }
            qna_order ++;
          } else {
            audAllowed = false;
          }
        } else if (audioCtrlMode < 0) {
          /* pres + audience(N) audio */
          if (-audioCtrlMode <= audience_cnt) { audAllowed = false; }
          audience_cnt ++;
        } else { // pres only audio
          audAllowed = false;
        }
      }
    }
    if (ct.isSelf) {
      canTranscribeSelf = audAllowed;
      if (vx.sw_1on1 && vx.sw_1on1.state == "accepted") {
        canTranscribeSelf = false;
      }
    }

    /* We set the 'aud' attribute somewhat more broadly than actual
       audio. The intent for 'aud' (which controls css badge) is
       whether or not OTHERS can hear you -- i.e. you can be heard */
    let aud = (audAllowed?"true":"false");
    for (let i = 0; i < cs.length; i++) {
      /* Find matching cell and set 'aud' */
      if (cs[i].id != ct.id) { continue; }
      if (cs[i].is_second) { continue; }
      if (cs[i].__second) {
        /* Show audio indicator only on second (it's the camera) */
        cs[i].__second.aud = aud;
        cs[i].aud = "none";
      } else if (!ct.detach) {
        cs[i].aud = aud;
      } else {
        cs[i].aud = "detach";
      }
      break;
    }

    if (audAllowed && (vx.st_always_hear_me || !ct.isSelf)) {
      let stm_id = ct.streamingID;
      aud_ids.push(stm_id);
      if (vx && vx.debug) { console.log(`AUDIO${j} selected, id ${ct.id}, tt ${ct.title}`); }
    } else {
      if (vx && vx.debug) { console.log(`AUDIO${j} excluded, id ${ct.id}, tt ${ct.title}`); }
    }
  }
  //console.log("AUDS:"+JSON.stringify(aud_ids));

  window.vx_nav_callback("canTranscribe",canTranscribeSelf);
  update_audios(aud_ids);
  vx.redraw_next_chunk = true;
  /* The vid_id's cnt does not have to match streaming profile. It
   *   will be trimmed/padded as needed. */
  vx.pt_ids = pt_ids;
  vx.vid_ids = vid_ids;
  vx.vid_ids_refreshed = true;

  if (vx.useWPlay) {
    if (vx.dbg_vidstm) {
      if (vx && vx.debug) {
        console.log("Update video stream as needed");
        console.log("profile:",vx.wall_info_cur.vp, vx.wall_info_nxt.vp);
        console.log("query:",vx.last_query_limit,vx.wall_info_nxt.limit);
      }
      let cmd = "";
      cmd = "video_profile="+vx.wall_info_nxt.vp+"&";
      if (!vx.last_query_limit ||
          vx.wall_info_nxt.limit > vx.last_query_limit) {
        handle_room(null,{immediate:true});
      }
      vx.wall_info_cur = vx.wall_info_nxt;

      vx.stm_id_seq = "";
      for (let i=0; i<vx.wall_info_nxt.stitched_cnt; i++) {
        if (i != 0) {
          vx.stm_id_seq += ",";
        }
        if (vx.vid_ids && vx.vid_ids[i]) {
          vx.stm_id_seq += vx.vid_ids[i];
        }
      }
      if (vx.pt_ids.length) {
        for (let i=0; i<vx.pt_ids.length; i++) {
          if (vx.stm_id_seq != "") {
            vx.stm_id_seq += ",";
          }
          vx.stm_id_seq += vx.pt_ids[i];
        }
      }
      if (vx && vx.debug) { console.log("ids:",vx.stm_id_seq); }
      if (document.hidden || vx.user_vmode == 4) {
        cmd = ("video_profile=16&video=&ptcnt=0");
      } else {
        cmd += "video="+vx.stm_id_seq+"&";
        cmd += "ptcnt="+vx.pt_ids.length+"&";
      }
      if (vx.user.dname) { cmd += "&dname="+vx.user.dname.replace(/\s+/,""); }
      if (vx && vx.debug) { console.log("update video",cmd); }
      vx.dbg_vidstm.parent.cmd(cmd);
      let redelay = 500;
      //if (vx.current_vbuf) { redelay += vx.current_vbuf; }
      //console.log("redraw vbuf ",vx.current_vbuf,redelay);
      setTimeout(doRedraw, redelay);
    }
    if (vx.dbg_audstm) {
      let cmd = "";
      if (vx && vx.debug) {
        console.log("Update audio stream as needed");
        console.log("ids:",vx.aud_stm_id_seq);
      }
      cmd = "audio="+vx.aud_ids.join(",");
      if (vx.user.dname) { cmd += "&dname="+vx.user.dname.replace(/\s+/,""); }
      vx.dbg_audstm.parent.cmd(cmd);
    }
  } /* useWPlay */

  if (vx && vx.debug) { console.log("Update: done"); }
}

  function onPageChange(wall, pgi, npg) {
    if (vx && vx.debug) { console.log("onPageChange"); }
    createPanel();

    /* Sometimes list_room responds before the initial wall is created
     *  If there room is non-empty, update here because list_room's will
     *  have failed */
    if (vx.cs_all && vx.cs_all.length) {
      if (vx && vx.debug) { console.log("prelayout update:"+vx.cs_all.length); }
      setTimeout(updateWall,1);
    }
  }

function build1on1Modal($el) {
  let h = "";
  h += '<div class="panel4 vxelrm">';
  h += ('<div class="ct_1on1_label">'+
        '<span class="ct_1on1_name"> </span>'+
        '<span> has requested a one-on-one video chat. </span>'+
        '</div>');
  h += ('<div class="ct_1on1_label ct_1on1_accept">'+
        "Accept their request."+
        '</div>');
  h += ('<div class="ct_1on1_label ct_1on1_deny">'+
        "Ignore it."+
        '</div>');
  h += '<div>';
  if (h) {
    $el.append(h);
  }

  $(".panel4").hide();
  $(".ct_1on1_accept").on("click", () => {
    $(".panel4").hide();
    accept_1on1();
  });
  $(".ct_1on1_deny").on("click", () => {
    $(".panel4").hide();
    reject_1on1();
  });
}

  function clicktouch(jq,cb) {
    if (!jq || !jq[0]) { return; }
    jq.on("click", (ev) => {
      let now = Date.now();
      if (jq[0].actms && (now - jq[0].actms) < 500) {
        //console.log("click SKIP");
      } else {
        //console.log("click",(now - jq[0].actms));
        jq[0].actms = Date.now();
        cb && cb(ev);
      }
    });
    jq[0].addEventListener('touchend', function(ev) {
      let now = Date.now();
      let changedTouch = ev.changedTouches[0];
      let chel = document.elementFromPoint(changedTouch.clientX,
                                           changedTouch.clientY);
      if (chel && ev.target != chel) {
        /* Finger moved between initial touch and release. Ignore
           the selection. */
        //console.log("touch moved");
        return;
      }
      if (jq[0].actms && (now - jq[0].actms) < 500) {
        //console.log("touch SKIP");
      } else {
        //console.log("touch",(now - jq[0].actms));
        jq[0].actms = Date.now();
        cb && cb(ev);
      }
    });
  }

  function buildMiscPanel($el) {
    let h = "";
    h += '<div class="panel3 vxelrm">';

    h += ('<div class="ct_misc_label ct_misc_sep">'+
          '<span class="ct_misc_name"> </span>'+
          '<span style="float:right;color:rgb(150,50,50);font-weight:bold;"> X </span>'+
          '</div>');
    /* BUTTON: Mic */
    h += ('<div class="ct_misc_btn ct_misc_btn_block_aud">'+
          "Mute Their Mic"+
          '</div>' +
          '<div class="ct_misc_btn ct_misc_btn_unblock_aud">'+
          "Unmute Their Mic"+
          '</div>');
    h += ('<div class="ct_misc_label ct_misc_btn_selfblock_aud">'+
          "User Muted Themself (You Cannot Unmute)"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_block_sdaud">'+
          "Mute The Desktop"+
          '</div>' +
          '<div class="ct_misc_btn ct_misc_btn_unblock_sdaud">'+
          "Unmute The Desktop"+
          '</div>');
    /* BUTTON: Focus */
    h += ('<div class="ct_misc_btn ct_misc_btn_focus1">'+
          "Focus on Participant"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_focus2">'+
          "Remove Focus"+
          '</div>');
    /* BUTTON: Panelist */
    h += ('<div class="ct_misc_btn ct_misc_btn_swap1">'+
          "Make Them a Panelist"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_swap2">'+
          "Return Panelist to Audience"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_swaptop">'+
          "Bring Panelist to Top"+
          '</div>');
    /* BUTTON: Transfer */
    h += ('<div class="ct_misc_btn ct_misc_btn_trntop">'+
          '<table style="width:100%"><td><input type="text" autocapitalize="off" autocomplete="new-password" autocorrect="off" list="autocompleteOff" name="hidden" class="ct_misc_btn_transfer"'+
          ' placeholder="Transfer @room or #phone"'+
          '></input></td><td><button class="ct_misc_btn_trnf">Send Anyway</button></td></table><div id="trans-pastrooms"></div></div>');
    /* BUTTON: Exit */
    h += ('<div class="ct_misc_btn ct_misc_btn_exit">'+
          "End user participation but allow to watch"+
          '</div>');
    /* BUTTON: Eject */
    h += ('<div class="ct_misc_btn ct_misc_btn_eject">'+
          "Permanently Eject From Room"+
          '</div>');
    /* BUTTON: KVM */
    h += ('<div class="ct_misc_btn ct_misc_btn_kvmrq">'+
          "Request Remote Access"+
          '</div>');
    /* BUTTON: Breakout */
    h += ('<div class="ct_misc_btn ct_misc_btn_mybrk">'+
          'Send User to Your Breakout ('+
          '<span class="ct_misc_btn_mybrk_num"></span>)'+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_2main">'+
          "Send User to Main Room"+
          '</div>');
    /* BUTTON: 1-on-1 */
    h += ('<div class="ct_misc_btn ct_misc_btn_1on1">'+
          "Request 1-to-1 video chat"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_1on1_stop">'+
          "End 1-to-1 video chat"+
          '</div>');
    /* BUTTON: Shared Desktop */
    h += ('<input type="text" autocapitalize="off" autocomplete="new-password" autocorrect="off" list="autocompleteOff" name="hidden" class="ct_misc_btn_sdurl" placeholder="Open URL"></input>');
    //h += ('<input type="text" autocapitalize="off" autocomplete="new-password" autocorrect="off" list="autocompleteOff" name="hidden" class="ct_misc_btn_sdkiosk" placeholder="Open URL as Kiosk"></input>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdadd_uid">'+
          "Allow user to Control Key/Mouse"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdrem_uid">'+
          "Revoke user's Control of Key/Mouse"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdamode_mod">'+
          "Only Moderators Control Key/Mouse"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdamode_any">'+
          "All Participants Control Key/Mouse"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdsave">'+
          "Save Config"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdrestore" imageid="1">'+
          "Restore Saved Config"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sdrestore" imageid="0">'+
          "Restore Base Config"+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sddwn0">'+
          '<div id="sddwn0"></div> '+
          '<div class="ct_misc_btn_sddwnk0">DELETE</div>'+
          '</div>');
    h += ('<div class="ct_misc_btn ct_misc_btn_sddwn1">'+
          '<div id="sddwn1"></div> '+
          '<div class="ct_misc_btn_sddwnk1">DELETE</div>'+
          '</div>');
    h += '<div>';
    if (h) {
      $el.append(h);
    }

    $(".panel3").hide();
    $(".ct_misc_btn_trnf").hide();

    /* BUTTON: Focus */
    clicktouch($(".ct_misc_btn_focus1"), () => {
      set_focus(vx.selected_ct);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_focus2"), () => {
      clr_focus();
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: Panelist */
    clicktouch($(".ct_misc_btn_swap1"), () => {
      toggle_pres(vx.selected_ct);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_swaptop"), () => {
      window.wss_send(window.vx, "raise_hand",
                      {tgt_uid: vx.selected_ct.userid, tgt_to:"prs"});
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_swap2"), () => {
      toggle_pres(vx.selected_ct);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: Mic */
    clicktouch($(".ct_misc_btn_block_aud"), () => {
      updateUserState(vx.selected_ct, "blk", 1);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_unblock_aud"), () => {
      updateUserState(vx.selected_ct, "blk", 0);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_block_sdaud"), () => {
      updateUserState(vx.selected_ct, "blk", 1);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_unblock_sdaud"), () => {
      updateUserState(vx.selected_ct, "blk", 0);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: Transfer (change) */
    $(".ct_misc_btn_transfer").on("keyup", (ev) => {
      $(".ct_misc_btn_trnf").hide();
      let past;
      if (ev.key == "Enter" || ev.keyCode == 13) {
        if (!ev.target || !ev.target.value) { return; }
        btn_room_transfer(ev.target);
      } else {
        btn_room_past(ev.target, function(past) {
          let h = "";
          past.forEach(function(p) {
            h += "<span class='trans-past' room='"+p+"'>"+p+"</span>";
          });
          $("#trans-pastrooms").html(h);
          clicktouch($(".trans-past"), (xev) => {
            let value = xev.target.getAttribute("room");
            let target = $(".ct_misc_btn_transfer")[0];
            if (target) {
              target.value = value;
              target.focus();
              $("#trans-pastrooms").html("");
            }
          });
        });
      }
    });
    clicktouch($(".ct_misc_btn_trnf"), (ev) => {
      let target = $(".ct_misc_btn_transfer")[0];
      btn_room_transfer(target,true);
    });
    /* BUTTON: Eject (click) */
    clicktouch($(".ct_misc_btn_exit"), () => {
      leave_group(vx.selected_ct.userid);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    $(".ct_misc_btn_eject").on("click", () => {
      leave_group(vx.selected_ct.userid,true);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: KVM (click) */
    clicktouch($(".ct_misc_btn_kvmrq"), () => {
      kvm_request_access(vx.selected_ct);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: Breakout (click) */
    clicktouch($(".ct_misc_btn_mybrk"), () => {
      wss_send(vx, "move_to_brk", {tgt_uid: vx.selected_ct.userid,
                                   tgt_ephidx:"self"});
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_2main"), () => {
      wss_send(vx, "move_to_brk", {tgt_uid: vx.selected_ct.userid,
                                   tgt_ephidx:0});
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: 1-on-1 */
    clicktouch($(".ct_misc_btn_1on1"), () => {
      request_1on1(vx.selected_ct);
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_1on1_stop"), () => {
      reject_1on1();
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    /* BUTTON: Shared Desktop */
    $(".ct_misc_btn_sdurl").on("keyup", (ev) => {
      if (ev.key == "Enter" || ev.keyCode == 13) {
        let val = $(".ct_misc_btn_sdurl")[0].value;
        if (!val) { return; }
        if (val.indexOf("http") < 0) {
          val = "https://" + val;
        }
        let info = room_get_kminfo(vx.selected_ct);
        if (info) {
          let km = vx._km[info.id];
          if (km && km.wss) {
            km.wss.mysend({type:"command", kind:"appurl",
                           url:val});
          }
        }
        $(".panel3").hide();
        delete vx.selected_ct;
      }
    });
    clicktouch($(".ct_misc_btn_sdamode_mod"), () => {
      let km = room_get_km(vx.selected_ct);
      if (km && km.wss) {
        km.wss.mysend({type:"command", kind:"cfg",
                       amode: "any"});
      }
    });
    clicktouch($(".ct_misc_btn_sdamode_any"), () => {
      let km = room_get_km(vx.selected_ct);
      if (km && km.wss) {
        km.wss.mysend({type:"command", kind:"cfg",
                       amode:"mod"});
      }
    });
    clicktouch($(".ct_misc_btn_sdsave"), () => {
      let km = room_get_km(vx.selected_ct);
      let imageid = "1";
      if (km && km.wss) {
        window.wss_send_cb(window.vx, "shared_desktop", {
          cfg: {
            cmd: "save",
            id: imageid,
            indom: "",
          }
        }, function(msg) {
          km.wss.mysend({type:"command", kind:"save",
                         id:imageid,
                         url:msg.data.saveto});
          $(".panel3").hide();
          delete vx.selected_ct;
        });
      }
    });
    clicktouch($(".ct_misc_btn_sdrestore"), (ev) => {
      let km = room_get_km(vx.selected_ct);
      let imageid = ev.target.getAttribute("imageid");
      if (km && km.wss) {
        window.wss_send_cb(window.vx, "shared_desktop", {
          cfg: {
            cmd: "restore",
            id: imageid,
            indom: "",
          }
        }, function(msg) {
          km.wss.mysend({type:"command", kind:"restore",
                         id:imageid,
                         url:msg.data.getfrom});
          $(".panel3").hide();
          delete vx.selected_ct;
        });
      }
    });
    clicktouch($(".ct_misc_btn_sdadd_uid"), () => {
      room_send_all_kms({type:"command", kind:"cfg",
                         adduid:vx.selected_ct.userid});
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_sdrem_uid"), () => {
      room_send_all_kms({type:"command", kind:"cfg",
                         remuid:vx.selected_ct.userid});
      $(".panel3").hide();
      delete vx.selected_ct;
    });
    clicktouch($(".ct_misc_btn_sddwnk0"), () => {
      let km = room_get_km(vx.selected_ct);
      if (km && km.wss) {
        km.wss.mysend({type:"command", kind:"downdel",
                       file:km.downloads[0]});
        km.downloads.splice(0,1);
      }
      $(".ct_misc_btn_sddwn0").hide();
    });
    clicktouch($(".ct_misc_btn_sddwnk1"), () => {
      let km = room_get_km(vx.selected_ct);
      if (km && km.wss) {
        km.wss.mysend({type:"command", kind:"downdel",
                       file:km.downloads[1]});
        km.downloads.splice(1,1);
      }
      $(".ct_misc_btn_sddwn1").hide();
    });

    /* LABELS */
    clicktouch($(".ct_misc_label"), () => {
      $(".panel3").hide();
      delete vx.selected_ct;
    });
  }

  function updateMiscDownloads(ct,km) {
    $(".ct_misc_btn_sddwn0").hide();
    $(".ct_misc_btn_sddwn1").hide();
    for (let i=0; km.downloads && i < km.downloads.length && i<2; ++i) {
      let url= `https://${km.port}/kmd/${km.downloads[i]}?secret=${km.secret}`;
      $("#sddwn"+i).html(
        '<a href="'+url+'" download>'+km.downloads[i]+'</a>'
      );
      $(".ct_misc_btn_sddwn"+i).show();
    }
  }

  function onMiscClick(ct) {
    if (!ct || vx.selected_ct == ct) {
      delete vx.selected_ct;
      $(".panel3").hide();
      return;
    }
    vx.selected_ct = ct;

    $(".ct_misc_btn_focus1").hide();
    $(".ct_misc_btn_focus2").hide();
    $(".ct_misc_btn_swap1").hide();
    $(".ct_misc_btn_swaptop").hide();
    $(".ct_misc_btn_swap2").hide();
    $(".ct_misc_btn_selfblock_aud").hide();
    $(".ct_misc_btn_block_aud").hide();
    $(".ct_misc_btn_unblock_aud").hide();
    $(".ct_misc_btn_block_sdaud").hide();
    $(".ct_misc_btn_unblock_sdaud").hide();
    $(".ct_misc_btn_trntop").hide();
    $(".ct_misc_btn_exit").hide();
    $(".ct_misc_btn_eject").hide();
    $(".ct_misc_btn_kvmrq").hide();
    $(".ct_misc_btn_mybrk").hide();
    $(".ct_misc_btn_2main").hide();
    $(".ct_misc_btn_1on1").hide();
    $(".ct_misc_btn_1on1_stop").hide();
    $(".ct_misc_btn_sdurl").hide();
    $(".ct_misc_btn_sdkiosk").hide();
    $(".ct_misc_btn_sdadd_uid").hide();
    $(".ct_misc_btn_sdrem_uid").hide();
    $(".ct_misc_btn_sdamode_mod").hide();
    $(".ct_misc_btn_sdamode_any").hide();
    $(".ct_misc_btn_sdsave").hide();
    $(".ct_misc_btn_sdrestore").hide();
    $(".ct_misc_btn_sddwn0").hide();
    $(".ct_misc_btn_sddwn1").hide();

    if (ct && ct.role) {
      $(".ct_misc_name").html(ct.title);
      if (vx.room.is_mod) {
        /* BUTTON: Focus */
        if (vx.layouts[0] &&
            vx.layouts[0].focus_uid) {
          $(".ct_misc_btn_focus2").show();
        } else {
          /* Only modify panelist state when not in focus
           *   to avoid confusion. */
          $(".ct_misc_btn_focus1").show();
          /* BUTTON: Panelist */
          if (!ct.pres) {
            $(".ct_misc_btn_swap1").show();
          } else {
            if (true || ct.idx != 0) {
              $(".ct_misc_btn_swaptop").show();
            }
            $(".ct_misc_btn_swap2").show();
          }
        }
        if (!ct.isSelf) {
          if (window.vx_get_mydevice().kvm_supported) {
            let kvm = getLocal("vxkvm",true);
            if (!kvm) {
              $(".ct_misc_btn_kvmrq").show();
            }
          }
          if (!vx.room.ephidx) {
            if (vx.room.my_ephidx) {
              $(".ct_misc_btn_mybrk_num").html("#"+vx.room.my_ephidx);
              $(".ct_misc_btn_mybrk").show();
            }
          } else {
            $(".ct_misc_btn_2main").show();
          }
        }
      }
      if (vx.room.is_mod && !ct.pres) {
        if (getAudioBlk(ct) == 1) {
          $(".ct_misc_btn_selfblock_aud").show();
        } else if (getAudioBlk(ct) == 2) {
          $(".ct_misc_btn_unblock_aud").show();
        } else {
          $(".ct_misc_btn_block_aud").show();
        }
      }
      if (vx.room.is_mod && (!ct.roles || !ct.roles.is_mod) && !ct.detach) {
        $(".ct_misc_btn_trntop").show();
        if (vx._kmvisible) {
          /* For now, uids should match across ALL kms */
          if (!vx._kmuids || !vx._kmuids.includes(ct.userid)) {
            $(".ct_misc_btn_sdadd_uid").show();
          } else {
            $(".ct_misc_btn_sdrem_uid").show();
          }
        }
      }
      if (vx.room.is_mod && !ct.pres && (!ct.roles || !ct.roles.is_mod)) {
        if (vx.room.cast && vx.room.cast.handle) {
           $(".ct_misc_btn_exit").show();
        }
        $(".ct_misc_btn_eject").show();
      }
      if (vx.room.is_joined && !ct.isSelf) {
        if (!vx.sw_1on1) {
          $(".ct_misc_btn_1on1").show();
        }
      }
      if (vx.sw_1on1) {
        $(".ct_misc_btn_1on1_stop").show();
      }
    } else if (ct && ct.vt && ct.vt.km) {
        $(".ct_misc_name").html("Shared Desktop");
      if (vx.room.is_mod) {
        let km = room_get_km(ct);
        $(".ct_misc_btn_sdurl").show();
        $(".ct_misc_btn_sdamode_"+km.amode).show();
        $(".ct_misc_btn_sdsave").show();
        $(".ct_misc_btn_sdrestore").show();
        if (getAudioBlk(ct) == 2) {
          $(".ct_misc_btn_unblock_sdaud").show();
        } else {
          $(".ct_misc_btn_block_sdaud").show();
        }
        updateMiscDownloads(ct, km);
      }
    }
    $(".panel3").show();
  }

  function onCreateCell(wall, cidx, $cell, pageDelta) {
    var ct = wall.currPageCellContent(cidx);
    let h = '';
    let ss_ct = null;
    let ss_local = window.vx_get_mydevice().ss_local;
    let ss_is_new = false;
    if (ct && ct.ss && ct.ss != "-") {
      ss_ct = ct;
      ss_is_new = ct.ss_is_new;
      ct.ss_is_new = false;
    }
    if (ct.vt && ct.vt.km) {
      if (cidx == 0) {
        vx._kmvisible = 0;
      }
      room_add_kmctrl($cell[0],ct);
    }

    if (cidx == 0) {
      if (ct.vt && ct.vt.km) {
        /* Don't use slate, logo, etc. on top of KM */
      } else if ((vx.room && vx.room.logo && vx.room.logo.url) &&
                 !vx.aud_filt) {
        room_add_logo($cell[0]);
      }
      if (ct.id == "__dummyct_0" &&
          (vx.room && vx.room.slate && vx.room.slate.mode == "on") &&
          vx.room.ephidx == 0 && !vx.aud_filt) {
        room_add_slate($cell[0]);
      } else {
        room_destroy_slate();
      }
      /* Moderator can share in slot0 */
      if (!vx.st_browsing && !ss_ct &&
          vx.room && vx.room.mod_ct &&
          vx.room.mod_ct.ss && vx.room.mod_ct.ss != "-") {
        ss_ct = vx.room.mod_ct;
        ss_is_new = vx.room.mod_ct.ss_is_new;
        vx.room.mod_ct.ss_is_new = false;
      }
      if (!vx.st_browsing && ss_ct && !ss_local && !vx.room.ephidx) {
        /* For zero, follow slot */
        ss_ct = {userid:"slot0",ss:"slot0",pres:true};
      }
    }

    if ((ct && ct.role && (!ct.isSelf || vx.room.is_mod || vx.sw_1on1)) ||
        (ct && ct.vt && ct.vt.km && vx.room.is_mod)) {
      /* BUTTON: Misc */
      h += ('<div class="ct_panel_btn ct_panel_btn_misc" style="color:white;">'+
            svg_misc("Actions")+
            '</div>');
    }

    if (ct && ct.role) {
      if (vx.room.is_mod) {
        if (!ct.isSelf) {
          /* BUTTON: KVM */
          h += ('<div class="ct_panel_btn_always ct_panel_btn_kvmon" style="display:none">'+
                svg_kvm_on("End remote access")+
                '</div>');
        }
      }
      if (vx.room.is_mod && !ct.pres) {
        /* BUTTON: Hand */
        h += ('<div class="ct_panel_btn ct_panel_btn_exit_q">'+
              svg_hand_raised("Lower Their Hand") +
              '</div>' +
              '<div class="ct_panel_btn ct_panel_btn_enter_q">'+
              svg_hand_down("Raise Their Hand") +
              '</div>');
      }
    }

    if (h != "") {
      let ctp = "";
      if (ct.userid) { ctp = "ct_panel_"+ct.userid; }
      $cell.append('<div class="ct_panel '+ctp+'">'+h+'</div>');
    }
    clicktouch($cell.find(".ct_panel_btn_misc"), () => {
      onMiscClick(ct);
    });

    if (ct && ct.role) {
      /* BUTTON: Hand (hide) */
      if (ct.qna) { 
        $cell.find(".ct_panel_btn_enter_q").hide();
      } else {
        $cell.find(".ct_panel_btn_exit_q").hide();
      }
      /* BUTTON: KVM (click) */
      clicktouch($cell.find(".ct_panel_btn_kvmon"), () => {
        kvm_request_stop();
      });
      /* BUTTON: Hand (click) */
      clicktouch($cell.find(".ct_panel_btn_enter_q"), () => {
        enter_line(ct.userid);
      });
      clicktouch($cell.find(".ct_panel_btn_exit_q"), () => {
        exit_line(ct.userid);
      });
    }

    if (ct.isSelf && !ct.ao && vx.localloopback && vx.localloopback.active) {
      window.start_localloopback($cell);
    } else if (ct.ispt) {
      let stm_id = ct.streamingID;
      if (vx.dbg_vidstm) {
        //let el = vx.dbg_vidstm.parent.get_pt_element(stm_id);
        let pt = vx.dbg_vidstm.parent.get_pt(stm_id);
        if (pt && pt.el) {
          $cell[0].appendChild(pt.real_el);
          pt.play();
        }
      }
    }

    if (ct) {
      $cell.append('<div class="turtle material-icons cell'+cidx+'">error_outline</div>');
      $cell.append('<div class="aonly aonly'+cidx+'"> Audio Only </div>');
      //if (!vx.audio_only) { $(".aonly").hide(); }
    }

    let tnclass = "vxwcvimg_"+cidx;
    $("."+tnclass).on("error", function(e) {
      let n = e.target.parentNode;
      let cls = e.target.getAttribute("class") || "";
      let style = "";
      cls = cls.replace(tnclass,"");
      //console.log("CELL tn "+cidx+" failed to load");
      if (e.target.style && e.target.style.display) {
        style = "display: "+e.target.style.display+";";
      }
      let str = "";
      let title = ct.raw.title || ct.raw.orig_title;
      if (title) {
        let parts = title.split(" ");
        if (parts[0]) { str += parts[0].substring(0,1) + "."; }
        if (parts[2]) {
          str += parts[2].substring(0,1) + ".";
        } else if (parts[1]) {
          str += parts[1].substring(0,1) + ".";
        }
      }
      n.innerHTML = '<div style="width:100%;height:100%;background-color:black;'+style+'"><div class="aoplaceholder '+cls+'">'+str+'</div></div>';
    });
  }
  
function prelayout(sw, pageTemplates, cs) {
  let cells = pageTemplates && pageTemplates[0] && pageTemplates[0].cells;  
  cs.splice(0, cs.length);
  vx.dummy_ct.forEach(function(c,idx) {
    cs.vxAddContent(vx.dummy_ct[idx]);
  });
  if (vx && vx.debug) { console.log("prelayout done "+cs.length); }
}

function update_panel_ephroom() {
  if (!vx.room.eph_cnt || !vx.room.eph_show) {
    $(".panel2_btn_brk").hide();
    return;
  }

  let cur_room = window.vx_only_full_room_name(window.vx);
  let parts = cur_room.split(".");
  let main_room = parts[0];
  let cur_idx = parts[1] || 0;
  let value = vx.prv_ephidx || "";
  if (cur_idx > 0) { vx.prv_ephidx = value = cur_idx; }
  
  if (vx.room.eph_mode == "open" || vx.room.is_mod) {
    if (cur_idx == 0) {
      $("#brkmain").attr("picked","true");
      $("#brkgo").attr("picked","false")
    } else {
      $("#brkmain").attr("picked","false");
      $("#brkgo").attr("picked","true");
    }
    $("#brkinput").attr("value",value);
    $(".panel2_btn_brk").show();
  } else {
    if (cur_idx == 0) {
      $("#nbrkmain").show();
    } else {
      $("#nbrkgo").html("Brk "+cur_idx).show();
    }
  }

}

function update_panel_abr() {
  if (vx.actual_video_mode == vx.vmode) {
    return;
  }
  vx.actual_video_mode = vx.vmode;
  $(".panel_btn_abr").attr("at","false");
  $(".panel_btn_abri").attr("at","false");
  switch (vx.actual_video_mode) {
  case 1: $("#abr_max").attr("at","true"); break;
  case 2: $("#abr_med").attr("at","true"); break;
  case 3: $("#abr_low").attr("at","true"); break;
  case 4: $("#abr_audio").attr("at","true"); break;
  }
}

function URLaux(url) {
  let avd = 0;
  let vbuf = vx.current_vbuf || 0;
  let abuf = vx.current_abuf || 0;
  let le = vx.current_le || 0;
  let at = vx.current_at || 0;
  if (vx.avd) { avd=vx.avd; }
  url = url + "&zw="+encodeURIComponent(vx.user.dname)+"&zp="+vbuf+","+abuf+","+le+"&zat="+at+"&zavd="+avd+"&zvm="+vx.vmode;
  if (vx.dbg_vidstm) { 
    let s = vx.dbg_vidstm;
    let dqz = s.dataq_size().join(":");
    url = url + "&zdv="+dqz+";"+s.pushing_data+","+s.removing_data+","+s.enough_buffered;
    if (s.end_idx && s.cur_idx) {
      url += ","+(s.end_idx - s.cur_idx);
    }
  }
  if (vx.dbg_audstm) {
    let s = vx.dbg_audstm;
    let dqz = s.dataq_size().join(":");      
    url = url + "&zda="+dqz+";"+s.pushing_data+","+s.removing_data+","+s.enough_buffered;
    if (s.end_idx && s.cur_idx) {
      url += ","+(s.end_idx - s.cur_idx);
    }
  }
  return url;
}

function aec_workaroundinit() {
  let inputStream;
  VuemixSDK.getAudioCtx();
  VuemixSDK.getAudioStreamDest().stream;
  vx.aec = vx.aec || {};

  vx.aec.an = $("#__tmprtcaudio")[0];
  if (!vx.aec.an) {
    vx.aec.an = document.createElement("audio");
    vx.aec.an.muted = false;
    vx.aec.an.id = "__tmprtcaudio";
    vx.aec.an.controls = true;
    vx.aec.an.style="position:absolute;top:150px;left:10px;width:200px;height:30px;z-index:1000;visibility:hidden;"
    let body = document.getElementsByTagName("body")[0];
    body.append(vx.aec.an);
  }
}

function aec_workaround_off() {
  if (!vx.aec) return;
  if (vx.aec.rtcConn) {
    vx.aec.rtcConn.close();
    vx.aec.rtcConn = null;
  }
  if (vx.aec.rtcLoop) {
    vx.aec.rtcLoop.close();
    vx.aec.rtcLoop = null;
  }
  if (vx.aec.loopbackStream) {
    vx.aec.loopbackStream = null;
  }
  if (vx.aec.an) {
    vx.aec.an.srcObject = null;
  }
}

function aec_workaround_on() {
  if (!vx.aec) return;
  let inputStream;
  let opt = {};
  if (navigator && navigator.platform && navigator.platform.match(/^Win/)) {
    opt.noise = true;
  }
  inputStream = VuemixSDK.getAudioStreamDest(opt).stream;

  aec_workaround_off();

  // this is the stream you will read from for actual audio output
  vx.aec.loopbackStream = new MediaStream();

  const offerOptions = {
    offerVideo: true,
    offerAudio: true,
    offerToReceiveAudio: false,
    offerToReceiveVideo: false,
  };
  let offer, answer;
  vx.aec.rtcConn = new RTCPeerConnection();
  vx.aec.rtcLoop = new RTCPeerConnection();

  vx.aec.rtcConn.onicecandidate = e =>
    e.candidate && vx.aec.rtcLoop.addIceCandidate(new RTCIceCandidate(e.candidate));

  vx.aec.rtcLoop.onicecandidate = e =>
    e.candidate && vx.aec.rtcConn.addIceCandidate(new RTCIceCandidate(e.candidate));

  vx.aec.rtcLoop.ontrack = e =>
    e.streams[0].getTracks().forEach(track => vx.aec.loopbackStream.addTrack(track));

  /* this stream would be the processed stream coming
     out of Web Audio API destination node */  
  inputStream.getTracks().forEach(function(track) {
    vx.aec.rtcConn.addTrack(track, inputStream);
  });

  vx.aec.rtcConn.createOffer(function(offer) {
    //console.log("createOffer ok");
    vx.aec.rtcConn.setLocalDescription(offer)
      .then(function() {
        //console.log("setLocalDescription ok");
        vx.aec.rtcLoop.setRemoteDescription(offer)
          .then(function() {
            //console.log("setRemoteDescription ok");
            vx.aec.rtcLoop.createAnswer()
              .then(function(answer) {
                //console.log("createAnswer ok");
                vx.aec.rtcLoop.setLocalDescription(answer)
                  .then(function() {
                    //console.log("setLocalDescription ok");
                    vx.aec.rtcConn.setRemoteDescription(answer)
                      .then(function() {
                        //console.log("setRemoteDescription ok");
                        vx.aec.an.srcObject = vx.aec.loopbackStream;
                        vx.aec.an.play();
                        console.log("===end:aec-rtc");
                      })
                      .catch(function(w) {
                        console.log("setRemoteDescription error:",e);
                      });
                  })
                  .catch(function(e) {
                    console.warn("setLocalDescription error:",e);
                  });
              })
              .catch(function(e) {
                console.warn("createAnswer error:",e);
              });
          })
          .catch(function(e) {
            console.warn("setRemoteDescription error",e);
          });
      })
      .catch(function(e) {
        console.warn("setLocalDescription error",e);
      });
  }, function(e) {
    console.warn("createOffer error:",e);
  }, offerOptions);
}

function do_mute() {
  window.NSV_update();
  if (vx.sw) {
    delete vx.avd;
    delete vx.dbg_audstm;
    if (vx.dbg_vidstm) {
      delete vx.dbg_vidstm.limit_ep;
    }
    delete vx.current_le;
    vx.sw.setFocus(-1);
    vx.sw.st_unmute = vx.st_unmute = false;
    window.vx_nav_callback("unmute",false);
    updateUIStates();
    aec_workaround_off();
    room_mute_slate();
  }
}

function do_unmute() {
  window.NSV_update();
  if (vx.sw && vx.aud_ids && (!vx.sw.st_unmute || !vx.st_unmute)) {
    vx.sw.setFocus(vx.aud_ids);
    vx.sw.st_unmute = vx.st_unmute = true;
    window.vx_nav_callback("unmute",true);
    updateUIStates();
    aec_workaround_on();
    /* So that rooms start unmuted by default in future */
    vx.about.unmute = true;
    room_unmute_slate();
  }
  let x = document.getElementById("__dbell");
  if (!x) {
    x = document.createElement("audio");
    x.id = "__dbell";
    x.src = vx_nav_callback("getasset","silence");
    x.setAttribute('playsinline', 'playsinline');
    //x.autoplay = true;
    //x.controls = true;
    let body = document.getElementsByTagName("body")[0];
    body.appendChild(x);
    x.muted = false;
    x.play();
  }
}

function do_mute_unmute(ms) {
  ms = ms || 500;
  do_mute();
  window.setTimeout(do_unmute, ms);
}

function updateRStats() {
  return; // FIXME
  if (!vx.room.is_mod || vx.room.adhoc || !vx.rstats) { return; }
  let h = "";
  if (vx.rstats.part) {
    h += '<span class="one_stat">'+vx.rstats.part+' joined</span>';
  }
  h += '<span class="one_stat">'+vx.rstats.view+' viewing</span>';
  if (vx.rstats.wait) {
    h += '<span class="one_stat">'+vx.rstats.wait+' waiting</span>';
  }
  if (h) {
    $(".panel_stats").html(h);
  }
}

function update_tfps() {
  let h = "";
  let t1 = window.vx_get_mydevice().fps_avg;
  if (t1) {
    let t2 = window.vx_get_mydevice().fps_min;
    let t3 = window.vx_get_mydevice().edrop || "-";
    h = '<span>'+t1.toFixed(1)+' '+t2.toFixed(1)+' '+t3+'</span>';
  }
  $(".panel_tfps").html(h);
}

function btn_with_help(cls,icon,msg1,msg2) {
  if (msg1) { msg1 = msg1.replace(/\s+/g,"\&nbsp;"); }
  if (msg2) { msg2 = msg2.replace(/\s+/g,"\&nbsp;"); }  
  let h = "";
  if (msg1) {
    h += '<div class="panel_btn '+cls+'" data-descr="'+msg1+'" help="off">';
  } else {
  }
  h +=  icon;
  h +=  '<div class="btn_help">';
  if (msg1) { h +=   '<div class="btn_help_msg" >'+msg1+"</div>"; }
  if (msg2) { h +=   '<div class="btn_help_msg">'+msg2+"</div>"; }
  h +=   '<button class="btn_help_dm">Close</button>'
  h +=   '<button class="btn_help_dmf">Close\&nbsp;Forever</button>'
  h +=  '</div>';
  h += '</div>';
  return h;
}

function btn_queue_help(cls) {
  let lsn = ""+cls;
  let val = getLocal(lsn, true);
  let el = $("."+cls);
  if (val) {
    if (val.forever) { return; }
    if (val.room == vx.room.main_room) { return; }
  }
  if (!el || !el[0]/*|| (el[0].style && el[0].style.display == "none")*/) {
    return;
  }
  vx.help_queue = vx.help_queue || [];
  if (!vx.help_queue.includes(cls)) {
    vx.help_queue.push(cls);
  }

  /* Enable first in queue */
  cls = vx.help_queue[0];
  $("."+cls).attr("help","on");
  $(".panel").attr("help","on");
}

/* Called when hiding element */
function btn_remove_help(cls) {
  $("."+cls).attr("help","off");

  vx.help_queue = vx.help_queue.filter(function(x) {
    if (x == cls) { return false; }
    return true;
  });
  if (!vx.help_queue.length) {
    /* All done. Help mode off. */
    $(".panel").attr("help","off");
    return;
  }
  /* Enable first in queue */
  cls = vx.help_queue[0];
  $("."+cls).attr("help","on");
  $(".panel").attr("help","on");  
}

/* Called from button press */
function btn_close_help(target, forever) {
  /* For safety, turn off referenced element */
  if (target && target.parentNode && target.parentNode.parentNode) {
    target.parentNode.parentNode.setAttribute("help","off");
  }

  let cls = vx.help_queue[0];
  let lsn = ""+cls;  
  if (forever) {
    setLocal(lsn, JSON.stringify({forever:true}));
  } else {
    setLocal(lsn, JSON.stringify({room:vx.room.main_room}));
  }
  btn_remove_help(cls);  
}

function createPanel() {
  $(".vxelrm").remove();
  let $my_wall = $("#room_wall");
  let h =
    '<div class="panel vxelrm" help="off" isopen="false">';

  if (vx.room.eph_cnt) {
    if (vx.room.is_mod || !dohide('breakout')) {
      if (vx.room.eph_mode == "open" || vx.room.is_mod) {
        h += '<div class="panel_sub">';
        h += '<div id="brkmain" class="panel_btn panel_btn_l panel2_btn_brk" data-descr="Go to the Main Room" picked="false">Main</div>';
        h += '<div id="brkgo" class="panel_btn panel_btn_l panel2_btn_brk panel2_btn_brki" data-descr="Go to the Selected Breakout Room" picked="false"><input id="brkinput" class="panel2_btn_brkinput" placeholder="1..'+vx.room.eph_cnt+'" value=""></input><div>GO</div></div>';
        if (vx.room.is_mod && window.vx_get_mydevice().multi_window) {
          h += '<div id="brkdivide" class="panel_btn panel_btn_l panel2_btn_brk" data-descr="Evenly Divide Participants into Groups">Shuffle</div>';
          h += '<div id="brkunite" class="panel_btn panel_btn_l panel2_btn_brk" data-descr="Bring All Participants Back to Main">Unite</div>';
          h += '<div id="brkrestore" class="panel_btn panel_btn_l panel2_btn_brk" data-descr="Return Participants to Existing Groups">Group</div>';
        }
        h += "</div>";
      } else {
        h += '<div id="nbrkmain" class="panel_btn panel_btn_l panel2_btn_brk" data-descr="You are in the Main Room" picked="true">Main</div>';
        h += '<div id="nbrkgo" class="panel_btn panel_btn_l panel2_btn_brk" data-descr="You are in a breakout room" picked="true"> Brk </div>';
      }
    }
  }

  if (vx.room && vx.room.url) {
    h += '<div class="panel_btn panel_btn_ctrl" id="ctrl_web" title="This Rooms Website">Web</div>';
  }

  if (!dohide('live') && !vx.disable_live) {
    h += '<div class="panel_sub">';
    h += '<div class="panel_btn panel_btn_l panel_btn_live" id="ctrl_live" data-descr="Watch Live">Live</div>';
    h += '<div class="panel_btn panel_btn_l panel_btn_live" id="ctrl_rewind" data-descr="Rewind 10 sec">'+(vx.rewind_delta?vx.rewind_delta:"-10")+'</div>';
    h += "</div>";
  }

  if (!dohide('auto')) {
    h += '<div class="panel_sub">';
    h += '<div class="panel_btn panel_btn_l panel_btn_abr" id="abr_auto" data-descr="Automatic Video+Audio">Auto</div>';
    h += '<div class="panel_btn panel_btn_l panel_btn_abr" id="abr_audio" data-descr="Force Audio Only">Audio</div>';
    h += "</div>";
  }

  h += '<div class="flex_fill"></div>';

  h += '<div class="panel_btn panel_btn_r panel_btn_enter_q" data-descr="Click to ask a Question">'+ svg_hand_down("")+'</div>';  
  h += '<div class="panel_btn panel_btn_r panel_btn_exit_q" data-descr="Hand Raised. Click to Lower.">'+ svg_hand_raised("")+'</div>';

  h += btn_with_help('panel_btn_join panel_btn_r',svg_enter_room(""),"Click to join this meeting.","You are currently just watching.");
  h += '<div class="panel_btn panel_btn_r panel_btn_leave" data-descr="Leave the Meeting">'+ svg_exit_room("")+'</div>';
  h += btn_with_help('panel_btn_chat panel_btn_r',svg_chat(),"Click for chat or polling.","Unread messages when flashing.");

  h += '<div class="flex_fill"></div>';
  
  h += '<div class="panel_btn panel_btn_r panel_btn_exitall_q" data-descr="Lower All Hands">'+ svg_allhand_down("") + "</div>";
  h +=
    '<div class="panel_btn panel_btn_r panel_btn_conf_0" data-descr="Anyone Can Talk">'+ conf_modes[0].fn() + '</div>'+
    '<div class="panel_btn panel_btn_r panel_btn_conf_1" data-descr="Host & Hand Raised Can Talk">'+ conf_modes[1].fn() + '</div>'+
    '<div class="panel_btn panel_btn_r panel_btn_conf_2" data-descr="Only Host Can Talk">'+ conf_modes[2].fn() + '</div>'+
    '<div class="panel_btn panel_btn_r panel_btn_mirror" data-descr="Mirror room to outside service">'+ svg_mirror("") + '</div>';

  if (!dohide('audience!') && (!dohide('audience') || vx.room.is_mod) &&
      !vx.rewind_delta) {
    h +=
      '<div class="panel_btn panel_btn_r panel_btn_mode_0" data-descr="Host View">'+ svg_layout_hv() +
      '</div>'+
      '<div class="panel_btn panel_btn_r panel_btn_mode_1 data-descr="Audience View">' + svg_layout_av() +
      '</div>';
  }

  h += '</div>';
  h += '<div id="bigmum" class="vxelrm material-icons">volume_off<div>';

  $my_wall.append(h);
  if (window.vx.about.app_kind != "ios" &&
      window.vx.about.app_kind != "android" &&
      !window.vx_get_mydevice().is_mobile) {
    $my_wall[0].addEventListener("mousemove", cssmotion, false);
  } else {
    $my_wall[0].addEventListener("touchstart", cssanytouch, false);
  }

  buildMiscPanel($my_wall);
  build1on1Modal($my_wall);

  $("#bigmum").hide().on("click", (ev) => {
    do_unmute();
  });

  $(".btn_help").on("click", (ev) => {
    ev.stopPropagation();
  });
  $(".btn_help_dm").on("click", (ev) => {
    //ev.stopPropagation();
    btn_close_help(ev.target,false);
  });
  $(".btn_help_dmf").on("click", (ev) => {
    //ev.stopPropagation();
    btn_close_help(ev.target,true);
  });

  if (vx.room.eph_cnt) {
    $("#brkinput").on("click", (ev) => {
      ev.stopPropagation();
    });
    $("#brkmain").on("click", (ev) => {
      $("#brkgo").attr("picked","false");
      //vx.room.eph_show = false;
      vx.room.is_joined = false;
      vx_to_brk_room(vx,0);
      updateUIStates();
      $(".panel_btn_join").hide();
      handle_room(null,{immediate:true});
    });
    $("#brkdivide").on("click", (ev) => {
      $("#brkdivide").attr("picked","true");
      setTimeout(function() {
        $("#brkdivide").attr("picked","false");
      }, 250);
      window.wss_send(window.vx, "divide_room", {});
    });
    $("#brkrestore").on("click", (ev) => {
      $("#brkrestore").attr("picked","true");
      setTimeout(function() {
        $("#brkrestore").attr("picked","false");
      }, 250);
      window.wss_send(window.vx, "divide_room", {opt:{restore:true}});
    });
    $("#brkunite").on("click", (ev) => {
      $("#brkunite").attr("picked","true");
      setTimeout(function() {
        $("#brkunite").attr("picked","false");
      }, 250);
      window.wss_send(window.vx, "unite_room", {});
    });
    $("#brkgo").on("click", (ev) => {
      let idx = 0|$("#brkinput")[0].value;
      let cur_room = window.vx_only_full_room_name(window.vx);
      let parts = cur_room.split(".");
      let cur_idx = parts[1] || 0;
      if (idx < 1 || idx > vx.room.eph_cnt || idx == cur_idx) {
        if (idx < 1) {
          window.vx_nav_callback("notify", {c:3, m:"First type in a Breakout Room Number."});
        } else if (idx > vx.room.eph_cnt) {
          window.vx_nav_callback("notify", {c:3, m:"Invalid Breakout Room Number."});
        }
        return;
      }
      $("#brkmain").attr("picked","false");
      //vx.room.eph_show = false;
      vx.room.is_joined = false;
      vx_to_brk_room(vx,idx);
      updateUIStates();
      $(".panel_btn_join").hide();
      handle_room(null,{immediate:true});
    });
  }

  $("#ctrl_web").on("click", () => {
    if (vx.room && vx.room.url) {
      window.vx.open_native_url(vx.room.url);
    }
  });
  $("#ctrl_live").on("click", () => {
    if (vx.rewind_delta != 0) {
      vx.rewind_delta = 0;
      createWall();
    } else {
      vx.live_click = vx.live_click || 0;
      vx.live_click++;
      if (vx.live_click == 1) {
        setTimeout(function() {
          if (vx.live_click > 1) {
            eraseCookie("vx_dsg");
          }
          vx.live_click = 0;
        },500);
      }
    }
  });
  $("#ctrl_rewind").on("click", () => {
    vx.live_click = 0;
    if (vx.rewind_delta > -25) {
      vx.rewind_delta -= 10;
      createWall();
    }
  });
  $("#abr_auto").on("click", () => {
    $(".panel_btn_abr").attr("picked","false");
    $("#abr_auto").attr("picked","true");
    vx.user_vmode = 0;
    delete vx.vmode;
  });
  $("#abr_max").on("click", () => {
    $(".panel_btn_abr").attr("picked","false");
    $("#abr_max").attr("picked","true");
    vx.user_vmode = 1;
  });
  $("#abr_med").on("click", () => {
    $(".panel_btn_abr").attr("picked","false");
    $("#abr_med").attr("picked","true");
    vx.user_vmode = 2;
  });
  $("#abr_low").on("click", () => {
    $(".panel_btn_abr").attr("picked","false");
    $("#abr_low").attr("picked","true");
    vx.user_vmode = 3;
  });
  $("#abr_audio").on("click", () => {
    $(".panel_btn_abr").attr("picked","false");
    $("#abr_audio").attr("picked","true");
    vx.user_vmode = 4;
  });

  if (!vx.rewind_delta) {
    $("#ctrl_live").attr("picked","true");
  } else {
    $("#ctrl_rewind").attr("picked","true");
  }
  switch (vx.vmode) {
  case 1: $("#abr_max").attr("picked","true"); break;
  case 2: $("#abr_med").attr("picked","true"); break;
  case 3: $("#abr_low").attr("picked","true"); break;
  case 4: $("#abr_audio").attr("picked","true"); break;
  default: $("#abr_auto").attr("picked","true"); break;
  }    
    
  $my_wall.find(".vxwport").append
    ('<div class="panel_stats vxelrm"></div>');
  //$my_wall.find(".vxwport").append
  //  ('<div class="panel_tfps vxelrm"></div>');
  updateRStats();

  $(".panel_btn_chat").on("click", () => {
    window.vx_nav_callback("open_chat", {acc:vx.room.acc, room:vx.room.name});
    $(".vxic-ch").attr("waiting","0");
  });

  $(".panel_btn_mirror").on("click", () => {
    window.vx_nav_callback("openMirror");
  });
  //$(".panel_btn_mic_on").on("click", () => {
  //  updateUserState(vx.room, "blk", 0, true);
  //});
  //$(".panel_btn_mic_off").on("click", () => {
  //  updateUserState(vx.room, "blk", 1, true);
  //});
  $(".panel_btn_conf_0").on("click", () => {
    if (vx.room.is_mod && vx.room.state) {
      vx.room.state.ac = conf_modes[1].ac;
      vx.room.state.prv = conf_modes[1].prv;
      update_room_state();
    }
  });
  $(".panel_btn_conf_1").on("click", () => {
    if (vx.room.is_mod && vx.room.state) {
      vx.room.state.ac = conf_modes[2].ac;
      vx.room.state.prv = conf_modes[2].prv;
      update_room_state();
    }
  });
  $(".panel_btn_conf_2").on("click", () => {
    if (vx.room.is_mod && vx.room.state) {
      vx.room.state.ac = conf_modes[0].ac;
      vx.room.state.prv = conf_modes[0].prv;
      update_room_state();
    }
  });
  $(".panel_btn_join").on("click", () => {
    if (vx.user.is_streaming && vx.room.can_join) {
      join_group();
    }
  });
  $(".panel_btn_leave").on("click", () => {
    leave_group();
  });
  $(".panel_btn_enter_q").on("click", () => {
    enter_line();
  });
  $(".panel_btn_exit_q").on("click", () => {
    exit_line();
  });
  $(".panel_btn_exitall_q").on("click", () => {
    exit_all_line();
  });
  $(".panel_btn_mode_0").on("click", () => {
    if (!vx.st_browsing) {
       window.show_notification("You are in audience view. Return to host view to follow the meeting.","warning",5);
    }
    vx.st_layout = 1;
    vx.st_browsing = true;
    vx.st_page_idx = 1;
    handle_room(null,{immediate:true});
    /* Update layout and refresh user-to-tile mapping */
    wallFastRefresh();
    updateWall();
  });
  $(".panel_btn_mode_1").on("click", () => {
    vx.st_layout = 0;
    vx.st_browsing = false;
    //window.vx_nav_callback("setAudMode", {enable:false});
    if (vx.st_page_idx > 1 || vx.aud_filt) {
      /* Refresh if anything other than unfiltered first page */
      vx.st_page_idx = 1;
      handle_room(null,{immediate:true});
    } else {
      vx.st_page_idx = 1;
    }
    //delete vx.aud_filt;
    /* Update layout and refresh user-to-tile mapping */
    wallFastRefresh();
    updateWall();
  });

  window.vx_nav_callback("setAudMode", {enable:true, cb: function(str) {
    if (str) {
      vx.aud_filt = {name: str};
    } else {
      delete vx.aud_filt;
    }
    vx.st_page_idx = 1;
    handle_room(null,{immediate:true});
  }});

  /* Recreated. Reapply to new one. */
  $(".panel").attr("isopen","true");
  cssmotion();

  $my_wall.append
  ('<div id="show_debug" class="vxelrm debug_cont">'+
   ' <div class="header_status"> adj <span id="vadj">0</span> add <span id="sync_a">0</span> drop <span id="sync_d">0</span> avd <span id="sync_avd">0</span> p <span id="sync_p">0</span> vmode: <span id="v_mode"></span> <span id="sync_ep"> </span> </div>'+
   ' <div class=""> <canvas id="debug_chart" height:"150px"> </canvas> </div>'+
   '</div>');
  if (window.vx_get_mydevice().enable_debug_graph) {
    let opt = {
      type: 'line',
      data: { labels: [],
              datasets: [],
            },
      options: {
        title: { display: false,
                 position: "left",
                 text: "",
               },
        animation: { duration: 1,
                   },
        legend: {
            display: true,
            labels: {
               filter: function(item, chart) {
                  return item.datasetIndex !== 5;
               }
            }
        },
        tooltips: {
          enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: "time",
            display: false,
            scaleLabel: {
              display: true,
              labelString: 'Time'
            }
          }],
          yAxes: [{
            type: "linear",
            display: true,
            position: "right",
            id: "y-axis-1",
            ticks: {
              min:0,
              stepSize:500
            },
            gridLines: {
              drawOnChartArea:true,
              color:"#6F6F6F"
            }
          },{
            type: "linear",
            display: false,
            position: "left",
            id: "y-axis-2",
            ticks: {
              beginAtZero:true,
              min:0,
              max:50,
            }
          }]
        }
      }
    };
    opt.data.datasets.push({
      label:"buf",
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: (!vx.vmode_dsg?'rgba(250,50,50,1)':'rgba(250,25,220,1)'),
      borderWidth: 2,
      pointRadius:(!vx.vmode_dsg?0.5:1.0),
      yAxisID: "y-axis-1",
      data:[]});
    opt.data.datasets.push({
      label:"ale",
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: 'rgba(50,50,250,1)',
      borderWidth: 2,
      pointRadius: 0.5,
      yAxisID: "y-axis-1",
      data:[]});
    opt.data.datasets.push({
      label:"drop",
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: 'rgba(180,180,0,1)',
      borderWidth: 1.5,
      pointRadius: 0.5,
      yAxisID: "y-axis-2",
      data:[]});
    opt.data.datasets.push({
      label:"avd(aud)", //audio ahead
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: 'rgba(75,220,75,1)',
      borderWidth: 1.5,
      pointRadius: 0.5,
      yAxisID: "y-axis-1",
      data:[]});
    opt.data.datasets.push({
      label:"vle",
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: 'rgba(150,50,50,1)',
      borderWidth: 2,
      pointRadius: 0.5,
      //showLine: false,
      yAxisID: "y-axis-1",
      data:[]});
    opt.data.datasets.push({
      label:"", // notused
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: 'rgba(200,100,0,1)',
      borderWidth: 2.0,
      pointRadius: 3.0,
      showLine: false,
      yAxisID: "y-axis-1",
      data:[]});
    opt.data.datasets.push({
      label:"avd(vid)", // video ahead
      backgroundColor: 'rgba(0,0,0,0)',
      borderColor: 'rgba(5,75,5,1)',
      borderWidth: 2.0,
      pointRadius: 3.0,
      yAxisID: "y-axis-1",
      data:[]});
    let jq = $("#debug_chart")[0];
    let ctx = jq.getContext('2d');
    vx.debug_cnt = 0;
    vx.debug_g = new Chart(ctx, opt);
    if (!vx.debug_tid) {
      vx.debug_tid = setInterval(function() {
        //update_tfps();
        if (vx.debug_g.data.labels.length >= 150) {
          vx.debug_g.data.labels.shift();
          vx.debug_g.data.datasets[0].data.shift();
          vx.debug_g.data.datasets[1].data.shift();
          vx.debug_g.data.datasets[2].data.shift();
          vx.debug_g.data.datasets[3].data.shift();
          vx.debug_g.data.datasets[4].data.shift();          
          vx.debug_g.data.datasets[5].data.shift();
          vx.debug_g.data.datasets[6].data.shift();
        }
        vx.debug_cnt++;
        vx.debug_g.data.labels.push(vx.debug_cnt);
        vx.debug_g.data.datasets[0].data.push(vx.current_vbuf);
        vx.debug_g.data.datasets[1].data.push(vx.current_le);
        vx.current_le_clear = true;
        let dp = -500; /* Only show in graph when non-zero */
        if (vx.current_drop > 0) { dp = vx.current_drop; }
        vx.debug_g.data.datasets[2].data.push(dp);
        //let avd = Math.abs(vx.avd);
        if (vx.avd > 50) {
          vx.debug_g.data.datasets[3].data.push(-500);
          vx.debug_g.data.datasets[6].data.push(vx.avd);
        } else {
          vx.debug_g.data.datasets[3].data.push(-1*vx.avd);
          vx.debug_g.data.datasets[6].data.push(-500);
        }
        vx.debug_g.data.datasets[4].data.push(vx.current_vle || 0);
        vx.current_vle_clear = true;
        vx.debug_g.data.datasets[5].data.push(-500);
        /* Don't clear current_vbuf directly. Wait for next sample */
        vx.current_vbuf_clear = true;
        vx.current_abuf_clear = true;
        /* Don't clear current_le directly. Wait for next sample */
        vx.current_le_clear = true;
        vx.current_drop = 0;
        if (vx.show_debug_panel/* && ((vx.debug_cnt & 0x1) == 1)*/) {
          vx.debug_g.update();
          if (vx.current_vbuf) {
            $("#sync_p").empty().html(vx.current_vbuf+","+vx.current_abuf);
          }
          $("#vadj").empty().html(vx.adj_cnt);
          $("#v_mode").html(" le:"+vx.current_le+" "+(Date.now()/1000).toFixed(0));
          $("#sync_avd").empty().html(vx.avd?vx.avd:0);
        }
        if (false) {
          let now = Date.now();
          console.log((now - vx._prev_tm),"avd "+vx.avd+
                      " v/abuf "+vx.current_vbuf+","+vx.current_abuf+
                      " v/ale "+vx.current_vle+","+vx.current_le,
                      document.hidden);
          vx._prev_tm = now;
        }
      }, 500);
    }
  }
  if (!vx.show_debug_panel) {
    $("#show_debug").hide();
  }
  window.vx.debug_toggle = function() {
    if (!vx.show_debug_panel) {
      vx.show_debug_panel = true;
      $("#show_debug").show();
    } else {
      vx.show_debug_panel = false;
      $("#show_debug").hide();
    }
  };

  vx.volume = vx.volume || 1;
  if (vx.sw) { vx.sw.setVolume(vx.volume); }
  
  $my_wall.append
  ('<div class="pg_panel vxelrm">'+
   '<div class="flex_fill"></div>'+
   '<div class="pg_panel_btn pg_panel_first">&lt;&lt;</div>'+
   '<div class="pg_panel_btn pg_panel_prev">&lt;</div>'+
   '<div class="pg_panel_label pg_panel_curr"></div>'+
   '<div class="pg_panel_btn pg_panel_next">&gt;</div>'+
   '<div class="flex_fill"></div>'+
   '</div>');
  $(".pg_panel_first").on("click", () => {
    if (vx.st_page_idx > 1) {
      vx.st_page_idx = 1;
      handle_room(null,{immediate:true});
    }
  });
  $(".pg_panel_prev").on("click", () => {
    if (vx.st_page_idx > 1) {
      vx.st_page_idx --;
      handle_room(null,{immediate:true});
    }
  });
  $(".pg_panel_next").on("click", () => {
    if (true) {
      vx.st_page_idx ++;
      handle_room(null,{immediate:true});
    }
  });
  updateUIStates();
}

function getSubG(url) {
  let m = url.match(/sub\=\d+\.(\d+)/);
  if (!m) return 0;
  return m[1];
}

function room_wh_changed(sw,w,h) {
  if (!sw || !w || !h) { return false; }
  if (sw._width && sw._height) {
    let r_w = sw._width/w;
    let r_h = sw._height/h;
    if (r_w > 0.90 && r_w < 1.1 &&
        r_h > 0.90 && r_h < 1.1) {
      return false;
    }
  }
  sw._width = w;
  sw._height = h;
  return true;
}

function createWall() {
    if (vx && vx.debug) { console.log("update: room createWall"); }
    $("#room_wall").html("");
    window.stop_localloopback();
    if (vx.sw) {
      vx.sw.close();
      delete vx.sw;
    }
    delete vx.vmode_better;
    delete vx.vmode;
    delete vx.current_vbuf;
    delete vx.current_le;
    delete vx.avd;
    delete vx.dbg_audstm;
    delete vx.dbg_vidstm;  
  
    var opt = {
      //sdkconfig: {
      //  overrideVSTemplate:dnssub, groupPageSize:vx.page_size, loggerSendTo:""
      //},
      //sig: "a", /* Tricks it into using external sign-in */
      el: "room_wall",
      ww:1024, wh:576,
      //playlist: "qna_empty",
      labelTimeout:0,
      noSinglePageSwipe:true,
      setFocusOnTap: false,
      onTap: function(w,c,t,idx) {
        setLocal("vx_chattgt_"+vx.room.name,
                 JSON.stringify({uid: c.userid, dname: c.title}));
        if (idx == 0) {
          vx.debugTapIdx = 1;
        }
        else if (vx.debugTapIdx == idx) {
          vx.debugTapIdx ++;
          if (vx.debugTapIdx == 4) {
            $(".debug").toggle();
          }
        }
        else {
          vx.debugTapIdx = -1;
        }
      },
      onAPIFail: function(wall, state, error) {
        console.log("state: "+JSON.stringify(state));
        console.log("error: "+JSON.stringify(error));
        if (!error) {
        } else if (error == "Unauthorized") {
          window.vx_signout_callback();
        }
      },
      onPlayerFail: function(x) {
        console.warn("sdk player failed to start");
        window.setTimeout(startFresh,500);
      },
      clientLayout:true,
      onPageChange: onPageChange,
      onCreateCell: onCreateCell,
      preLayoutContents: prelayout,
      resolveSeekTime: function(seekTime, delta, player) {
        if (!vx.rewind_delta) {
          return {a: Date.now()+delta};
        } else {
          return {a: Date.now()+delta+(1000*vx.rewind_delta)};
       }
      },
      useVxmsp:1,
      vad: function(aindex, vad) {
        let vindex = vx.ai2vi[aindex];
        //console.log("vad:"+aindex+" "+vindex+" "+vad);
        if (vindex !== undefined) {
          if (vad) {
            $(".vxwctag_"+vindex).css("border","solid 2px rgba(255,0,0,1)");
          } else {
            $(".vxwctag_"+vindex).css("border","solid 2px rgba(255,0,0,0)");
          }
        }
      },
      sks:[{attr:"role",key:"role"},{attr:"order",key:"order"},{attr:"self",key:"isSelf"},{attr:"aud",key:"aud"}],
      scalabilityClasses:{vxwclb:[],vxwclbtxt:[]},
      onResize: function(w, width, height, x, y) {
        if (vx_is_portrait()) {
          //$(".panel").css({left:0,height:"60px",top:"auto"});
          //$(".panel2").css({height:"50px",top:"auto"});
          if (!vx.sw_is_portrait) {
            setTimeout(function() { createWall(); },10);
            //setTimeout(function() { wallFastRefresh(); updateWall(); },10);
          }
        } else {
          //$(".panel").css({right:(x-3)+"px",height:height+"px",top:"0"});
          //$(".panel2").css({left:(x-3)+"px",height:height+"px",top:"0"});
          if (vx.sw_is_portrait) {
            setTimeout(function() { createWall(); },10);
            //setTimeout(function() { wallFastRefresh(); updateWall(); },10);
          }
        }
        $(".pg_panel").css({left:x+"px",width:width+"px",top:(height+3)+"px"});
        /* second arg: 0 == show thumbnails, 1 == hide */
        if (vx.sw && room_wh_changed(vx.sw,width,height)) {
          vx.sw.redraw(0, 1);
        }
        kvm_btn_state();
      }
    };

    delete vx.stm_id_seq;
    delete vx.aud_stm_id_seq;
    delete vx.vsync_id_seq;

    wallFastRefresh();
    VuemixSDK.Wall.cellPrototypes["vidSM"] =
      {stateKeys:(opt.sks || ["isLive", "recState"])};
    VuemixSDK.Wall.cellPrototypes["vidLG"] =
      {stateKeys:(opt.sks || ["isLive", "recState"])};
    VuemixSDK.Wall.cellPrototypes["vidPT"] =
      {stateKeys:(opt.sks || ["isLive", "recState"])};

    VuemixSDK.useWPlay = vx.useWPlay;
    VuemixSDK.alwaysMulti = true;

    let cfg = {serverAddress: vx.subd + ".vuemix.com",
               groupPageSize: vx.page_size,
               //needTouch: i10 ? false : null,
               protocolOverride: "follow",
               overrideVSTemplate: dnssub,
               loggerSendTo: ""};
    VuemixSDK.config(cfg);
    let rs = {scaleMax: 9.9, scaleMin: 0.1, scaleStep: 0.01,
              xPadding: 6, yPadding: 4,
              xAlignment: "center", yAlignment: "top", ignore: "none" };
    if (vx.sw_is_portrait) {
      rs.xPadding = 0;
      rs.yPadding = 50;
    }
    if (!vx.about.is_app && vx.about.is_chrome) {
      aec_workaroundinit();
    }

    vx.sw = new VuemixSDK.SimpleWall
      (opt.el, opt.ww, opt.wh, null, rs,
       false, null, null,
       opt.onTap, // tap
       opt.onDoubleTap, // double-tap
       opt.onPageChange, // page-change
       null, null, opt);

    /* Make sure server selection has completed */
    vuemix_vs_selected(function() {
      let ly = VuemixLY.base;
      ly.layout = VuemixLY.ly["1x1_256"];
      vx.sw.open(function() {
        let x = new VuemixSDK.DataObject.GroupData(ly, "", 0);
        return x;
      });
      doRedraw();
    });

  delete vx.dbg_vidstm;
  delete vx.dbg_audstm;
  VuemixSDK.setListener("dash_created", function(player) {
    if (vx.useWPlay) {
      player.rewind(1000*vx.rewind_delta);
    }
  });
  VuemixSDK.setListener("dash_live_timing", function(tm, stm, meta) {
    if (vx.useWPlay) {
      if (document.hidden || vx.user_vmode == 4) {
        if (!vx.hidden_at) {
          /* Hiding */
          vx.dbg_vidstm &&
            vx.dbg_vidstm.parent.cmd("video_profile=16&video=&ptcnt=0");
          vx.cs_all.forEach(function(ct) {ct.aoall = true;});
          setTimeout(doRedraw, 1);
        }
        vx.hidden_at = Date.now();
      } else if (vx.hidden_at) {
        /* Unhiding */
        if (vx && vx.debug) { console.log("unhide cmd");  }
        vx.hidden_at = 0;
        vx.cs_all.forEach(function(ct) {ct.aoall = false;});
        setTimeout(doRedraw, 500);
        if (vx.dbg_vidstm) {
          vx.dbg_vidstm.parent.cmd(`video_profile=${vx.wall_info_cur.vp}&video=${vx.stm_id_seq}&ptcnt=${vx.pt_ids.length}`);
          if (vx.dbg_vidstm.buf_ready > 0.6) {
            if (vx && vx.debug) {
              console.log("unhide adj",
                          vx.dbg_vidstm.buf_ready,
                          (vx.dbg_vidstm.buf_ready - 0.6));
            }
            vx.dbg_vidstm.player.el.currentTime +=
              (vx.dbg_vidstm.buf_ready - 0.6);
          }
        }
      }

      if (stm.kind == "video") {
        if (!vx.dbg_vidstm ||
            /* Underlying stream changed. Likely due to missing close() on
             *  removal of earlier wall. */
            (vx.dbg_vidstm && vx.dbg_vidstm != stm)) {
          if (vx && vx.debug) { console.log("updateWall: video start"); }
          setTimeout(updateWall, 1);
        }
        vx.dbg_vidstm = stm;
        if (meta) {
          if (vx.current_vle_clear || meta.lat > vx.current_vle) {
            vx.current_vle = meta.lat;
            delete vx.current_vle_clear;
          }
          if (meta.et && stm.player.el.currentTime) {
            let vd = Math.trunc(1000*(meta.et -
                                      stm.player.el.currentTime));
            if (vx.current_vbuf_clear || vd < vx.current_vbuf) {
              //console.log("update vbuf:",vd,meta.et,stm.player.el.currentTime,meta.vp);
              vx.current_vbuf = vd;
            }
            window.vx_get_mydevice().set_audio_at(stm.player.el.currentTime);
          }
        }
      }
      if (stm.kind == "audio") {
        if (!vx.dbg_audstm) {
          if (vx && vx.debug) { console.log("audio update first"); }
          let cmd = "audio="+vx.aud_ids.join(",");
          if (vx.user.dname) { cmd += "&dname="+vx.user.dname.replace(/\s+/,""); }
          stm.parent.cmd(cmd);
        }
        vx.dbg_audstm = stm;
        stm.parent.av_sync_limits.addOffset = -100000;
        stm.parent.av_sync_limits.dropOffset = -1.0;
        if (vx.hidden_at) {
          stm.parent.av_sync_limits.dropBufMin = 0.35;
        } else if (vx.user_vmode != 4) {
          stm.parent.av_sync_limits.dropBufMin = 0.100;
        } else {
          /* Filler video can race ahead; Give audio slack */
          stm.parent.av_sync_limits.dropBufMin = 0.35;
        }
        if (meta) {
          if (vx.current_le_clear || meta.lat > vx.current_le) {
            vx.current_le = meta.lat;
            delete vx.current_le_clear;
          }
          let ad = Math.trunc(1000*(meta.et - stm.player.el.currentTime));
          if (vx.current_abuf_clear || ad < vx.current_abuf) {
            vx.current_abuf = ad;
          }
        }
        if (stm.sbuf[0].avd != -9) {
          /* avd: positive == video ahead; negative == audio ahead */
          vx.avd = Math.trunc(1000*stm.sbuf[0].avd);
          //if (vx.avd > 1000 && vx.current_abuf > 1000 &&
          //    window.vx_get_mydevice().do_jackunplug) {
          //  /* audio playback behind but plenty buffered.
          //     physical jack likely unplugged. */
          //  do_mute_unmute(750);
          //}
        }
      }
    } /* useWPlay */

    if (vx.st_page_idx > 1 || vx.aud_filt ||
        (vx.wall_info_nxt && vx.wall_info_nxt.limit > 20)) {
      let now = Date.now();
      if (vx.list_room_lastq < (now - 10000)) {
        handle_room(null,{immediate:true});
      }
    }

    if (!tm) { return; }
    for (let c=0; c<tm.cells.length; c++) {
      let tc = tm.cells[c];
      if (tm.cells && tc && tc.hasOwnProperty("m2av_pad")) {
        let val = (tc.m2av_pad * vx.one_frm_sec * 1000);
        if (val > 2000) {
          $(".cell"+c).attr("delay","vhigh");
        } else if (val > 1000) {
          $(".cell"+c).attr("delay","high");
        } else if (val > 400) {
          $(".cell"+c).attr("delay","med");
        } else {
          $(".cell"+c).attr("delay","low");
        }
      }
    }
  });
}

  /* GRAPH ============================= */
  
  function start_graphing() {
    $("#stopg").show();
    $("#startg").hide();
    VuemixSDK.setListener("dash_live_timing", function(tm) {
      helper_graph_stat(vx, tm, 4);
    });
  }
  
  function stop_graphing() {
    $("#stopg").hide();
    $("#startg").show();
    VuemixSDK.setListener("dash_live_timing", null);
    vx.chart.update();
  }
  
/* ============================= */
   
  function show_header_flash(msg,timeout) {
     timeout = timeout || 3000;
     $("#header_flash").html(msg);
     $("#header_flash").attr("enabled","1");
     setTimeout(function() {
        $("#header_flash").attr("enabled","0");
     },timeout);
  }
  
VuemixSDK.setListener("webaudio_sync", function(add, drop_arr) {
  let drop = -1;
  drop_arr.forEach(function(d) {
    if (d > drop) { drop = d; }    
  });
  $("#vadj").empty().html(vx.adj_cnt);  
  $("#sync_a").empty().html(add);
  $("#sync_d").empty().html(drop);
  vx.current_drop += drop;
  if (add > 0 || drop > 0) {
    if (vx && vx.debug) { console.log("add "+add+" drop "+drop); }
  }
});

  function getStats() {
    let s = {acnt:0};
    if (vx.room.is_joined) {
      s.acnt++;
    }
    vx.cs_all && vx.cs_all.forEach(function(ct) {
      if (ct.pres || ct.mod || ct.isSelf) { return; }
      s.acnt ++;
    });
    return s;
  }

  if (vx.debugv != null) {
    $(".debugv, .debug").show();
  }
  else if (vx.debug != null) {
    $(".debug").show();
  }
  
  if (vx.dlevel) {
    VuemixSDK.dlevel = (+vx.dlevel);
    VuemixDashJS.dlevel = (+vx.dlevel);
  }

  return {startFresh: startFresh,
          cleanup: cleanup,
          updateUserState: updateUserState,
          getStats: getStats,
          dohide: dohide};
}
  
  
